// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2796%27%20height%3D%2796%27%20viewBox%3D%270%200%2096%2096%27%3E%3Cg%20fill%3D%27none%27%20stroke%3D%27%23ffffff%27%20stroke-opacity%3D%27.052%27%20stroke-width%3D%271.05%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%3E%3Cpath%20d%3D%27M10%2015h12l5%205v16H10z%27%2F%3E%3Cpath%20d%3D%27M22%2015v6h6%27%2F%3E%3Cpath%20d%3D%27M14%2027h10M14%2032h7%27%2F%3E%3Cpath%20d%3D%27M56%209l4%209%2010%201-7%207%202%2010-9-5-9%205%202-10-7-7%2010-1z%27%2F%3E%3Ccircle%20cx%3D%2780%27%20cy%3D%2726%27%20r%3D%278%27%2F%3E%3Cpath%20d%3D%27M76%2026h8M80%2022v8%27%2F%3E%3Cpath%20d%3D%27M25%2061c4-8%2014-5%2012%204-1%207-11%2012-12%2019-1-7-11-12-12-19-2-9%208-12%2012-4z%27%2F%3E%3Cpath%20d%3D%27M67%2062l10%205%2010-5-10-5zM67%2062v12l10%205%2010-5V62%27%2F%3E%3Cpath%20d%3D%27M41%2084c7-8%2016-8%2023%200M47%2077c3-4%209-4%2012%200%27%2F%3E%3Cpath%20d%3D%27M7%2082h12M13%2076v12%27%2F%3E%3Ccircle%20cx%3D%2785%27%20cy%3D%2782%27%20r%3D%275%27%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2796%27%20height%3D%2796%27%20viewBox%3D%270%200%2096%2096%27%3E%3Cg%20fill%3D%27none%27%20stroke%3D%27%236f8493%27%20stroke-opacity%3D%27.12%27%20stroke-width%3D%271.05%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%3E%3Cpath%20d%3D%27M10%2015h12l5%205v16H10z%27%2F%3E%3Cpath%20d%3D%27M22%2015v6h6%27%2F%3E%3Cpath%20d%3D%27M14%2027h10M14%2032h7%27%2F%3E%3Cpath%20d%3D%27M56%209l4%209%2010%201-7%207%202%2010-9-5-9%205%202-10-7-7%2010-1z%27%2F%3E%3Ccircle%20cx%3D%2780%27%20cy%3D%2726%27%20r%3D%278%27%2F%3E%3Cpath%20d%3D%27M76%2026h8M80%2022v8%27%2F%3E%3Cpath%20d%3D%27M25%2061c4-8%2014-5%2012%204-1%207-11%2012-12%2019-1-7-11-12-12-19-2-9%208-12%2012-4z%27%2F%3E%3Cpath%20d%3D%27M67%2062l10%205%2010-5-10-5zM67%2062v12l10%205%2010-5V62%27%2F%3E%3Cpath%20d%3D%27M41%2084c7-8%2016-8%2023%200M47%2077c3-4%209-4%2012%200%27%2F%3E%3Cpath%20d%3D%27M7%2082h12M13%2076v12%27%2F%3E%3Ccircle%20cx%3D%2785%27%20cy%3D%2782%27%20r%3D%275%27%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chats-page {
  min-height: 100vh;
  background: radial-gradient(circle at 16% 18%, rgba(231, 47, 68, 0.12), transparent 38%), radial-gradient(circle at 88% 8%, rgba(35, 33, 55, 0.12), transparent 34%), linear-gradient(160deg, #f3f5f8 0%, #f7fafc 42%, #eef2f8 100%);
  color: #1d2330;
  font-family: "Manrope", "Segoe UI", sans-serif;
}

.chats-shell {
  display: grid;
  grid-template-columns: 340px minmax(0, 1fr);
  gap: 14px;
  padding: 0 14px 20px;
  max-width: 1220px;
  margin: 0 auto;
}

.chats-sidebar,
.chats-main {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  box-shadow: 0 18px 40px rgba(23, 30, 44, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.8);
}

.chats-sidebar {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: calc(100vh - 95px);
}

.chats-brand {
  font-size: 13px;
  letter-spacing: 0.22em;
  font-weight: 800;
  color: #e72f44;
}

.chats-create {
  display: grid;
  gap: 8px;
  padding: 10px;
  border-radius: 16px;
  background: linear-gradient(145deg, rgba(231, 47, 68, 0.09), rgba(35, 33, 55, 0.06));
}

.chats-input,
.composer-input {
  width: 100%;
  border: 1px solid rgba(35, 33, 55, 0.15);
  background: #fff;
  color: #1f2530;
  border-radius: 14px;
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.chats-input:focus,
.composer-input:focus {
  border-color: rgba(231, 47, 68, 0.65);
  box-shadow: 0 0 0 3px rgba(231, 47, 68, 0.12);
}

.chats-search {
  background: rgba(255, 255, 255, 0.92);
}

.chats-primary,
.chats-secondary,
.messages-loadmore {
  border: 0;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.chats-primary:hover,
.chats-secondary:hover,
.messages-loadmore:hover {
  transform: translateY(-1px);
}

.chats-primary:disabled,
.chats-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.chats-primary {
  background: linear-gradient(135deg, #e72f44, #ff5f45);
  color: #fff;
  padding: 10px 12px;
}

.chats-secondary,
.messages-loadmore {
  background: #232137;
  color: #fff;
  padding: 10px 12px;
}

.chats-list {
  overflow: auto;
  padding-right: 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chat-row {
  text-align: left;
  border: 1px solid rgba(24, 29, 42, 0.08);
  background: #fff;
  border-radius: 16px;
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.15s ease;
  display: grid;
  gap: 3px;
}

.chat-row-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.chat-row.active {
  border-color: rgba(231, 47, 68, 0.58);
  background: linear-gradient(155deg, rgb(255, 247, 248), rgb(255, 255, 255));
}

.chat-row-title {
  font-weight: 700;
  color: #1f2534;
  font-size: 14px;
}

.chat-row-preview {
  color: #6f7786;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-row-time {
  color: #939cb0;
  font-size: 11px;
}

.chat-unread-badge {
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  padding: 0 6px;
  background: #e72f44;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.chats-main {
  min-height: calc(100vh - 95px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
}

.chats-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid rgba(25, 32, 45, 0.08);
}

.chats-header-name {
  font-size: 18px;
  font-weight: 800;
}

.chats-header-meta {
  font-size: 12px;
  color: #7a8396;
}

.chats-invite {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chats-invite .chats-input {
  min-width: 220px;
}

.messages-panel {
  overflow: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.messages-loadmore-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

:where(.chats-page) .message-bubble {
  max-width: 72%;
  border-radius: 18px;
  padding: 10px 12px 8px;
  animation: bubble-in 0.22s ease;
}

:where(.chats-page) .message-bubble.mine {
  align-self: flex-end;
  background: linear-gradient(145deg, #e72f44, #ff5e47);
  color: #fff;
  border-bottom-right-radius: 6px;
}

:where(.chats-page) .message-bubble.other {
  align-self: flex-start;
  background: #fff;
  border: 1px solid rgba(30, 36, 51, 0.1);
  color: #1d2432;
  border-bottom-left-radius: 6px;
}

:where(.chats-page) .message-text {
  font-size: 14px;
  line-height: 1.42;
  white-space: pre-wrap;
}

:where(.chats-page) .message-meta {
  margin-top: 5px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  font-size: 11px;
  opacity: 0.8;
}

.read-indicator {
  font-weight: 700;
}

.composer {
  border-top: 1px solid rgba(25, 32, 45, 0.08);
  padding: 12px 16px 14px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
}

.composer-send {
  min-width: 122px;
}

.chats-empty {
  padding: 20px;
  border-radius: 14px;
  text-align: center;
  color: #667082;
}

.chats-error {
  color: #d12f3d;
}

@keyframes bubble-in {
  from {
    transform: translateY(6px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@media (max-width: 990px) {
  .chats-shell {
    grid-template-columns: 1fr;
  }
  .chats-sidebar {
    max-height: none;
  }
  .chats-main {
    min-height: 74vh;
  }
  .chats-invite {
    width: 100%;
  }
  .chats-invite .chats-input {
    min-width: 0;
  }
}
@media (max-width: 680px) {
  .chats-shell {
    padding: 0 6px 16px;
  }
  .chats-header {
    flex-direction: column;
    align-items: stretch;
  }
  .chats-invite {
    display: grid;
    grid-template-columns: 1fr auto;
  }
  :where(.chats-page) .message-bubble {
    max-width: 88%;
  }
  .composer {
    grid-template-columns: 1fr;
  }
  .composer-send {
    width: 100%;
  }
}
/* Telegram-like regular chat overrides */
.chats-page {
  --tg-bg: #e7eef5;
  --tg-sidebar: #fff;
  --tg-panel: #fff;
  --tg-header: rgba(255, 255, 255, 0.96);
  --tg-border: #dfe7ef;
  --tg-text: #17212b;
  --tg-muted: #6f8396;
  --tg-accent: #2aabee;
  --tg-bubble-other: #fff;
  --tg-bubble-mine: #effdde;
  min-height: 100dvh;
  background: var(--tg-bg);
  color: var(--tg-text);
}

body[data-theme=dark] .chats-page {
  --tg-bg: #0e1621;
  --tg-sidebar: #17212b;
  --tg-panel: #17212b;
  --tg-header: rgba(23, 33, 43, 0.96);
  --tg-border: #263542;
  --tg-text: #eef6fc;
  --tg-muted: #8aa0b3;
  --tg-bubble-other: #182533;
  --tg-bubble-mine: #2b5278;
}

.chats-shell {
  grid-template-columns: minmax(300px, 368px) minmax(0, 1fr);
  gap: 0;
  max-width: none;
  min-height: calc(100dvh - 68px);
  padding: 0;
}

.chats-sidebar,
.chats-main {
  border-radius: 0;
  border: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.chats-sidebar {
  background: var(--tg-sidebar);
  border-right: 1px solid var(--tg-border);
  max-height: none;
}

.chats-main {
  background: linear-gradient(rgba(231, 238, 245, 0.84), rgba(231, 238, 245, 0.84)), repeating-linear-gradient(45deg, rgba(42, 171, 238, 0.04) 0 1px, transparent 1px 18px);
}

body[data-theme=dark] .chats-main {
  background: linear-gradient(rgba(14, 22, 33, 0.9), rgba(14, 22, 33, 0.9)), repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.025) 0 1px, transparent 1px 18px);
}

.chats-brand {
  display: none;
}

.chats-create {
  margin: 10px;
  background: var(--tg-panel);
  border: 1px solid var(--tg-border);
}

.chats-filter-row {
  display: flex;
  gap: 8px;
  overflow: auto;
  padding: 0 14px 10px;
}

.chat-filter-chip,
.chats-icon {
  border: 1px solid var(--tg-border);
  border-radius: 999px;
  background: transparent;
  color: var(--tg-muted);
  padding: 8px 10px;
}

.chat-filter-chip.active {
  color: var(--tg-accent);
  background: rgba(42, 171, 238, 0.12);
}

.chat-row {
  position: relative;
  border-radius: 0;
  border: 0;
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-height: 72px;
}

.chat-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-accent);
  color: #fff;
  font-weight: 800;
}

.chat-avatar.large {
  width: 48px;
  height: 48px;
}

.chat-avatar.small {
  width: 34px;
  height: 34px;
  font-size: 13px;
}

.chat-row-copy {
  min-width: 0;
}

.chat-row-pin {
  color: var(--tg-accent);
  margin-right: 4px;
}

.chat-row-pin.important {
  color: #e8a800;
}

.chats-header {
  background: var(--tg-header);
  border-bottom: 1px solid var(--tg-border);
}

.chats-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.pinned-message-bar {
  border: 0;
  border-bottom: 1px solid var(--tg-border);
  background: var(--tg-header);
  color: var(--tg-text);
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  padding: 8px 18px;
  text-align: left;
}

.pinned-message-bar em {
  color: var(--tg-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:where(.chats-page) .message-bubble.other {
  background: var(--tg-bubble-other);
}

:where(.chats-page) .message-bubble.mine {
  background: var(--tg-bubble-mine);
  color: var(--tg-text);
}

.attachment-stack {
  display: grid;
  gap: 6px;
  margin-bottom: 6px;
}

.attachment-card {
  border-radius: 9px;
  overflow: hidden;
}

.attachment-card.media img,
.attachment-card.media {
  max-width: 260px;
  max-height: 260px;
}

.message-reply-preview,
.message-forwarded,
.link-preview-card {
  border-left: 3px solid var(--tg-accent);
  background: rgba(42, 171, 238, 0.08);
  border-radius: 7px;
  padding: 6px 8px;
  margin-bottom: 6px;
}

.message-reply-preview {
  width: 100%;
  text-align: left;
}

:where(.chats-page) .message-text {
  overflow-wrap: anywhere;
}

:where(.chats-page) .message-text.deleted {
  color: var(--tg-muted);
  font-style: italic;
}

.link-preview-card {
  display: block;
  color: var(--tg-accent);
}

.message-reactions,
.reaction-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.message-reaction,
.reaction-row button {
  border: 0;
  border-radius: 999px;
  background: rgba(42, 171, 238, 0.14);
  padding: 4px 8px;
}

.message-more {
  border: 0;
  background: transparent;
  color: var(--tg-muted);
}

.composer {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  align-items: end;
  gap: 8px;
  background: transparent;
}

.composer-file-input {
  display: none;
}

.composer-input {
  min-height: 42px;
  resize: none;
}

.composer-preview {
  grid-column: 1/-1;
  border-left: 3px solid var(--tg-accent);
  background: var(--tg-panel);
  border-radius: 12px;
  padding: 8px 10px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 8px;
}

.messages-panel.drag-over {
  outline: 2px dashed var(--tg-accent);
  outline-offset: -12px;
}

.attachment-card.media-button {
  border: 0;
  padding: 0;
  cursor: zoom-in;
}

.emoji-panel {
  grid-column: 1/-1;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 10px;
  border: 1px solid var(--tg-border);
  border-radius: 14px;
  background: var(--tg-panel);
}

.emoji-choice {
  border: 0;
  border-radius: 999px;
  background: rgba(42, 171, 238, 0.12);
  padding: 6px 9px;
  cursor: pointer;
}

.chat-sheet {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: end center;
  background: rgba(14, 22, 33, 0.36);
}

.chat-sheet-card {
  width: min(420px, 100%);
  max-height: 78dvh;
  overflow: auto;
  background: var(--tg-panel);
  color: var(--tg-text);
  border-radius: 18px 18px 0 0;
  padding: 14px;
  display: grid;
  gap: 8px;
}

.chat-sheet-card > button,
.forward-chat-row,
.search-result-row {
  border: 0;
  border-radius: 12px;
  background: rgba(42, 171, 238, 0.08);
  color: var(--tg-text);
  padding: 10px;
  text-align: left;
}

.forward-chat-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.settings-switch {
  width: 52px;
  height: 32px;
  border: 0;
  border-radius: 16px;
  padding: 3px;
  background: rgba(127, 145, 164, 0.35);
  transition: background 0.18s ease;
}

.settings-switch i {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: block;
  background: #fff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.22);
  transition: transform 0.18s ease;
}

.settings-switch.on {
  background: var(--tg-accent);
}

.settings-switch.on i {
  transform: translateX(20px);
}

.settings-switch:disabled {
  opacity: 0.58;
}

.chat-settings-sheet {
  z-index: 1300;
  padding: 0 10px calc(10px + env(safe-area-inset-bottom));
  background: rgba(10, 18, 28, 0.48);
  backdrop-filter: blur(12px);
}

.chat-settings-card {
  width: min(430px, 100%);
  max-height: min(82dvh, 720px);
  overflow: auto;
  border-radius: 20px;
  display: grid;
  gap: 12px;
  padding: 14px;
  color: var(--tg-text);
  background: color-mix(in srgb, var(--tg-panel) 94%, transparent);
  box-shadow: 0 20px 50px rgba(5, 12, 20, 0.28);
}

.chat-settings-head {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) 36px;
  align-items: center;
  gap: 10px;
}

.chat-settings-head span:nth-child(2) {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.chat-settings-head strong,
.chat-settings-toggle-row strong,
.chat-settings-row strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-settings-head em,
.chat-settings-toggle-row em,
.chat-settings-stats em {
  color: var(--tg-muted);
  font-style: normal;
  font-size: 13px;
}

.chat-settings-head button {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-muted);
  background: rgba(127, 145, 164, 0.12);
}

.chat-settings-section {
  border-radius: 14px;
  display: grid;
  gap: 10px;
  padding: 10px;
  background: rgba(127, 145, 164, 0.08);
}

.chat-settings-toggle-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 54px;
  align-items: center;
  gap: 12px;
}

.chat-settings-toggle-row span {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.chat-settings-section-title {
  color: var(--tg-muted);
  font-size: 13px;
  font-weight: 600;
}

.chat-settings-choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.chat-settings-choice,
.chat-settings-refresh {
  min-height: 40px;
  border: 1px solid var(--tg-soft-border);
  border-radius: 12px;
  color: var(--tg-text);
  background: rgba(255, 255, 255, 0.04);
  font-weight: 600;
}

.chat-settings-choice.active {
  border-color: rgba(42, 171, 238, 0.48);
  color: var(--tg-accent);
  background: rgba(42, 171, 238, 0.14);
}

.chat-settings-choice:disabled {
  opacity: 0.58;
}

.chat-settings-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.chat-settings-stats span {
  min-height: 68px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 3px;
  background: rgba(255, 255, 255, 0.05);
}

.chat-settings-stats strong {
  font-size: 21px;
}

.chat-settings-row {
  min-height: 46px;
  border: 0;
  display: grid;
  grid-template-columns: 31px minmax(0, 1fr) 52px;
  align-items: center;
  gap: 10px;
  color: var(--tg-text);
  background: transparent;
  text-align: left;
}

.chat-settings-row + .chat-settings-row {
  border-top: 1px solid rgba(127, 145, 164, 0.12);
}

.chat-settings-note {
  border-radius: 12px;
  padding: 10px 12px;
  color: var(--tg-muted);
  background: rgba(127, 145, 164, 0.1);
  font-size: 13px;
  line-height: 1.35;
}

.chat-settings-note.error {
  color: #ff6b5f;
  background: rgba(255, 69, 58, 0.1);
}

.chat-settings-refresh {
  color: var(--tg-accent);
}

.chat-toast {
  position: fixed;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  z-index: 2000;
  border-radius: 999px;
  padding: 10px 16px;
  color: #fff;
  background: rgba(23, 33, 43, 0.88);
}

.image-modal {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: grid;
  place-items: center;
  padding: 18px;
  background: rgba(14, 22, 33, 0.78);
}

.image-modal-card {
  position: relative;
  max-width: min(960px, 96vw);
  max-height: 92dvh;
  display: grid;
  gap: 10px;
  color: #fff;
  text-align: center;
}

.image-modal-card img {
  max-width: 100%;
  max-height: 86dvh;
  border-radius: 12px;
  object-fit: contain;
}

.image-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  color: #fff;
  background: rgba(14, 22, 33, 0.72);
  cursor: pointer;
}

@media (max-width: 760px) {
  .chats-shell {
    grid-template-columns: 1fr;
  }
  .chats-sidebar {
    border-right: 0;
  }
  .chats-main {
    min-height: 100dvh;
  }
}
/* Telegram Web visual pass */
.chats-page {
  --tg-bg: #dbe7f3;
  --tg-sidebar: #ffffff;
  --tg-panel: #ffffff;
  --tg-header: #ffffff;
  --tg-border: #d7e0ea;
  --tg-text: #17212b;
  --tg-muted: #6d7f90;
  --tg-accent: #2aabee;
  --tg-accent-press: #1f97d4;
  --tg-bubble-other: #ffffff;
  --tg-bubble-mine: #dff7c7;
  --tg-bubble-mine-border: #c9edaa;
  --tg-pattern: rgba(49, 102, 139, 0.06);
  min-height: 100dvh;
  background: var(--tg-bg);
  color: var(--tg-text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

body[data-theme=dark] .chats-page {
  --tg-bg: #0e1621;
  --tg-sidebar: #17212b;
  --tg-panel: #17212b;
  --tg-header: #17212b;
  --tg-border: #263542;
  --tg-text: #eef6fc;
  --tg-muted: #8aa0b3;
  --tg-accent: #2aabee;
  --tg-accent-press: #49b7ec;
  --tg-bubble-other: #182533;
  --tg-bubble-mine: #2b5278;
  --tg-bubble-mine-border: #37658e;
  --tg-pattern: rgba(255, 255, 255, 0.035);
}

.chats-shell {
  display: grid;
  grid-template-columns: 372px minmax(0, 1fr);
  gap: 0;
  max-width: none;
  height: calc(100dvh - 68px);
  min-height: 620px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: var(--tg-bg);
}

.chats-sidebar,
.chats-main {
  border: 0;
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.chats-sidebar {
  min-height: 0;
  max-height: none;
  padding: 0;
  gap: 0;
  background: var(--tg-sidebar);
  border-right: 1px solid var(--tg-border);
}

.chats-main {
  min-height: 0;
  display: grid;
  grid-template-rows: 60px auto minmax(0, 1fr) auto;
  background: linear-gradient(rgba(219, 231, 243, 0.88), rgba(219, 231, 243, 0.88)), radial-gradient(circle at 18px 18px, var(--tg-pattern) 0 1.4px, transparent 1.5px), radial-gradient(circle at 42px 42px, var(--tg-pattern) 0 1.2px, transparent 1.3px);
  background-size: auto, 52px 52px, 52px 52px;
}

body[data-theme=dark] .chats-main {
  background: linear-gradient(rgba(14, 22, 33, 0.92), rgba(14, 22, 33, 0.92)), radial-gradient(circle at 18px 18px, var(--tg-pattern) 0 1.4px, transparent 1.5px), radial-gradient(circle at 42px 42px, var(--tg-pattern) 0 1.2px, transparent 1.3px);
  background-size: auto, 52px 52px, 52px 52px;
}

.chats-brand,
.chats-create {
  display: none;
}

.chats-sidebar-head {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 14px;
  border-bottom: 1px solid var(--tg-border);
  background: var(--tg-header);
}

.chats-sidebar-title {
  font-size: 20px;
  line-height: 1;
  font-weight: 700;
}

.chats-round-action,
.chats-icon {
  width: 38px;
  height: 38px;
  min-width: 38px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-muted);
  background: transparent;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.chats-round-action:hover,
.chats-icon:hover,
.chats-icon.active {
  color: var(--tg-accent);
  background: rgba(42, 171, 238, 0.12);
}

.chats-search-box {
  position: relative;
  padding: 9px 12px 8px;
  background: var(--tg-header);
}

.chats-search-box span {
  position: absolute;
  left: 25px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--tg-muted);
  pointer-events: none;
  z-index: 1;
}

.chats-input,
.composer-input {
  box-shadow: none;
  outline: none;
}

.chats-search {
  height: 38px;
  border: 0;
  border-radius: 19px;
  padding: 0 14px 0 38px;
  background: #eef3f7;
  color: var(--tg-text);
}

body[data-theme=dark] .chats-search {
  background: #242f3d;
}

.chats-search:focus,
.composer-input:focus,
.chat-sheet-card .chats-input:focus {
  border-color: transparent;
  box-shadow: 0 0 0 2px rgba(42, 171, 238, 0.24);
}

.chats-filter-row {
  display: flex;
  gap: 6px;
  padding: 4px 12px 9px;
  overflow: auto;
  background: var(--tg-header);
  scrollbar-width: none;
}

.chats-filter-row::-webkit-scrollbar {
  display: none;
}

.chat-filter-chip {
  min-height: 30px;
  border: 0;
  border-radius: 15px;
  background: transparent;
  color: var(--tg-muted);
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  white-space: nowrap;
}

.chat-filter-chip.active {
  background: rgba(42, 171, 238, 0.14);
  color: var(--tg-accent-press);
}

.chat-filter-chip span {
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(109, 127, 144, 0.16);
  font-size: 11px;
}

.chats-list {
  flex: 1 1;
  min-height: 0;
  padding: 0;
  gap: 0;
  overflow: auto;
  background: var(--tg-sidebar);
}

.chat-row {
  position: relative;
  min-height: 72px;
  width: 100%;
  border: 0;
  border-radius: 0;
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: transparent;
  color: var(--tg-text);
  transform: none;
}

.chat-row:hover {
  background: rgba(42, 171, 238, 0.07);
}

.chat-row.active {
  background: rgba(42, 171, 238, 0.14);
  border-color: transparent;
}

.chat-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #37aee2, #7bc862);
  color: #fff;
  font-size: 17px;
  font-weight: 700;
}

.chat-avatar.large {
  width: 42px;
  height: 42px;
  font-size: 15px;
}

.chat-avatar.small {
  width: 34px;
  height: 34px;
  font-size: 13px;
}

.chat-row-copy {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.chat-row-top {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}

.chat-row-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--tg-text);
  font-size: 15px;
  font-weight: 600;
}

.chat-row-time {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: var(--tg-muted);
  font-size: 12px;
}

.chat-row-preview {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--tg-muted);
  font-size: 13px;
}

.chat-row.unread .chat-row-title,
.chat-row.unread .chat-row-preview {
  font-weight: 700;
}

.chat-row-pin {
  color: var(--tg-muted);
  font-size: 12px;
}

.chat-row-pin.important {
  color: #e5a800;
}

.chat-unread-badge {
  position: absolute;
  right: 14px;
  bottom: 12px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  padding: 0 6px;
  background: var(--tg-accent);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.chats-header {
  height: 60px;
  min-height: 60px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--tg-header);
  border-bottom: 1px solid var(--tg-border);
}

.chats-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.chats-header-main > div:last-child {
  min-width: 0;
}

.chats-header-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--tg-text);
  font-size: 16px;
  line-height: 1.2;
  font-weight: 600;
}

.chats-header-meta {
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--tg-accent);
  font-size: 13px;
}

.chats-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.chats-invite {
  display: none;
}

.pinned-message-bar {
  min-height: 44px;
  border: 0;
  border-bottom: 1px solid var(--tg-border);
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 7px 18px;
  background: rgba(255, 255, 255, 0.9);
  color: var(--tg-text);
  text-align: left;
}

body[data-theme=dark] .pinned-message-bar {
  background: rgba(23, 33, 43, 0.92);
}

.pinned-message-bar span:first-child {
  color: var(--tg-accent);
}

.pinned-message-bar strong {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.pinned-message-bar em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--tg-muted);
  font-size: 13px;
  font-style: normal;
}

.messages-panel {
  min-height: 0;
  padding: 18px 22px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: auto;
}

.messages-date-divider {
  align-self: center;
  margin: 10px 0;
}

.messages-date-divider span {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  color: #fff;
  background: rgba(109, 127, 144, 0.58);
  font-size: 12px;
  font-weight: 600;
}

.messages-loadmore {
  min-height: 32px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.84);
  color: var(--tg-accent-press);
  padding: 0 14px;
}

:where(.chats-page) .message-bubble {
  position: relative;
  width: fit-content;
  max-width: min(680px, 72%);
  border: 0;
  border-radius: 12px;
  padding: 7px 9px 5px;
  box-shadow: 0 1px 1px rgba(23, 33, 43, 0.12);
  animation: bubble-in 0.16s ease;
}

:where(.chats-page) .message-bubble.other {
  align-self: flex-start;
  border-bottom-left-radius: 4px;
  background: var(--tg-bubble-other);
  color: var(--tg-text);
}

:where(.chats-page) .message-bubble.mine {
  align-self: flex-end;
  border: 1px solid var(--tg-bubble-mine-border);
  border-bottom-right-radius: 4px;
  background: var(--tg-bubble-mine);
  color: var(--tg-text);
}

:where(.chats-page) .message-bubble.other::after,
:where(.chats-page) .message-bubble.mine::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 10px;
  height: 10px;
  background: inherit;
}

:where(.chats-page) .message-bubble.other::after {
  left: -5px;
  clip-path: polygon(100% 0, 100% 100%, 0 100%);
}

:where(.chats-page) .message-bubble.mine::after {
  right: -5px;
  clip-path: polygon(0 0, 100% 100%, 0 100%);
}

:where(.chats-page) .message-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 1.35;
}

:where(.chats-page) .message-meta {
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  color: rgba(109, 127, 144, 0.92);
  font-size: 11px;
  line-height: 1;
}

:where(.chats-page) .message-bubble.mine .message-meta {
  color: rgba(77, 123, 57, 0.9);
}

body[data-theme=dark] :where(.chats-page) .message-bubble.mine .message-meta {
  color: rgba(170, 211, 238, 0.86);
}

.read-indicator {
  color: var(--tg-accent);
  font-weight: 700;
}

.message-more {
  width: 24px;
  height: 20px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  line-height: 1;
  cursor: pointer;
}

.message-more:hover {
  background: rgba(42, 171, 238, 0.12);
}

.message-reply-preview,
.message-forwarded,
.link-preview-card {
  border: 0;
  border-left: 3px solid var(--tg-accent);
  border-radius: 7px;
  background: rgba(42, 171, 238, 0.1);
  color: var(--tg-text);
  padding: 6px 8px;
  margin-bottom: 6px;
}

.message-reply-preview {
  width: 100%;
  display: grid;
  gap: 2px;
  text-align: left;
}

.message-reply-preview strong,
.message-forwarded {
  color: var(--tg-accent-press);
  font-size: 12px;
}

.attachment-stack {
  display: grid;
  gap: 6px;
  margin-bottom: 6px;
}

.attachment-card {
  border-radius: 8px;
  overflow: hidden;
}

.attachment-card.media-button {
  border: 0;
  padding: 0;
  background: transparent;
  cursor: zoom-in;
}

.attachment-card.media img,
.attachment-card.media {
  max-width: 300px;
  max-height: 300px;
}

.message-reactions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 6px;
}

.message-reaction {
  border: 0;
  border-radius: 999px;
  background: rgba(42, 171, 238, 0.13);
  color: var(--tg-text);
  padding: 3px 7px;
  font-size: 12px;
}

.composer {
  position: sticky;
  bottom: 0;
  z-index: 4;
  border: 0;
  padding: 9px 18px 14px;
  display: grid;
  grid-template-columns: 40px 40px minmax(0, 1fr) 44px;
  align-items: end;
  gap: 8px;
  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, 0.95) 28%);
}

body[data-theme=dark] .composer {
  background: linear-gradient(180deg, rgba(14, 22, 33, 0), rgba(14, 22, 33, 0.96) 28%);
}

.composer-file-input {
  display: none;
}

.composer .chats-icon {
  background: var(--tg-panel);
  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);
}

.composer-input {
  min-height: 42px;
  max-height: 140px;
  border: 0;
  border-radius: 21px;
  resize: none;
  padding: 11px 14px;
  background: var(--tg-panel);
  color: var(--tg-text);
  font-size: 15px;
  line-height: 1.35;
  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);
}

.composer-send {
  min-width: 44px;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: var(--tg-accent);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  box-shadow: 0 2px 5px rgba(42, 171, 238, 0.28);
}

.composer-send:hover {
  transform: none;
  background: var(--tg-accent-press);
}

.composer-preview,
.emoji-panel {
  grid-column: 1/-1;
  border: 0;
  border-left: 3px solid var(--tg-accent);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.92);
  padding: 8px 10px;
  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);
}

body[data-theme=dark] .composer-preview,
body[data-theme=dark] .emoji-panel {
  background: rgba(23, 33, 43, 0.92);
}

.composer-preview {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 8px;
}

.composer-preview span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--tg-muted);
}

.composer-preview button {
  border: 0;
  background: transparent;
  color: var(--tg-muted);
  cursor: pointer;
}

.emoji-panel {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.emoji-choice {
  border: 0;
  border-radius: 999px;
  background: rgba(42, 171, 238, 0.12);
  padding: 6px 9px;
  cursor: pointer;
}

.chats-primary,
.chats-secondary {
  border: 0;
  border-radius: 10px;
  background: var(--tg-accent);
  color: #fff;
  padding: 10px 12px;
  font-weight: 600;
}

.chats-primary:hover,
.chats-secondary:hover {
  transform: none;
  background: var(--tg-accent-press);
}

.chat-sheet {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: end center;
  background: rgba(14, 22, 33, 0.36);
}

.chat-sheet-card {
  width: min(420px, 100%);
  max-height: 78dvh;
  overflow: auto;
  border-radius: 16px 16px 0 0;
  display: grid;
  gap: 9px;
  padding: 14px;
  background: var(--tg-panel);
  color: var(--tg-text);
}

.chat-sheet-card h3 {
  margin: 0 0 4px;
  font-size: 17px;
}

.chat-sheet-card > button,
.forward-chat-row,
.search-result-row {
  min-height: 40px;
  border: 0;
  border-radius: 10px;
  background: rgba(42, 171, 238, 0.08);
  color: var(--tg-text);
  padding: 10px;
  text-align: left;
}

.chat-sheet-card .chats-input {
  border: 1px solid var(--tg-border);
  border-radius: 10px;
  background: var(--tg-panel);
  color: var(--tg-text);
}

.forward-chat-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-toast {
  position: fixed;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  z-index: 2000;
  border-radius: 999px;
  padding: 10px 16px;
  color: #fff;
  background: rgba(23, 33, 43, 0.88);
}

.chats-empty {
  align-self: center;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  color: var(--tg-muted);
  padding: 16px 18px;
}

body[data-theme=dark] .chats-empty {
  background: rgba(23, 33, 43, 0.72);
}

@media (max-width: 900px) {
  .chats-shell {
    grid-template-columns: 320px minmax(0, 1fr);
  }
  :where(.chats-page) .message-bubble {
    max-width: 82%;
  }
}
@media (max-width: 760px) {
  .chats-shell {
    display: grid;
    grid-template-columns: 1fr;
    height: auto;
    min-height: calc(100dvh - 68px);
    overflow: visible;
  }
  .chats-sidebar {
    border-right: 0;
    min-height: 44dvh;
  }
  .chats-main {
    min-height: 70dvh;
  }
  .messages-panel {
    padding: 12px 10px;
  }
  :where(.chats-page) .message-bubble {
    max-width: 90%;
  }
  .composer {
    grid-template-columns: 40px 40px minmax(0, 1fr) 44px;
    padding: 8px 8px calc(10px + env(safe-area-inset-bottom));
  }
  .chats-header-actions {
    gap: 0;
  }
}
.chat-icon {
  width: 20px;
  height: 20px;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.chats-sidebar-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.chat-avatar-wrap {
  position: relative;
  width: 52px;
  height: 52px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.chat-avatar-wrap.large {
  width: 42px;
  height: 42px;
}

.chat-avatar-wrap.online::after {
  content: "";
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 11px;
  height: 11px;
  border: 2px solid var(--tg-sidebar);
  border-radius: 50%;
  background: #33c46e;
}

.chats-header .chat-avatar-wrap.online::after {
  right: 0;
  bottom: 0;
  border-color: var(--tg-header);
}

.chats-search-box .chat-icon {
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: var(--tg-muted);
  pointer-events: none;
  z-index: 1;
}

.chats-search-box span {
  display: none;
}

.chat-row-time .chat-icon {
  width: 13px;
  height: 13px;
}

.chat-row-time .chat-icon:nth-child(2) {
  color: #e5a800;
}

.chats-icon .chat-icon,
.chats-round-action .chat-icon,
.composer-send .chat-icon {
  width: 20px;
  height: 20px;
}

.chat-mobile-back {
  display: none;
}

.chats-main {
  position: relative;
}

.chats-header {
  grid-row: 1;
}

.pinned-message-bar {
  grid-row: 2;
}

.messages-panel {
  grid-row: 3;
}

.composer {
  grid-row: 4;
}

:where(.chats-page) .message-bubble.grouped-prev {
  margin-top: 1px;
}

:where(.chats-page) .message-bubble.grouped-prev.other {
  border-top-left-radius: 12px;
}

:where(.chats-page) .message-bubble.grouped-prev.mine {
  border-top-right-radius: 12px;
}

:where(.chats-page) .message-bubble.grouped-next.other,
:where(.chats-page) .message-bubble.grouped-prev.other {
  border-bottom-left-radius: 12px;
}

:where(.chats-page) .message-bubble.grouped-next.mine,
:where(.chats-page) .message-bubble.grouped-prev.mine {
  border-bottom-right-radius: 12px;
}

:where(.chats-page) .message-bubble.grouped-next::after,
:where(.chats-page) .message-bubble.grouped-prev::after {
  display: none;
}

:where(.chats-page) .message-bubble.important {
  box-shadow: 0 0 0 1px rgba(229, 168, 0, 0.28), 0 1px 1px rgba(23, 33, 43, 0.12);
}

:where(.chats-page) .message-text a {
  color: var(--tg-accent-press);
  text-decoration: none;
}

:where(.chats-page) .message-text a:hover {
  text-decoration: underline;
}

:where(.chats-page) .message-text code {
  border-radius: 5px;
  padding: 1px 5px;
  background: rgba(109, 127, 144, 0.16);
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 0.92em;
}

:where(.chats-page) .message-text pre {
  max-width: 100%;
  overflow: auto;
  border-radius: 8px;
  margin: 5px 0;
  padding: 8px;
  background: rgba(14, 22, 33, 0.08);
}

body[data-theme=dark] :where(.chats-page) .message-text pre {
  background: rgba(255, 255, 255, 0.08);
}

.message-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.message-more .chat-icon {
  width: 16px;
  height: 16px;
}

.jump-to-bottom {
  position: absolute;
  right: 22px;
  bottom: 76px;
  z-index: 8;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-accent);
  background: var(--tg-panel);
  box-shadow: 0 4px 14px rgba(23, 33, 43, 0.18);
  cursor: pointer;
}

.composer-send:disabled,
.composer .chats-icon:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.composer-send .chat-icon {
  color: #fff;
}

.composer-preview button,
.composer-attachment-chip button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.composer-preview button .chat-icon,
.composer-attachment-chip button .chat-icon {
  width: 16px;
  height: 16px;
}

.composer-attachments {
  grid-column: 1/-1;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 2px 0 1px;
  scrollbar-width: thin;
}

.composer-attachment-chip {
  min-width: 190px;
  max-width: 260px;
  border-radius: 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 10px;
  background: var(--tg-panel);
  color: var(--tg-text);
  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);
}

.composer-attachment-chip span {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.composer-attachment-chip strong,
.composer-attachment-chip em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.composer-attachment-chip strong {
  font-size: 13px;
  font-weight: 600;
}

.composer-attachment-chip em {
  color: var(--tg-muted);
  font-size: 12px;
  font-style: normal;
}

.composer-attachment-chip button {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  color: var(--tg-muted);
  background: rgba(109, 127, 144, 0.12);
}

@media (max-width: 760px) {
  .chats-shell {
    height: calc(100dvh - 56px);
    min-height: 0;
  }
  .chats-shell:not(.mobile-dialog-open) .chats-main {
    display: none;
  }
  .chats-shell.mobile-dialog-open .chats-sidebar {
    display: none;
  }
  .chat-mobile-back {
    display: inline-flex;
    margin-left: -8px;
  }
  .chats-sidebar {
    min-height: 100%;
  }
  .chats-main {
    min-height: 0;
  }
  .chats-header {
    padding: 0 8px;
  }
  .chats-header-actions .chats-icon {
    width: 34px;
    min-width: 34px;
  }
  .jump-to-bottom {
    right: 14px;
    bottom: 72px;
  }
}
/* Native Telegram-like pass */
.chats-page {
  --tg-bg: #0e1621;
  --tg-sidebar: #17212b;
  --tg-panel: #17212b;
  --tg-header: #17212b;
  --tg-border: #0b1118;
  --tg-soft-border: #26323f;
  --tg-text: #eef6fc;
  --tg-muted: #7f91a4;
  --tg-accent: #2aabee;
  --tg-accent-press: #41b6ea;
  --tg-bubble-other: #182533;
  --tg-bubble-mine: #2b5278;
  --tg-bubble-mine-border: #2b5278;
  --tg-date-pill: rgba(42, 54, 68, 0.82);
  --tg-composer: #17212b;
  --tg-input: #242f3d;
  min-height: 100dvh;
  height: 100dvh;
  overflow: hidden;
  background: var(--tg-bg);
  color: var(--tg-text);
}

.chats-page[data-chat-theme=light] {
  --tg-bg: #dbe7f3;
  --tg-sidebar: #ffffff;
  --tg-panel: #ffffff;
  --tg-header: #ffffff;
  --tg-border: #cfd9e4;
  --tg-soft-border: #e2e8ef;
  --tg-text: #17212b;
  --tg-muted: #6d7f90;
  --tg-bubble-other: #ffffff;
  --tg-bubble-mine: #dff7c7;
  --tg-bubble-mine-border: #c9edaa;
  --tg-date-pill: rgba(109, 127, 144, 0.58);
  --tg-composer: #dbe7f3;
  --tg-input: #ffffff;
}

.chats-page .chats-shell {
  height: 100dvh;
  min-height: 0;
  grid-template-columns: 360px minmax(0, 1fr);
  background: var(--tg-bg);
}

.chats-page .chats-sidebar {
  background: var(--tg-sidebar);
  border-right: 1px solid var(--tg-border);
}

.chats-page .chats-main {
  position: relative;
  isolation: isolate;
  min-height: 0;
  grid-template-rows: 56px auto minmax(0, 1fr) auto;
  background: linear-gradient(rgba(14, 22, 33, 0.9), rgba(14, 22, 33, 0.9)), radial-gradient(circle at 24px 24px, rgba(255, 255, 255, 0.045) 0 1.2px, transparent 1.4px), radial-gradient(circle at 76px 84px, rgba(255, 255, 255, 0.035) 0 1.6px, transparent 1.8px), linear-gradient(35deg, transparent 0 46%, rgba(255, 255, 255, 0.025) 46% 48%, transparent 48% 100%);
  background-color: var(--tg-bg);
  background-size: auto, 68px 68px, 112px 112px, 96px 96px;
}

.chats-page[data-chat-theme=light] .chats-main {
  background: linear-gradient(rgba(219, 231, 243, 0.84), rgba(219, 231, 243, 0.84)), radial-gradient(circle at 24px 24px, rgba(49, 102, 139, 0.075) 0 1.2px, transparent 1.4px), radial-gradient(circle at 76px 84px, rgba(49, 102, 139, 0.055) 0 1.6px, transparent 1.8px), linear-gradient(35deg, transparent 0 46%, rgba(49, 102, 139, 0.035) 46% 48%, transparent 48% 100%);
  background-color: var(--tg-bg);
  background-size: auto, 68px 68px, 112px 112px, 96px 96px;
}

.chats-page .chats-sidebar-head,
.chats-page .chats-header {
  height: 56px;
  min-height: 56px;
  background: var(--tg-header);
  border-bottom: 1px solid var(--tg-border);
}

.chats-page .chats-sidebar-head {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  gap: 8px;
  padding: 0 8px 0 10px;
}

.chats-page .chats-sidebar-title {
  font-size: 19px;
  font-weight: 600;
}

.chats-page .chats-round-action,
.chats-page .chats-icon {
  width: 40px;
  height: 40px;
  min-width: 40px;
  color: #8596a8;
}

.chats-page .chats-round-action:hover,
.chats-page .chats-icon:hover,
.chats-page .chats-icon.active {
  color: var(--tg-accent);
  background: rgba(42, 171, 238, 0.12);
}

.chats-page .chats-search-box {
  padding: 8px 12px;
  background: var(--tg-sidebar);
}

.chats-page .chats-search {
  height: 36px;
  border-radius: 18px;
  background: var(--tg-input);
  color: var(--tg-text);
  font-size: 14px;
}

.chats-page .chats-search::placeholder,
.chats-page .composer-input::placeholder {
  color: var(--tg-muted);
}

.chats-page .chats-filter-row {
  padding: 2px 10px 8px;
  background: var(--tg-sidebar);
}

.chats-page .chat-filter-chip {
  min-height: 30px;
  border-radius: 15px;
  color: var(--tg-muted);
  font-size: 13px;
}

.chats-page .chat-filter-chip.active {
  color: #ffffff;
  background: rgba(42, 171, 238, 0.24);
}

.chats-page[data-chat-theme=light] .chat-filter-chip.active {
  color: var(--tg-accent-press);
  background: rgba(42, 171, 238, 0.14);
}

.chats-page .chat-row {
  min-height: 72px;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 10px;
  padding: 8px 12px;
}

.chats-page .chat-row::after {
  content: "";
  position: absolute;
  left: 76px;
  right: 0;
  bottom: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.045);
}

.chats-page[data-chat-theme=light] .chat-row::after {
  background: rgba(23, 33, 43, 0.08);
}

.chats-page .chat-row:hover {
  background: rgba(255, 255, 255, 0.045);
}

.chats-page .chat-row.active {
  background: rgba(42, 171, 238, 0.22);
}

.chats-page[data-chat-theme=light] .chat-row.active {
  background: rgba(42, 171, 238, 0.14);
}

.chats-page .chat-avatar {
  background: linear-gradient(135deg, #8b5cf6, #c053dd);
  box-shadow: none;
}

.chats-page .chat-row:nth-child(4n+1) .chat-avatar {
  background: linear-gradient(135deg, #36a3f7, #2cc7b7);
}

.chats-page .chat-row:nth-child(4n+2) .chat-avatar {
  background: linear-gradient(135deg, #f59f37, #ef4444);
}

.chats-page .chat-row:nth-child(4n+3) .chat-avatar {
  background: linear-gradient(135deg, #7bc862, #38bdf8);
}

.chats-page .chat-row-title {
  color: var(--tg-text);
  font-size: 15px;
  font-weight: 600;
}

.chats-page .chat-row-preview,
.chats-page .chat-row-time {
  color: var(--tg-muted);
}

.chats-page .chat-unread-badge {
  right: 12px;
  bottom: 12px;
  background: #4dcd5e;
}

.chats-page .chats-header {
  padding: 0 10px 0 14px;
  box-shadow: none;
}

.chats-page .chats-header-name {
  color: var(--tg-text);
  font-size: 16px;
  font-weight: 600;
}

.chats-page .chats-header-meta {
  color: var(--tg-accent);
  font-size: 14px;
}

.chats-page .pinned-message-bar {
  min-height: 42px;
  background: rgba(23, 33, 43, 0.94);
  border-bottom: 1px solid var(--tg-border);
}

.chats-page[data-chat-theme=light] .pinned-message-bar {
  background: rgba(255, 255, 255, 0.94);
}

.chats-page .messages-panel {
  padding: 14px max(18px, (100% - 920px) / 2) 10px;
  gap: 2px;
  scroll-behavior: smooth;
}

.chats-page .messages-date-divider span {
  min-height: 26px;
  padding: 0 12px;
  background: var(--tg-date-pill);
  backdrop-filter: blur(8px);
  font-size: 12px;
}

.chats-page .message-bubble {
  max-width: min(620px, 78%);
  border-radius: 11px;
  padding: 6px 8px 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.22);
}

.chats-page .message-bubble.other {
  background: var(--tg-bubble-other);
  border-bottom-left-radius: 3px;
}

.chats-page .message-bubble.mine {
  border: 0;
  background: var(--tg-bubble-mine);
  border-bottom-right-radius: 3px;
}

.chats-page .message-bubble.grouped-next.other,
.chats-page .message-bubble.grouped-prev.other {
  border-bottom-left-radius: 11px;
}

.chats-page .message-bubble.grouped-next.mine,
.chats-page .message-bubble.grouped-prev.mine {
  border-bottom-right-radius: 11px;
}

.chats-page .message-text {
  color: var(--tg-text);
  font-size: 16px;
  line-height: 1.36;
}

.chats-page .message-meta {
  min-height: 13px;
  margin-top: 1px;
  color: #7d8e9f;
  font-size: 11px;
}

.chats-page .message-bubble.mine .message-meta {
  color: #a9c7dd;
}

.chats-page[data-chat-theme=light] .message-bubble.mine .message-meta {
  color: #4d7b39;
}

.chats-page .read-indicator {
  color: #59c7ff;
}

.chats-page .message-reply-preview,
.chats-page .message-forwarded,
.chats-page .link-preview-card {
  background: rgba(42, 171, 238, 0.11);
}

.chats-page .composer {
  min-height: 58px;
  padding: 7px max(12px, (100% - 940px) / 2) 10px;
  grid-template-columns: 40px minmax(0, 1fr) 40px 46px;
  background: linear-gradient(180deg, rgba(14, 22, 33, 0), var(--tg-bg) 22%);
}

.chats-page[data-chat-theme=light] .composer {
  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, 0.96) 22%);
}

.chats-page .composer .chats-icon {
  background: transparent;
  box-shadow: none;
}

.chats-page .composer > .chats-icon:first-of-type {
  grid-column: 1;
}

.chats-page .composer > .chats-icon:nth-of-type(2) {
  grid-column: 3;
}

.chats-page .composer-input {
  grid-column: 2;
  min-height: 42px;
  border: 0;
  border-radius: 21px;
  background: var(--tg-input);
  color: var(--tg-text);
  box-shadow: none;
}

.chats-page .composer-send {
  grid-column: 4;
  background: var(--tg-accent);
  box-shadow: none;
}

.chats-page .composer-preview,
.chats-page .composer-attachments,
.chats-page .emoji-panel {
  grid-column: 1/-1;
}

.chats-page .composer-preview,
.chats-page .emoji-panel,
.chats-page .composer-attachment-chip {
  background: rgba(23, 33, 43, 0.96);
  border-color: var(--tg-accent);
}

.chats-page[data-chat-theme=light] .composer-preview,
.chats-page[data-chat-theme=light] .emoji-panel,
.chats-page[data-chat-theme=light] .composer-attachment-chip {
  background: rgba(255, 255, 255, 0.96);
}

.chats-page .jump-to-bottom {
  right: max(16px, (100% - 920px) / 2);
  bottom: 74px;
  background: var(--tg-panel);
}

.chats-page .chats-empty {
  justify-self: center;
  align-self: center;
  background: rgba(42, 54, 68, 0.84);
  color: #d7e5ef;
}

.chats-page[data-chat-theme=light] .chats-empty {
  background: rgba(255, 255, 255, 0.78);
  color: var(--tg-muted);
}

@media (max-width: 900px) {
  .chats-page .chats-shell {
    grid-template-columns: 330px minmax(0, 1fr);
  }
  .chats-page .message-bubble {
    max-width: 84%;
  }
}
@media (max-width: 760px) {
  .chats-page .chats-shell {
    height: 100dvh;
    grid-template-columns: 1fr;
  }
  .chats-page .chats-sidebar-head,
  .chats-page .chats-header {
    height: 58px;
    min-height: 58px;
  }
  .chats-page .chats-main {
    grid-template-rows: 58px auto minmax(0, 1fr) auto;
  }
  .chats-page .chats-header-actions .chats-icon:nth-child(3),
  .chats-page .chats-header-actions .chats-icon:nth-child(4),
  .chats-page .chats-header-actions .chats-icon:nth-child(5) {
    display: none;
  }
  .chats-page .messages-panel {
    padding: 12px 10px 8px;
  }
  .chats-page .message-bubble {
    max-width: 86%;
  }
  .chats-page .composer {
    padding: 6px 8px calc(8px + env(safe-area-inset-bottom));
    grid-template-columns: 38px minmax(0, 1fr) 38px 44px;
  }
  .chats-page .jump-to-bottom {
    right: 12px;
    bottom: calc(70px + env(safe-area-inset-bottom));
  }
}
/* Telegram iOS multi-screen states */
.chats-sidebar-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.chat-list-screen {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.mobile-settings-screen,
.mobile-tabbar {
  display: none;
}

.chats-search-cancel {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-muted);
  background: rgba(127, 145, 164, 0.18);
}

.chats-search-cancel .chat-icon {
  width: 14px;
  height: 14px;
}

.mobile-search-screen {
  display: grid;
  gap: 10px;
  padding: 0 12px 8px;
  color: var(--tg-muted);
}

.mobile-search-tabs {
  display: flex;
  gap: 18px;
  overflow-x: auto;
  scrollbar-width: none;
}

.mobile-search-tabs::-webkit-scrollbar {
  display: none;
}

.mobile-search-tabs button {
  position: relative;
  border: 0;
  background: transparent;
  color: var(--tg-muted);
  padding: 8px 0;
  white-space: nowrap;
}

.mobile-search-tabs button.active {
  color: var(--tg-accent);
}

.mobile-search-tabs button.active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  border-radius: 2px;
  background: var(--tg-accent);
}

.mobile-search-count {
  font-size: 13px;
}

.message-action-sheet {
  place-items: center center;
  max-height: 100vh;
  max-height: 100dvh;
  padding: 18px 12px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  backdrop-filter: blur(14px);
  background: rgba(0, 0, 0, 0.58);
}

.message-action-sheet .message-action-preview {
  width: fit-content;
  max-width: min(520px, 84vw);
  margin-bottom: 10px;
  pointer-events: auto;
}

.message-action-sheet .chat-sheet-card {
  width: min(360px, 100vw - 24px);
  max-height: calc(100vh - 36px);
  max-height: calc(100dvh - 36px);
  border-radius: 14px;
  padding: 0;
  gap: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  background: rgba(34, 36, 40, 0.94);
  backdrop-filter: blur(20px);
}

.message-action-sheet .reaction-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
  margin: 0;
  padding: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.message-action-sheet .reaction-row button {
  min-height: 34px;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 23px;
}

.message-action-sheet .reaction-row .chat-icon {
  width: 17px;
  height: 17px;
}

.message-action-sheet .chat-sheet-card > button {
  min-height: 46px;
  border: 0;
  border-radius: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px;
  align-items: center;
  gap: 16px;
  padding: 0 14px;
  color: #fff;
  background: transparent;
  text-align: left;
  font-size: 16px;
}

.message-action-sheet .chat-sheet-card > button + button {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.message-action-sheet .chat-sheet-card > button.danger {
  color: #ff453a;
}

.message-action-sheet .chat-sheet-card .chat-icon {
  width: 19px;
  height: 19px;
}

.attachment-action-sheet {
  place-items: end center;
  gap: 10px;
  padding: 0 10px calc(10px + env(safe-area-inset-bottom));
  backdrop-filter: blur(18px);
  background: rgba(0, 0, 0, 0.58);
}

.attachment-sheet-grid {
  width: min(420px, 100%);
  border-radius: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 12px;
  padding: 28px 18px 24px;
  background: rgba(33, 35, 39, 0.94);
  backdrop-filter: blur(20px);
}

.attachment-sheet-grid button {
  border: 0;
  display: grid;
  justify-items: center;
  gap: 8px;
  color: #fff;
  background: transparent;
}

.attachment-sheet-grid strong {
  font-size: 13px;
  font-weight: 500;
}

.attachment-sheet-icon,
.settings-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.attachment-sheet-icon .chat-icon {
  width: 25px;
  height: 25px;
}

.attachment-sheet-icon.blue,
.settings-icon.blue {
  background: linear-gradient(135deg, #2f80ed, #3b9bff);
}

.attachment-sheet-icon.purple,
.settings-icon.purple {
  background: linear-gradient(135deg, #7c3aed, #a855f7);
}

.attachment-sheet-icon.orange,
.settings-icon.orange {
  background: linear-gradient(135deg, #f59e0b, #fb923c);
}

.attachment-sheet-icon.green,
.settings-icon.green {
  background: linear-gradient(135deg, #22c55e, #4ade80);
}

.attachment-sheet-icon.red,
.settings-icon.red {
  background: linear-gradient(135deg, #ef4444, #f97316);
}

.settings-icon.gray {
  background: linear-gradient(135deg, #64748b, #94a3b8);
}

.attachment-sheet-cancel {
  width: min(420px, 100%);
  min-height: 54px;
  border: 0;
  border-radius: 14px;
  color: var(--tg-accent);
  background: rgba(33, 35, 39, 0.94);
  font-size: 16px;
}

.telegram-media-viewer {
  place-items: stretch;
  padding: 0;
  background: #000;
}

.telegram-media-viewer header,
.telegram-media-viewer footer {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 3;
  display: grid;
  align-items: center;
  color: #fff;
}

.telegram-media-viewer header {
  top: 0;
  height: 58px;
  grid-template-columns: 58px 1fr 96px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0));
}

.telegram-media-viewer header > button,
.telegram-media-viewer header span button,
.media-caption button {
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: transparent;
}

.telegram-media-viewer header strong {
  text-align: center;
  font-size: 16px;
}

.telegram-media-viewer header span {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-right: 12px;
}

.telegram-media-viewer .image-modal-card {
  width: 100%;
  height: 100dvh;
  max-width: none;
  max-height: none;
  display: grid;
  place-items: center;
  padding: 70px 16px 150px;
}

.telegram-media-viewer .image-modal-card img {
  max-width: min(820px, 88vw);
  max-height: calc(100dvh - 240px);
  border-radius: 0;
}

.telegram-media-viewer footer {
  bottom: 0;
  gap: 12px;
  padding: 10px 18px calc(16px + env(safe-area-inset-bottom));
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
}

.media-thumbnails {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.media-thumbnails button {
  width: 42px;
  height: 42px;
  border: 2px solid transparent;
  border-radius: 5px;
  padding: 0;
  overflow: hidden;
  background: transparent;
}

.media-thumbnails button.active {
  border-color: #fff;
}

.media-thumbnails img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-caption {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 14px;
  max-width: 620px;
  width: 100%;
  justify-self: center;
}

.media-caption strong,
.media-caption span {
  grid-column: 1;
}

.media-caption strong {
  font-size: 14px;
}

.media-caption span {
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
}

.mobile-edit-screen {
  display: none;
}

@media (max-width: 760px) {
  .mobile-tabbar {
    height: 66px;
    border-top: 1px solid rgba(211, 221, 232, 0.92);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 -10px 28px rgba(15, 23, 42, 0.07);
    backdrop-filter: blur(18px) saturate(1.2);
  }
  .mobile-tabbar button {
    position: relative;
    border: 0;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 3px;
    color: #7b8da3;
    background: transparent;
    font-size: 10px;
  }
  .mobile-tabbar button.active {
    color: var(--tg-accent);
  }
  .mobile-tabbar .chat-icon {
    width: 22px;
    height: 22px;
  }
  .mobile-tabbar b {
    position: absolute;
    top: 7px;
    right: calc(50% - 22px);
    min-width: 17px;
    height: 17px;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #ff3b30;
    font-size: 10px;
  }
  .chats-sidebar-body.show-settings .chat-list-screen,
  .chats-sidebar-body.show-chats .mobile-settings-screen {
    display: none;
  }
  .chats-sidebar-body.show-settings .mobile-settings-screen {
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 0 12px 14px;
    background: var(--tg-bg);
  }
  .mobile-settings-title {
    height: 54px;
    display: grid;
    grid-template-columns: 64px 1fr 64px;
    align-items: center;
    color: var(--tg-text);
  }
  .mobile-settings-title span {
    grid-column: 2;
    justify-self: center;
    font-weight: 700;
  }
  .mobile-settings-title button {
    grid-column: 3;
    border: 0;
    color: var(--tg-accent);
    background: transparent;
    text-align: right;
    font-size: 15px;
  }
  .mobile-settings-title.sub {
    grid-template-columns: 48px 1fr 64px;
  }
  .mobile-settings-title.sub .mobile-settings-back {
    grid-column: 1;
    justify-self: start;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .mobile-settings-title.sub .mobile-settings-back .chat-icon {
    width: 22px;
    height: 22px;
  }
  .mobile-settings-profile {
    min-height: 76px;
    border: 0;
    border-radius: 12px;
    display: grid;
    grid-template-columns: 56px minmax(0, 1fr) 20px;
    align-items: center;
    gap: 12px;
    padding: 10px;
    color: var(--tg-text);
    background: rgba(255, 255, 255, 0.04);
    text-align: left;
  }
  .mobile-settings-profile span:nth-child(2) {
    min-width: 0;
    display: grid;
    gap: 4px;
  }
  .mobile-settings-profile strong {
    font-size: 17px;
  }
  .mobile-settings-profile em {
    color: var(--tg-muted);
    font-style: normal;
  }
  .mobile-settings-profile em.error {
    color: #ff6b5f;
  }
  .mobile-settings-group {
    margin-top: 14px;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.04);
  }
  .mobile-settings-row {
    min-height: 48px;
    width: 100%;
    border: 0;
    display: grid;
    grid-template-columns: 31px minmax(0, 1fr) auto auto 16px;
    align-items: center;
    gap: 10px;
    padding: 7px 10px;
    color: var(--tg-text);
    background: transparent;
    text-align: left;
  }
  .mobile-settings-row + .mobile-settings-row {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }
  .settings-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
  }
  .settings-icon .chat-icon {
    width: 17px;
    height: 17px;
  }
  .mobile-settings-row strong {
    font-weight: 500;
  }
  .mobile-settings-row em,
  .mobile-settings-row b {
    color: var(--tg-muted);
    font-style: normal;
    font-weight: 400;
  }
  .mobile-settings-row > .chat-icon {
    width: 15px;
    height: 15px;
    transform: rotate(-90deg);
    color: var(--tg-muted);
  }
  .mobile-settings-note {
    margin-top: 12px;
    border-radius: 12px;
    padding: 10px 12px;
    color: var(--tg-muted);
    background: rgba(255, 255, 255, 0.04);
    font-size: 13px;
    line-height: 1.35;
  }
  .mobile-settings-note.error {
    color: #ff6b5f;
    background: rgba(255, 69, 58, 0.1);
  }
  .mobile-settings-panel {
    display: grid;
    gap: 12px;
  }
  .mobile-settings-toggle-row {
    min-height: 68px;
    border-radius: 14px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 54px;
    align-items: center;
    gap: 14px;
    padding: 12px;
    color: var(--tg-text);
    background: rgba(255, 255, 255, 0.04);
  }
  .mobile-settings-toggle-row span {
    min-width: 0;
    display: grid;
    gap: 4px;
  }
  .mobile-settings-toggle-row strong,
  .mobile-settings-section-title {
    font-weight: 600;
  }
  .mobile-settings-toggle-row em {
    color: var(--tg-muted);
    font-style: normal;
    font-size: 13px;
  }
  .settings-switch {
    width: 52px;
    height: 32px;
    border: 0;
    border-radius: 16px;
    padding: 3px;
    background: rgba(127, 145, 164, 0.35);
    transition: background 0.18s ease;
  }
  .settings-switch i {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: block;
    background: #fff;
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.22);
    transition: transform 0.18s ease;
  }
  .settings-switch.on {
    background: var(--tg-accent);
  }
  .settings-switch.on i {
    transform: translateX(20px);
  }
  .settings-switch:disabled,
  .mobile-settings-choice:disabled {
    opacity: 0.58;
  }
  .mobile-settings-section-title {
    padding: 4px 2px 0;
    color: var(--tg-muted);
    font-size: 13px;
  }
  .mobile-settings-choice-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .mobile-settings-choice-grid.two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mobile-settings-choice {
    min-height: 42px;
    border: 1px solid var(--tg-soft-border);
    border-radius: 12px;
    color: var(--tg-text);
    background: rgba(255, 255, 255, 0.04);
    font-weight: 600;
  }
  .mobile-settings-choice.active {
    border-color: rgba(42, 171, 238, 0.48);
    color: var(--tg-accent);
    background: rgba(42, 171, 238, 0.14);
  }
  .mobile-settings-stats {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }
  .mobile-settings-stats span {
    min-height: 76px;
    border-radius: 14px;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 4px;
    background: rgba(255, 255, 255, 0.04);
  }
  .mobile-settings-stats strong {
    color: var(--tg-text);
    font-size: 22px;
  }
  .mobile-settings-stats em {
    color: var(--tg-muted);
    font-style: normal;
    font-size: 13px;
  }
  .chats-page[data-chat-theme=light] .mobile-settings-profile,
  .chats-page[data-chat-theme=light] .mobile-settings-group,
  .chats-page[data-chat-theme=light] .mobile-settings-note,
  .chats-page[data-chat-theme=light] .mobile-settings-toggle-row,
  .chats-page[data-chat-theme=light] .mobile-settings-choice,
  .chats-page[data-chat-theme=light] .mobile-settings-stats span {
    background: rgba(255, 255, 255, 0.72);
  }
  .chats-page[data-chat-theme=light] .mobile-settings-row + .mobile-settings-row {
    border-top-color: rgba(23, 33, 43, 0.08);
  }
  .message-action-sheet {
    place-items: end center;
    padding-bottom: calc(24px + env(safe-area-inset-bottom));
  }
  .message-action-sheet .message-action-preview {
    justify-self: start;
    margin-left: 8px;
  }
  .mobile-edit-screen {
    position: fixed;
    inset: 0;
    z-index: 3600;
    display: grid;
    grid-template-rows: 56px minmax(0, 1fr);
    background: var(--tg-bg);
    color: var(--tg-text);
  }
  .is-editing-message .composer {
    display: none;
  }
  .mobile-edit-screen header {
    display: grid;
    grid-template-columns: 48px 1fr 48px;
    align-items: center;
    border-bottom: 1px solid var(--tg-border);
    background: var(--tg-header);
  }
  .mobile-edit-screen header button {
    border: 0;
    color: var(--tg-accent);
    background: transparent;
  }
  .mobile-edit-screen header strong {
    text-align: center;
  }
  .mobile-edit-body {
    display: grid;
    align-content: start;
    gap: 22px;
    padding: 22px 14px;
  }
  .mobile-edit-body p {
    margin: 0;
    font-size: 16px;
    line-height: 1.35;
  }
  .mobile-edit-input {
    border: 1px solid var(--tg-soft-border);
    border-radius: 14px;
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr) 38px;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background: var(--tg-input);
  }
  .mobile-edit-input textarea {
    border: 0;
    resize: none;
    outline: none;
    color: var(--tg-text);
    background: transparent;
    font: inherit;
  }
  .mobile-edit-input button {
    width: 34px;
    height: 34px;
    border: 0;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: var(--tg-accent);
  }
}
/* Loading polish */
.chats-page {
  --tg-skeleton-base: rgba(255, 255, 255, 0.07);
  --tg-skeleton-peak: rgba(255, 255, 255, 0.16);
}

.chats-page[data-chat-theme=light] {
  --tg-skeleton-base: rgba(23, 33, 43, 0.08);
  --tg-skeleton-peak: rgba(255, 255, 255, 0.72);
}

.chat-list-skeleton {
  display: grid;
  gap: 0;
  padding: 2px 0;
}

.chat-list-status {
  margin: 8px 12px;
  border: 1px solid rgba(42, 171, 238, 0.16);
  border-radius: 14px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 10px 10px 12px;
  color: var(--tg-muted);
  background: rgba(42, 171, 238, 0.08);
  font-size: 13px;
  animation: skeleton-row-in 0.24s ease both;
}

.chat-list-status span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-list-status button {
  border: 0;
  border-radius: 999px;
  color: var(--tg-accent);
  background: rgba(42, 171, 238, 0.14);
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
}

.messages-status {
  align-self: center;
  width: min(440px, 92%);
  margin: 8px 0;
  background: rgba(23, 33, 43, 0.78);
  backdrop-filter: blur(12px);
}

.chats-page[data-chat-theme=light] .messages-status {
  background: rgba(255, 255, 255, 0.82);
}

.chat-skeleton-row {
  position: relative;
  min-height: 72px;
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr) 42px;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  overflow: hidden;
  animation: skeleton-row-in 0.28s ease both;
}

.chat-skeleton-row::after {
  content: "";
  position: absolute;
  left: 76px;
  right: 0;
  bottom: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.045);
}

.chats-page[data-chat-theme=light] .chat-skeleton-row::after {
  background: rgba(23, 33, 43, 0.08);
}

.chat-skeleton-row:nth-child(2) {
  animation-delay: 0.03s;
}

.chat-skeleton-row:nth-child(3) {
  animation-delay: 0.06s;
}

.chat-skeleton-row:nth-child(4) {
  animation-delay: 0.09s;
}

.chat-skeleton-row:nth-child(5) {
  animation-delay: 0.12s;
}

.chat-skeleton-row:nth-child(6) {
  animation-delay: 0.15s;
}

.chat-skeleton-row:nth-child(7) {
  animation-delay: 0.18s;
}

.chat-skeleton-row:nth-child(8) {
  animation-delay: 0.21s;
}

.skeleton-circle,
.skeleton-line,
.skeleton-date-pill,
.message-skeleton-bubble {
  position: relative;
  overflow: hidden;
  background: var(--tg-skeleton-base);
}

.skeleton-circle::after,
.skeleton-line::after,
.skeleton-date-pill::after,
.message-skeleton-bubble::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent);
  animation: skeleton-shimmer 1.25s ease-in-out infinite;
}

.skeleton-circle {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.skeleton-lines {
  min-width: 0;
  display: grid;
  gap: 9px;
}

.skeleton-line {
  display: block;
  height: 11px;
  border-radius: 999px;
}

.skeleton-line.title {
  width: min(170px, 78%);
  height: 13px;
}

.skeleton-line.preview {
  width: min(230px, 92%);
}

.skeleton-line.time {
  width: 38px;
  height: 9px;
  align-self: start;
  margin-top: 10px;
}

.message-list-skeleton {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0 16px;
}

.skeleton-date-pill {
  align-self: center;
  width: 86px;
  height: 26px;
  border-radius: 999px;
  margin: 6px 0 8px;
  background: rgba(109, 127, 144, 0.32);
}

.message-skeleton-bubble {
  width: min(360px, 68%);
  min-height: 56px;
  border-radius: 13px;
  display: grid;
  align-content: center;
  gap: 8px;
  padding: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
  animation: skeleton-bubble-in 0.28s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.message-skeleton-bubble.other {
  align-self: flex-start;
  border-bottom-left-radius: 4px;
}

.message-skeleton-bubble.mine {
  align-self: flex-end;
  border-bottom-right-radius: 4px;
  background: rgba(42, 171, 238, 0.16);
}

.chats-page[data-chat-theme=light] .message-skeleton-bubble.mine {
  background: rgba(91, 185, 74, 0.16);
}

.message-skeleton-bubble.wide {
  width: min(470px, 78%);
}

.message-skeleton-bubble:nth-child(2) {
  animation-delay: 0.02s;
}

.message-skeleton-bubble:nth-child(3) {
  animation-delay: 0.06s;
}

.message-skeleton-bubble:nth-child(4) {
  animation-delay: 0.1s;
}

.message-skeleton-bubble:nth-child(5) {
  animation-delay: 0.14s;
}

.message-skeleton-bubble:nth-child(6) {
  animation-delay: 0.18s;
}

.message-skeleton-bubble:nth-child(7) {
  animation-delay: 0.22s;
}

.message-skeleton-bubble:nth-child(8) {
  animation-delay: 0.26s;
}

.message-line {
  width: 92%;
  height: 10px;
}

.message-line.short {
  width: 54%;
}

.chats-page .chat-row {
  animation: chat-row-in 0.22s ease both;
}

.chats-page .message-bubble {
  transform-origin: left bottom;
  animation: telegram-message-in 0.2s cubic-bezier(0.18, 0.9, 0.22, 1.12) both;
}

.chats-page .message-bubble.mine {
  transform-origin: right bottom;
}

.chats-page .messages-date-divider {
  animation: date-pill-in 0.2s ease both;
}

@keyframes skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
@keyframes skeleton-row-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes skeleton-bubble-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes chat-row-in {
  from {
    opacity: 0;
    transform: translateX(-6px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes telegram-message-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes date-pill-in {
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .skeleton-circle::after,
  .skeleton-line::after,
  .skeleton-date-pill::after,
  .message-skeleton-bubble::after,
  .chat-skeleton-row,
  .message-skeleton-bubble,
  .chats-page .chat-row,
  .chats-page .message-bubble,
  .chats-page .messages-date-divider {
    animation: none;
  }
}
/* Final mobile native polish */
@media (max-width: 760px) {
  .chats-page {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100dvh;
    min-height: 100dvh;
    overflow: hidden;
    touch-action: manipulation;
  }
  .chats-page .chats-shell {
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
  }
  .chats-page .chats-sidebar {
    height: 100dvh;
    min-height: 0;
    display: grid;
    grid-template-rows: 54px minmax(0, 1fr) calc(58px + env(safe-area-inset-bottom));
  }
  .chats-page .chats-sidebar-head {
    height: 54px;
    min-height: 54px;
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;
    padding: 0 10px;
  }
  .chats-page .chats-sidebar-title {
    justify-self: start;
    font-size: 18px;
    letter-spacing: 0;
  }
  .chats-page .chats-sidebar-actions {
    gap: 2px;
  }
  .chats-page .chats-round-action,
  .chats-page .chats-icon {
    width: 36px;
    height: 36px;
    min-width: 36px;
    padding: 0;
  }
  .chats-page .chat-list-screen {
    min-height: 0;
    overflow: hidden;
  }
  .chats-page .chats-search-box {
    padding: 8px 10px 6px;
  }
  .chats-page .chats-search-box .chat-icon {
    left: 22px;
    width: 17px;
    height: 17px;
  }
  .chats-page .chats-search {
    height: 34px;
    border-radius: 17px;
    padding-left: 36px;
    font-size: 15px;
  }
  .chats-page .chats-filter-row {
    gap: 8px;
    padding: 4px 10px 8px;
  }
  .chats-page .chat-filter-chip {
    flex: 0 0 auto;
    min-height: 28px;
    padding: 0 10px;
    font-size: 13px;
  }
  .chats-page .chats-list {
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  .chats-page .chat-row {
    min-height: 72px;
    grid-template-columns: 50px minmax(0, 1fr);
    gap: 10px;
    padding: 8px 10px;
  }
  .chats-page .chat-row::after {
    left: 70px;
  }
  .chats-page .chat-avatar-wrap,
  .chats-page .chat-avatar {
    width: 50px;
    height: 50px;
  }
  .chats-page .chat-row-title {
    font-size: 16px;
  }
  .chats-page .chat-row-preview {
    font-size: 14px;
  }
  .chats-page .chat-row-time {
    font-size: 12px;
  }
  .chats-page .mobile-tabbar {
    height: calc(58px + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
  }
  .chats-page .chats-shell:not(.mobile-dialog-open) .chats-main {
    display: none !important;
  }
  .chats-page .chats-shell.mobile-dialog-open .chats-sidebar {
    display: none !important;
  }
  .chats-page .chats-main {
    height: 100dvh;
    min-height: 0;
    grid-template-rows: 56px auto minmax(0, 1fr) auto;
  }
  .chats-page .chats-header {
    height: 56px;
    min-height: 56px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 0 8px;
  }
  .chats-page .chats-header-main {
    flex: 1 1 auto;
    min-width: 0;
    height: 56px;
    gap: 8px;
  }
  .chats-page .chat-mobile-back {
    display: inline-flex !important;
    flex: 0 0 36px;
    margin-left: 0;
  }
  .chats-page .chats-header .chat-avatar-wrap.large,
  .chats-page .chats-header .chat-avatar.large {
    width: 38px;
    height: 38px;
    font-size: 14px;
  }
  .chats-page .chats-header-name {
    font-size: 16px;
  }
  .chats-page .chats-header-meta {
    font-size: 12px;
  }
  .chats-page .chats-header-actions {
    position: static;
    flex: 0 0 auto;
    width: auto;
    height: 36px;
    display: flex;
    align-self: center;
  }
  .chats-page .chats-header-actions .chats-icon {
    display: none;
  }
  .chats-page .chats-header-actions .chats-icon:first-child,
  .chats-page .chats-header-actions .chats-icon:nth-child(2) {
    display: inline-flex;
  }
  .chats-page .messages-panel {
    min-height: 0;
    padding: 10px 8px 8px;
    overscroll-behavior: contain;
  }
  .chats-page .message-bubble {
    max-width: 84%;
    padding: 6px 8px 4px;
  }
  .chats-page .message-bubble:has(.attachment-card.voice) {
    max-width: min(320px, 86%);
  }
  .chats-page .attachment-card.voice {
    width: min(260px, 66vw);
    height: 34px;
    border-radius: 17px;
  }
  .chats-page .message-text {
    font-size: 15px;
    line-height: 1.35;
  }
  .chats-page .composer {
    min-height: auto;
    grid-template-columns: 38px minmax(0, 1fr) 38px 44px;
    align-items: center;
    gap: 6px;
    padding: 6px 8px calc(7px + env(safe-area-inset-bottom));
  }
  .chats-page .composer > .chats-icon:first-of-type {
    grid-column: 1;
    grid-row: 1;
  }
  .chats-page .composer > .chats-icon:nth-of-type(2) {
    grid-column: 3;
    grid-row: 1;
  }
  .chats-page .composer-input {
    grid-column: 2;
    grid-row: 1;
    min-height: 40px;
    max-height: 112px;
    padding: 10px 14px;
    font-size: 16px;
  }
  .chats-page .composer-send {
    grid-column: 4;
    grid-row: 1;
    width: 44px;
    height: 44px;
    border-radius: 16px;
  }
  .chats-page .composer:has(.composer-preview),
  .chats-page .composer:has(.composer-attachments),
  .chats-page .composer:has(.emoji-panel) {
    grid-template-rows: auto auto;
  }
  .chats-page .composer:has(.composer-preview) > .chats-icon,
  .chats-page .composer:has(.composer-attachments) > .chats-icon,
  .chats-page .composer:has(.emoji-panel) > .chats-icon,
  .chats-page .composer:has(.composer-preview) .composer-input,
  .chats-page .composer:has(.composer-attachments) .composer-input,
  .chats-page .composer:has(.emoji-panel) .composer-input,
  .chats-page .composer:has(.composer-preview) .composer-send,
  .chats-page .composer:has(.composer-attachments) .composer-send,
  .chats-page .composer:has(.emoji-panel) .composer-send {
    grid-row: 2;
  }
  .chats-page .composer-preview,
  .chats-page .composer-attachments,
  .chats-page .emoji-panel {
    grid-row: 1;
  }
}
/* Native mobile polish: swipe reply, Telegram-like tails and cleaner touch menus */
.chats-page .message-bubble {
  position: relative;
  transform: translateX(var(--swipe-x, 0));
  transition: transform 0.18s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.18s ease, filter 0.18s ease;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.chats-page .message-bubble.is-swiping {
  z-index: 5;
  transition: none;
  filter: brightness(1.04);
}

.chats-page .message-bubble.swipe-ready {
  box-shadow: 0 4px 16px rgba(42, 171, 238, 0.22);
}

.message-swipe-reply {
  position: absolute;
  top: 50%;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  color: #fff;
  background: var(--tg-accent);
  box-shadow: 0 4px 14px rgba(42, 171, 238, 0.32);
  pointer-events: none;
  transform: translateY(-50%) scale(0.72);
  transition: opacity 0.12s ease, transform 0.12s ease;
}

.message-swipe-reply .chat-icon {
  width: 18px;
  height: 18px;
}

:where(.chats-page) .message-bubble.other .message-swipe-reply {
  left: -44px;
}

:where(.chats-page) .message-bubble.mine .message-swipe-reply {
  right: -44px;
}

:where(.chats-page) .message-bubble.is-swiping .message-swipe-reply {
  opacity: 0.82;
  transform: translateY(-50%) scale(1);
}

:where(.chats-page) .message-bubble.swipe-ready .message-swipe-reply {
  opacity: 1;
}

.chats-page .message-bubble.starts-group {
  margin-top: 7px;
}

.chats-page .message-bubble.grouped-prev {
  margin-top: 2px;
}

.chats-page .message-bubble.grouped-prev.other {
  border-top-left-radius: 8px;
}

.chats-page .message-bubble.grouped-prev.mine {
  border-top-right-radius: 8px;
}

.chats-page .message-bubble.grouped-next.other {
  border-bottom-left-radius: 8px;
}

.chats-page .message-bubble.grouped-next.mine {
  border-bottom-right-radius: 8px;
}

.chats-page .message-bubble.ends-group.other::after,
.chats-page .message-bubble.ends-group.mine::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 10px;
  height: 12px;
  pointer-events: none;
}

.chats-page .message-bubble.ends-group.other::after {
  left: -5px;
  border-bottom-right-radius: 10px;
  background: var(--tg-bubble-other);
}

.chats-page .message-bubble.ends-group.mine::after {
  right: -5px;
  border-bottom-left-radius: 10px;
  background: var(--tg-bubble-mine);
}

.chats-page .message-more {
  opacity: 0;
  transform: scale(0.86);
  transition: opacity 0.14s ease, transform 0.14s ease, background 0.14s ease;
}

.chats-page .message-bubble:hover .message-more,
.chats-page .message-more:focus-visible {
  opacity: 1;
  transform: scale(1);
}

.message-action-sheet {
  background: rgba(0, 0, 0, 0.62);
}

.message-action-sheet .message-action-preview {
  animation: action-preview-in 0.16s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.message-action-sheet .chat-sheet-card {
  animation: action-card-in 0.18s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.message-action-sheet .reaction-row button {
  border-radius: 999px;
  transition: transform 0.12s ease, background 0.12s ease;
}

.message-action-sheet .reaction-row button:active {
  transform: scale(0.88);
  background: rgba(255, 255, 255, 0.1);
}

.attachment-sheet-grid button {
  transition: transform 0.14s ease, opacity 0.14s ease;
}

.attachment-sheet-grid button:active {
  transform: scale(0.94);
}

.attachment-sheet-grid button.is-disabled {
  opacity: 0.54;
}

.attachment-sheet-grid button.is-disabled .attachment-sheet-icon {
  filter: grayscale(0.2);
}

@keyframes action-preview-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes action-card-in {
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 760px) {
  .chats-page .message-more {
    display: none;
  }
  .chats-page .message-bubble {
    -webkit-user-select: none;
            user-select: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .chats-page .message-bubble,
  .message-swipe-reply,
  .message-action-sheet .message-action-preview,
  .message-action-sheet .chat-sheet-card,
  .attachment-sheet-grid button {
    animation: none;
    transition: none;
  }
}
/* Telegram Web typography and text color calibration */
.chats-page {
  --tg-font-main: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif;
  --tg-font-mono: "Roboto Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  --tg-text: #f5f5f5;
  --tg-text-strong: #ffffff;
  --tg-muted: #a8b3bd;
  --tg-muted-soft: #7f91a4;
  --tg-meta: #8ea2b3;
  --tg-accent: #6ab2f2;
  --tg-accent-press: #5aa9ee;
  --tg-danger: #ff595a;
  --tg-link: #6ab2f2;
  --tg-service-text: #d5dee7;
  font-family: var(--tg-font-main);
  color: var(--tg-text);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

.chats-page[data-chat-theme=light] {
  --tg-text: #222222;
  --tg-text-strong: #000000;
  --tg-muted: #707579;
  --tg-muted-soft: #8a969f;
  --tg-meta: #8c9aa5;
  --tg-accent: #3390ec;
  --tg-accent-press: #2481cc;
  --tg-danger: #df3f40;
  --tg-link: #168acd;
  --tg-service-text: #ffffff;
  color: var(--tg-text);
}

.chats-page,
.chats-page button,
.chats-page input,
.chats-page textarea,
.chats-page select {
  font-family: var(--tg-font-main);
}

.chats-page .chats-sidebar-title,
.chats-page .chats-header-name,
.chats-page .chat-row-title,
.chats-page .mobile-settings-title span,
.chats-page .mobile-settings-profile strong,
.chats-page .chat-settings-head strong {
  color: var(--tg-text-strong);
  font-weight: 500;
  letter-spacing: 0;
}

.chats-page .chats-sidebar-title {
  font-size: 20px;
  line-height: 1.2;
}

.chats-page .chats-header-name {
  font-size: 16px;
  line-height: 1.2;
}

.chats-page .chat-row-title {
  font-size: 16px;
  line-height: 1.2;
}

.chats-page .chat-row-preview,
.chats-page .chat-row-meta,
.chats-page .chat-row-time,
.chats-page .chats-header-meta,
.chats-page .mobile-tabbar button,
.chats-page .mobile-settings-row em,
.chats-page .mobile-settings-row b,
.chats-page .mobile-settings-profile em,
.chats-page .chat-settings-head em,
.chats-page .chat-settings-toggle-row em,
.chats-page .chat-settings-note,
.chats-page .composer-input::placeholder {
  color: var(--tg-muted);
  font-weight: 400;
  letter-spacing: 0;
}

.chats-page .chat-row-preview {
  font-size: 14px;
  line-height: 1.25;
}

.chats-page .chat-row-time {
  font-size: 12px;
}

.chats-page .chats-header-meta {
  font-size: 14px;
}

.chats-page .chats-header-meta.typing,
.chats-page .chat-filter-chip.active,
.chats-page .mobile-search-tabs button.active,
.chats-page .mobile-tabbar button.active,
.chats-page .chats-icon,
.chats-page .chats-round-action,
.chats-page .chat-mobile-back,
.chats-page .mobile-settings-back,
.chats-page .message-text a,
.chats-page .link-preview-card,
.chats-page .read-indicator {
  color: var(--tg-accent);
}

.chats-page .message-text {
  color: var(--tg-text);
  font-size: 16px;
  line-height: 1.3125;
  font-weight: 400;
  letter-spacing: 0;
}

.chats-page .message-text.deleted {
  color: var(--tg-muted);
}

.chats-page .message-meta {
  color: var(--tg-meta);
  font-size: 12px;
  line-height: 1.1;
  font-weight: 400;
  letter-spacing: 0;
}

.chats-page .message-bubble.mine .message-meta {
  color: #93bdd8;
}

.chats-page[data-chat-theme=light] .message-bubble.mine .message-meta {
  color: #5c8f45;
}

.chats-page .messages-date-divider span,
.chats-page .chats-empty,
.chats-page .chat-list-status {
  color: var(--tg-service-text);
  font-size: 14px;
  font-weight: 400;
}

.chats-page[data-chat-theme=light] .chats-empty,
.chats-page[data-chat-theme=light] .chat-list-status {
  color: var(--tg-muted);
}

.chats-page .composer-input {
  color: var(--tg-text);
  font-size: 16px;
  line-height: 1.25;
  font-weight: 400;
}

.chats-page .composer-preview strong,
.chats-page .composer-attachment-chip strong,
.chats-page .message-reply-preview strong,
.chats-page .pinned-message-copy strong {
  color: var(--tg-accent);
  font-weight: 500;
}

.chats-page .composer-preview span,
.chats-page .composer-attachment-chip em,
.chats-page .message-reply-preview span,
.chats-page .message-forwarded,
.chats-page .pinned-message-copy span {
  color: var(--tg-muted);
  font-weight: 400;
}

.chats-page .message-action-sheet .chat-sheet-card > button,
.chats-page .attachment-sheet-grid strong,
.chats-page .attachment-sheet-cancel,
.chats-page .chat-settings-choice,
.chats-page .mobile-settings-choice,
.chats-page .chat-settings-row strong,
.chats-page .mobile-settings-row strong {
  font-weight: 400;
  letter-spacing: 0;
}

.chats-page .message-action-sheet .chat-sheet-card > button {
  color: #ffffff;
  font-size: 16px;
}

.chats-page .message-action-sheet .chat-sheet-card > button.danger {
  color: var(--tg-danger);
}

.chats-page .message-text code,
.chats-page .message-text pre {
  font-family: var(--tg-font-mono);
}

/* Telegram-like chat wallpaper */
.chats-page {
  --tg-wallpaper-base: #0f1d2a;
  --tg-wallpaper-size: 112px 112px;
  --tg-wallpaper-vignette:
    radial-gradient(circle at 18% 0%, rgba(42, 171, 238, 0.08), transparent 34%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.015), rgba(0, 0, 0, 0.08));
  --tg-wallpaper-pattern: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.chats-page[data-chat-theme=light] {
  --tg-wallpaper-base: #d9e6f2;
  --tg-wallpaper-size: 112px 112px;
  --tg-wallpaper-vignette:
    radial-gradient(circle at 22% 0%, rgba(51, 144, 236, 0.12), transparent 34%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.42), rgba(210, 224, 237, 0.14));
  --tg-wallpaper-pattern: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.chats-page .chats-main {
  position: relative;
  isolation: isolate;
  background: var(--tg-wallpaper-base) !important;
  overflow: hidden;
}

.chats-page .chats-main::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-color: var(--tg-wallpaper-base);
  background-image: var(--tg-wallpaper-vignette);
  background-repeat: no-repeat;
  background-size: auto;
  background-position: center top;
}

.chats-page .chats-header,
.chats-page .pinned-message-bar,
.chats-page .messages-panel,
.chats-page .composer,
.chats-page .jump-to-bottom {
  position: relative;
  z-index: 1;
}

.chats-page .messages-panel {
  background-color: transparent !important;
  background-image: var(--tg-wallpaper-pattern) !important;
  background-repeat: repeat !important;
  background-size: var(--tg-wallpaper-size) !important;
  background-position: 12px 12px !important;
}

.chats-page .composer {
  background: linear-gradient(180deg, rgba(15, 29, 42, 0), var(--tg-wallpaper-base) 22%) !important;
}

.chats-page[data-chat-theme=light] .composer {
  background: linear-gradient(180deg, rgba(217, 230, 242, 0), rgba(217, 230, 242, 0.96) 22%) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/ChatsPage/ChatsPage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oOACE;EAGF,cAAA;EACA,8CAAA;AAFF;;AAKA;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AAFF;;AAKA;;EAEE,mBAAA;EACA,oCAAA;EACA,0BAAA;EACA,8CAAA;EACA,0CAAA;AAFF;;AAKA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BAAA;AAFF;;AAKA;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,oFAAA;AAFF;;AAKA;;EAEE,WAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,wDAAA;AAFF;;AAKA;;EAEE,qCAAA;EACA,6CAAA;AAFF;;AAKA;EACE,qCAAA;AAFF;;AAKA;;;EAGE,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oDAAA;AAFF;;AAKA;;;EAGE,2BAAA;AAFF;;AAKA;;EAEE,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,qDAAA;EACA,WAAA;EACA,kBAAA;AAFF;;AAKA;;EAEE,mBAAA;EACA,WAAA;EACA,kBAAA;AAFF;;AAKA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,gBAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,wDAAA;EACA,aAAA;EACA,QAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAFF;;AAKA;EACE,qCAAA;EACA,2EAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,8BAAA;EACA,aAAA;EACA,4CAAA;AAFF;;AAKA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,+CAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,+BAAA;AAFF;;AAKA;EACE,oBAAA;EACA,qDAAA;EACA,WAAA;EACA,+BAAA;AAFF;;AAKA;EACE,sBAAA;EACA,gBAAA;EACA,uCAAA;EACA,cAAA;EACA,8BAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,4CAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;EACA,QAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE;IACE,0BAAA;IACA,UAAA;EAFF;EAIA;IACE,wBAAA;IACA,UAAA;EAFF;AACF;AAKA;EACE;IACE,0BAAA;EAHF;EAMA;IACE,gBAAA;EAJF;EAOA;IACE,gBAAA;EALF;EAQA;IACE,WAAA;EANF;EASA;IACE,YAAA;EAPF;AACF;AAUA;EACE;IACE,mBAAA;EARF;EAWA;IACE,sBAAA;IACA,oBAAA;EATF;EAYA;IACE,aAAA;IACA,+BAAA;EAVF;EAaA;IACE,cAAA;EAXF;EAcA;IACE,0BAAA;EAZF;EAeA;IACE,WAAA;EAbF;AACF;AAgBA,yCAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sCAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mCAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;AAdF;;AAiBA;EACE,0DAAA;EACA,MAAA;EACA,eAAA;EACA,+BAAA;EACA,UAAA;AAdF;;AAiBA;;EAEE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,6BAAA;EACA,wCAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,yKACE;AAfJ;;AAmBA;EACE,mKACE;AAjBJ;;AAqBA;EACE,aAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,2BAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,oBAAA;AAlBF;;AAqBA;;EAEE,kCAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,uBAAA;EACA,oCAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,YAAA;AAlBF;;AAqBA;EACE,uBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,4BAAA;EACA,yCAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,yCAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,+CAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,kCAAA;AAlBF;;AAqBA;EACE,iCAAA;EACA,qBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,gBAAA;AAlBF;;AAqBA;;EAEE,gBAAA;EACA,iBAAA;AAlBF;;AAqBA;;;EAGE,uCAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,uBAAA;AAlBF;;AAqBA;EACE,sBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,uBAAA;AAlBF;;AAqBA;;EAEE,aAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAlBF;;AAqBA;;EAEE,SAAA;EACA,oBAAA;EACA,oCAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,uBAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,QAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,aAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,uCAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,+CAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,oCAAA;EACA,qBAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,UAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,oBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,aAAA;EACA,QAAA;AAlBF;;AAqBA;;;EAGE,SAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,qCAAA;EACA,iCAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,4CAAA;EACA,gCAAA;AAlBF;;AAqBA;EACE,4BAAA;AAlBF;;AAqBA;EACE,2BAAA;AAlBF;;AAqBA;EACE,aAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,wDAAA;EACA,kCAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,uBAAA;EACA,6BAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,gEAAA;EACA,6CAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AAlBF;;AAqBA;;;EAGE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlBF;;AAqBA;;;EAGE,sBAAA;EACA,kBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qCAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,qCAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAlBF;;AAqBA;;EAEE,gBAAA;EACA,uCAAA;EACA,mBAAA;EACA,qBAAA;EACA,qCAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,sCAAA;EACA,uBAAA;EACA,oCAAA;AAlBF;;AAqBA;EACE,aAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,QAAA;EACA,qCAAA;AAlBF;;AAqBA;EACE,eAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,+CAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,uBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,eAAA;AAlBF;;AAqBA;EACE;IACE,0BAAA;EAlBF;EAqBA;IACE,eAAA;EAnBF;EAsBA;IACE,kBAAA;EApBF;AACF;AAuBA,6BAAA;AACA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,gCAAA;EACA,sCAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,qFAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,gCAAA;EACA,wCAAA;AArBF;;AAwBA;EACE,aAAA;EACA,2CAAA;EACA,MAAA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;AArBF;;AAwBA;;EAEE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,MAAA;EACA,6BAAA;EACA,wCAAA;AArBF;;AAwBA;EACE,aAAA;EACA,aAAA;EACA,iDAAA;EACA,yPACE;EAGF,2CAAA;AAxBF;;AA2BA;EACE,mPACE;EAGF,2CAAA;AA3BF;;AA8BA;;EAEE,aAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,yCAAA;EACA,4BAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA3BF;;AA8BA;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA3BF;;AA8BA;;;EAGE,uBAAA;EACA,oCAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,qBAAA;EACA,4BAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;AA3BF;;AA8BA;;EAEE,gBAAA;EACA,aAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,mBAAA;AA3BF;;AA8BA;;;EAGE,yBAAA;EACA,8CAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,4BAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,aAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,oCAAA;EACA,6BAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,aAAA;EACA,UAAA;EACA,MAAA;EACA,cAAA;EACA,6BAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,oCAAA;AA3BF;;AA8BA;EACE,oCAAA;EACA,yBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,QAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AA3BF;;AA8BA;;EAEE,gBAAA;AA3BF;;AA8BA;EACE,sBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,cAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,4BAAA;EACA,yCAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AA3BF;;AA8BA;EACE,YAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA3BF;;AA8BA;EACE,aAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,SAAA;EACA,yCAAA;EACA,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oCAAA;EACA,qBAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,kCAAA;AA3BF;;AA8BA;EACE,uBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,6BAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;EACA,+BAAA;AA3BF;;AA8BA;EACE,sBAAA;EACA,8BAAA;EACA,kCAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,8CAAA;EACA,+BAAA;EACA,iCAAA;EACA,qBAAA;AA3BF;;AA8BA;;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,UAAA;EACA,6CAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,0CAAA;AA3BF;;AA8BA;EACE,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,6BAAA;AA3BF;;AA8BA;EACE,gCAAA;AA3BF;;AA8BA;EACE,uBAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,oCAAA;AA3BF;;AA8BA;;;EAGE,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,mCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AA3BF;;AA8BA;;EAEE,6BAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;AA3BF;;AA8BA;;EAEE,gBAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,oBAAA;EACA,oCAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,QAAA;EACA,0FAAA;AA3BF;;AA8BA;EACE,oFAAA;AA3BF;;AA8BA;EACE,aAAA;AA3BF;;AA8BA;EACE,2BAAA;EACA,4CAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,4CAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,4BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,8CAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,kCAAA;AA3BF;;AA8BA;;EAEE,iBAAA;EACA,SAAA;EACA,uCAAA;EACA,mBAAA;EACA,qCAAA;EACA,iBAAA;EACA,4CAAA;AA3BF;;AA8BA;;EAEE,kCAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,+CAAA;EACA,QAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,oBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AA3BF;;AA8BA;;EAEE,SAAA;EACA,mBAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AA3BF;;AA8BA;;EAEE,eAAA;EACA,kCAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,kCAAA;AA3BF;;AA8BA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,aAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,eAAA;AA3BF;;AA8BA;;;EAGE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,kCAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,kCAAA;AA3BF;;AA8BA;EACE;IACE,2CAAA;EA3BF;EA8BA;IACE,cAAA;EA5BF;AACF;AA+BA;EACE;IACE,aAAA;IACA,0BAAA;IACA,YAAA;IACA,+BAAA;IACA,iBAAA;EA7BF;EAgCA;IACE,eAAA;IACA,iBAAA;EA9BF;EAiCA;IACE,iBAAA;EA/BF;EAkCA;IACE,kBAAA;EAhCF;EAmCA;IACE,cAAA;EAjCF;EAoCA;IACE,oDAAA;IACA,yDAAA;EAlCF;EAqCA;IACE,MAAA;EAnCF;AACF;AAsCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AApCF;;AAuCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AApCF;;AAuCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;AApCF;;AAuCA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,QAAA;EACA,SAAA;EACA,8BAAA;AApCF;;AAuCA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;AApCF;;AAuCA;EACE,aAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;AApCF;;AAuCA;EACE,cAAA;AApCF;;AAuCA;;;EAGE,WAAA;EACA,YAAA;AApCF;;AAuCA;EACE,aAAA;AApCF;;AAuCA;EACE,kBAAA;AApCF;;AAuCA;EACE,WAAA;AApCF;;AAuCA;EACE,WAAA;AApCF;;AAuCA;EACE,WAAA;AApCF;;AAuCA;EACE,WAAA;AApCF;;AAuCA;EACE,eAAA;AApCF;;AAuCA;EACE,4BAAA;AApCF;;AAuCA;EACE,6BAAA;AApCF;;AAuCA;;EAEE,+BAAA;AApCF;;AAuCA;;EAEE,gCAAA;AApCF;;AAuCA;;EAEE,aAAA;AApCF;;AAuCA;EACE,+EAAA;AApCF;;AAuCA;EACE,6BAAA;EACA,qBAAA;AApCF;;AAuCA;EACE,0BAAA;AApCF;;AAuCA;EACE,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,kDAAA;EACA,iBAAA;AApCF;;AAuCA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kCAAA;AApCF;;AAuCA;EACE,qCAAA;AApCF;;AAuCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;AApCF;;AAuCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6CAAA;EACA,eAAA;AApCF;;AAuCA;;EAEE,aAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,WAAA;AApCF;;AAuCA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;AApCF;;AAuCA;;EAEE,WAAA;EACA,YAAA;AApCF;;AAuCA;EACE,iBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AApCF;;AAuCA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,4CAAA;AApCF;;AAuCA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AApCF;;AAuCA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,eAAA;EACA,gBAAA;AApCF;;AAuCA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,qCAAA;AApCF;;AAuCA;EACE;IACE,2BAAA;IACA,aAAA;EApCF;EAuCA;IACE,aAAA;EArCF;EAwCA;IACE,aAAA;EAtCF;EAyCA;IACE,oBAAA;IACA,iBAAA;EAvCF;EA0CA;IACE,gBAAA;EAxCF;EA2CA;IACE,aAAA;EAzCF;EA4CA;IACE,cAAA;EA1CF;EA6CA;IACE,WAAA;IACA,eAAA;EA3CF;EA8CA;IACE,WAAA;IACA,YAAA;EA5CF;AACF;AA+CA,8BAAA;AACA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,gCAAA;EACA,sCAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AA7CF;;AAgDA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gCAAA;EACA,yCAAA;EACA,sBAAA;EACA,mBAAA;AA7CF;;AAgDA;EACE,cAAA;EACA,aAAA;EACA,2CAAA;EACA,wBAAA;AA7CF;;AAgDA;EACE,6BAAA;EACA,wCAAA;AA7CF;;AAgDA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,iDAAA;EACA,wWACE;EAIF,8BAAA;EACA,wDAAA;AAjDF;;AAoDA;EACE,6WACE;EAIF,8BAAA;EACA,wDAAA;AArDF;;AAwDA;;EAEE,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,yCAAA;AArDF;;AAwDA;EACE,aAAA;EACA,+CAAA;EACA,QAAA;EACA,qBAAA;AArDF;;AAwDA;EACE,eAAA;EACA,gBAAA;AArDF;;AAwDA;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AArDF;;AAwDA;;;EAGE,uBAAA;EACA,oCAAA;AArDF;;AAwDA;EACE,iBAAA;EACA,6BAAA;AArDF;;AAwDA;EACE,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;AArDF;;AAwDA;;EAEE,sBAAA;AArDF;;AAwDA;EACE,qBAAA;EACA,6BAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AArDF;;AAwDA;EACE,cAAA;EACA,oCAAA;AArDF;;AAwDA;EACE,6BAAA;EACA,oCAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,0CAAA;EACA,SAAA;EACA,iBAAA;AArDF;;AAwDA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,sCAAA;AArDF;;AAwDA;EACE,kCAAA;AArDF;;AAwDA;EACE,sCAAA;AArDF;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,qDAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,qDAAA;AArDF;;AAwDA;EACE,qDAAA;AArDF;;AAwDA;EACE,qDAAA;AArDF;;AAwDA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AArDF;;AAwDA;;EAEE,sBAAA;AArDF;;AAwDA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AArDF;;AAwDA;EACE,sBAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,uBAAA;EACA,eAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,kCAAA;EACA,yCAAA;AArDF;;AAwDA;EACE,qCAAA;AArDF;;AAwDA;EACE,gDAAA;EACA,QAAA;EACA,uBAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,0BAAA;EACA,eAAA;AArDF;;AAwDA;EACE,0BAAA;EACA,mBAAA;EACA,oBAAA;EACA,yCAAA;AArDF;;AAwDA;EACE,kCAAA;EACA,8BAAA;AArDF;;AAwDA;EACE,SAAA;EACA,iCAAA;EACA,+BAAA;AArDF;;AAwDA;;EAEE,+BAAA;AArDF;;AAwDA;;EAEE,gCAAA;AArDF;;AAwDA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;;;EAGE,oCAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,+CAAA;EACA,oDAAA;EACA,0EAAA;AArDF;;AAwDA;EACE,0FAAA;AArDF;;AAwDA;EACE,uBAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,cAAA;EACA,4BAAA;EACA,gBAAA;AArDF;;AAwDA;;;EAGE,iBAAA;AArDF;;AAwDA;;;EAGE,kCAAA;EACA,8BAAA;AArDF;;AAwDA;;;EAGE,qCAAA;AArDF;;AAwDA;EACE,oCAAA;EACA,YAAA;EACA,2BAAA;AArDF;;AAwDA;EACE,oBAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AArDF;;AAwDA;EACE,qCAAA;EACA,sBAAA;AArDF;;AAwDA;EACE;IACE,2CAAA;EArDF;EAwDA;IACE,cAAA;EAtDF;AACF;AAyDA;EACE;IACE,cAAA;IACA,0BAAA;EAvDF;EA0DA;;IAEE,YAAA;IACA,gBAAA;EAxDF;EA2DA;IACE,iDAAA;EAzDF;EA4DA;;;IAGE,aAAA;EA1DF;EA6DA;IACE,sBAAA;EA3DF;EA8DA;IACE,cAAA;EA5DF;EA+DA;IACE,wDAAA;IACA,oDAAA;EA7DF;EAgEA;IACE,WAAA;IACA,gDAAA;EA9DF;AACF;AAiEA,qCAAA;AACA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AA/DF;;AAkEA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AA/DF;;AAkEA;;EAEE,aAAA;AA/DF;;AAkEA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qCAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,YAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AA/DF;;AAkEA;EACE,aAAA;AA/DF;;AAkEA;EACE,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AA/DF;;AAkEA;EACE,uBAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AA/DF;;AAkEA;EACE,eAAA;AA/DF;;AAkEA;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,2BAAA;EACA,+BAAA;AA/DF;;AAkEA;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,oBAAA;AA/DF;;AAkEA;EACE,+BAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;EACA,UAAA;EACA,MAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;EACA,kCAAA;EACA,2BAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,qCAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,kDAAA;AA/DF;;AAkEA;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,YAAA;AA/DF;;AAkEA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AA/DF;;AAkEA;EACE,+CAAA;AA/DF;;AAkEA;EACE,cAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,YAAA;AA/DF;;AAkEA;EACE,uBAAA;EACA,SAAA;EACA,wDAAA;EACA,2BAAA;EACA,+BAAA;AA/DF;;AAkEA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,qCAAA;EACA,cAAA;EACA,uBAAA;EACA,kCAAA;EACA,2BAAA;AA/DF;;AAkEA;EACE,SAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;AA/DF;;AAkEA;EACE,eAAA;EACA,gBAAA;AA/DF;;AAkEA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,YAAA;AA/DF;;AAkEA;;EACsB,qDAAA;AA9DtB;;AA+DA;;EACwB,qDAAA;AA3DxB;;AA4DA;;EACwB,qDAAA;AAxDxB;;AAyDA;;EACuB,qDAAA;AArDvB;;AAsDA;;EACqB,qDAAA;AAlDrB;;AAmDA;EAAsB,qDAAA;AA/CtB;;AAiDA;EACE,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,eAAA;AA9CF;;AAiDA;EACE,oBAAA;EACA,UAAA;EACA,gBAAA;AA9CF;;AAiDA;;EAEE,eAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA9CF;;AAiDA;EACE,MAAA;EACA,YAAA;EACA,oCAAA;EACA,0EAAA;AA9CF;;AAiDA;;;EAGE,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;AA9CF;;AAiDA;EACE,kBAAA;EACA,eAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,mBAAA;AA9CF;;AAiDA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AA9CF;;AAiDA;EACE,2BAAA;EACA,gCAAA;EACA,gBAAA;AA9CF;;AAiDA;EACE,SAAA;EACA,SAAA;EACA,2DAAA;EACA,uEAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AA9CF;;AAiDA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;AA9CF;;AAiDA;EACE,kBAAA;AA9CF;;AAiDA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;AA9CF;;AAiDA;;EAEE,cAAA;AA9CF;;AAiDA;EACE,eAAA;AA9CF;;AAiDA;EACE,gCAAA;EACA,eAAA;AA9CF;;AAiDA;EACE,aAAA;AA9CF;;AAiDA;EACE;IACE,YAAA;IACA,+CAAA;IACA,aAAA;IACA,qCAAA;IACA,qCAAA;IACA,+CAAA;IACA,yCAAA;EA9CF;EAiDA;IACE,kBAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;IACA,qBAAA;IACA,QAAA;IACA,cAAA;IACA,uBAAA;IACA,eAAA;EA/CF;EAkDA;IACE,uBAAA;EAhDF;EAmDA;IACE,WAAA;IACA,YAAA;EAjDF;EAoDA;IACE,kBAAA;IACA,QAAA;IACA,uBAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;EAlDF;EAqDA;;IAEE,aAAA;EAnDF;EAsDA;IACE,SAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,cAAA;IACA,oBAAA;IACA,wBAAA;EApDF;EAuDA;IACE,YAAA;IACA,aAAA;IACA,oCAAA;IACA,mBAAA;IACA,qBAAA;EArDF;EAwDA;IACE,cAAA;IACA,oBAAA;IACA,gBAAA;EAtDF;EAyDA;IACE,cAAA;IACA,SAAA;IACA,uBAAA;IACA,uBAAA;IACA,iBAAA;IACA,eAAA;EAvDF;EA0DA;IACE,oCAAA;EAxDF;EA2DA;IACE,cAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;EAzDF;EA4DA;IACE,WAAA;IACA,YAAA;EA1DF;EA6DA;IACE,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,aAAA;IACA,+CAAA;IACA,mBAAA;IACA,SAAA;IACA,aAAA;IACA,qBAAA;IACA,qCAAA;IACA,gBAAA;EA3DF;EA8DA;IACE,YAAA;IACA,aAAA;IACA,QAAA;EA5DF;EA+DA;IACE,eAAA;EA7DF;EAgEA;IACE,sBAAA;IACA,kBAAA;EA9DF;EAiEA;IACE,cAAA;EA/DF;EAkEA;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,qCAAA;EAhEF;EAmEA;IACE,gBAAA;IACA,WAAA;IACA,SAAA;IACA,aAAA;IACA,yDAAA;IACA,mBAAA;IACA,SAAA;IACA,iBAAA;IACA,qBAAA;IACA,uBAAA;IACA,gBAAA;EAjEF;EAoEA;IACE,+CAAA;EAlEF;EAqEA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EAnEF;EAsEA;IACE,WAAA;IACA,YAAA;EApEF;EAuEA;IACE,gBAAA;EArEF;EAwEA;;IAEE,sBAAA;IACA,kBAAA;IACA,gBAAA;EAtEF;EAyEA;IACE,WAAA;IACA,YAAA;IACA,yBAAA;IACA,sBAAA;EAvEF;EA0EA;IACE,gBAAA;IACA,mBAAA;IACA,kBAAA;IACA,sBAAA;IACA,qCAAA;IACA,eAAA;IACA,iBAAA;EAxEF;EA2EA;IACE,cAAA;IACA,kCAAA;EAzEF;EA4EA;IACE,aAAA;IACA,SAAA;EA1EF;EA6EA;IACE,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,0CAAA;IACA,mBAAA;IACA,SAAA;IACA,aAAA;IACA,qBAAA;IACA,qCAAA;EA3EF;EA8EA;IACE,YAAA;IACA,aAAA;IACA,QAAA;EA5EF;EA+EA;;IAEE,gBAAA;EA7EF;EAgFA;IACE,sBAAA;IACA,kBAAA;IACA,eAAA;EA9EF;EAiFA;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,mBAAA;IACA,YAAA;IACA,qCAAA;IACA,iCAAA;EA/EF;EAkFA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,cAAA;IACA,gBAAA;IACA,4CAAA;IACA,gCAAA;EAhFF;EAmFA;IACE,4BAAA;EAjFF;EAoFA;IACE,2BAAA;EAlFF;EAqFA;;IAEE,aAAA;EAnFF;EAsFA;IACE,kBAAA;IACA,sBAAA;IACA,eAAA;EApFF;EAuFA;IACE,aAAA;IACA,gDAAA;IACA,QAAA;EArFF;EAwFA;IACE,gDAAA;EAtFF;EAyFA;IACE,gBAAA;IACA,uCAAA;IACA,mBAAA;IACA,qBAAA;IACA,qCAAA;IACA,gBAAA;EAvFF;EA0FA;IACE,sCAAA;IACA,uBAAA;IACA,oCAAA;EAxFF;EA2FA;IACE,aAAA;IACA,gDAAA;IACA,QAAA;EAzFF;EA4FA;IACE,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,qBAAA;IACA,QAAA;IACA,qCAAA;EA1FF;EA6FA;IACE,qBAAA;IACA,eAAA;EA3FF;EA8FA;IACE,sBAAA;IACA,kBAAA;IACA,eAAA;EA5FF;EA+FA;;;;;;IAME,qCAAA;EA7FF;EAgGA;IACE,wCAAA;EA9FF;EAiGA;IACE,uBAAA;IACA,wDAAA;EA/FF;EAkGA;IACE,mBAAA;IACA,gBAAA;EAhGF;EAmGA;IACE,eAAA;IACA,QAAA;IACA,aAAA;IACA,aAAA;IACA,uCAAA;IACA,wBAAA;IACA,qBAAA;EAjGF;EAoGA;IACE,aAAA;EAlGF;EAqGA;IACE,aAAA;IACA,oCAAA;IACA,mBAAA;IACA,yCAAA;IACA,4BAAA;EAnGF;EAsGA;IACE,SAAA;IACA,uBAAA;IACA,uBAAA;EApGF;EAuGA;IACE,kBAAA;EArGF;EAwGA;IACE,aAAA;IACA,oBAAA;IACA,SAAA;IACA,kBAAA;EAtGF;EAyGA;IACE,SAAA;IACA,eAAA;IACA,iBAAA;EAvGF;EA0GA;IACE,uCAAA;IACA,mBAAA;IACA,aAAA;IACA,+CAAA;IACA,mBAAA;IACA,QAAA;IACA,YAAA;IACA,2BAAA;EAxGF;EA2GA;IACE,SAAA;IACA,YAAA;IACA,aAAA;IACA,qBAAA;IACA,uBAAA;IACA,aAAA;EAzGF;EA4GA;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,4BAAA;EA1GF;AACF;AA6GA,mBAAA;AACA;EACE,6CAAA;EACA,6CAAA;AA3GF;;AA8GA;EACE,0CAAA;EACA,6CAAA;AA3GF;;AA8GA;EACE,aAAA;EACA,MAAA;EACA,cAAA;AA3GF;;AA8GA;EACE,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,eAAA;EACA,0CAAA;AA3GF;;AA8GA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3GF;;AA8GA;EACE,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AA3GF;;AA8GA;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,2BAAA;AA3GF;;AA8GA;EACE,qCAAA;AA3GF;;AA8GA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;AA3GF;;AA8GA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,sCAAA;AA3GF;;AA8GA;EACE,kCAAA;AA3GF;;AA8GA;EAAkC,sBAAA;AA1GlC;;AA2GA;EAAkC,sBAAA;AAvGlC;;AAwGA;EAAkC,sBAAA;AApGlC;;AAqGA;EAAkC,sBAAA;AAjGlC;;AAkGA;EAAkC,sBAAA;AA9FlC;;AA+FA;EAAkC,sBAAA;AA3FlC;;AA4FA;EAAkC,sBAAA;AAxFlC;;AA0FA;;;;EAIE,kBAAA;EACA,gBAAA;EACA,mCAAA;AAvFF;;AA0FA;;;;EAIE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,qFAAA;EACA,sDAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAvFF;;AA0FA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AAvFF;;AA0FA;EACE,cAAA;EACA,YAAA;EACA,oBAAA;AAvFF;;AA0FA;EACE,sBAAA;EACA,YAAA;AAvFF;;AA0FA;EACE,sBAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAvFF;;AA0FA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAvFF;;AA0FA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,qCAAA;AAvFF;;AA0FA;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,aAAA;EACA,yCAAA;EACA,uEAAA;AAvFF;;AA0FA;EACE,sBAAA;EACA,8BAAA;AAvFF;;AA0FA;EACE,oBAAA;EACA,+BAAA;EACA,oCAAA;AAvFF;;AA0FA;EACE,mCAAA;AAvFF;;AA0FA;EACE,sBAAA;AAvFF;;AA0FA;EAAwC,sBAAA;AAtFxC;;AAuFA;EAAwC,sBAAA;AAnFxC;;AAoFA;EAAwC,qBAAA;AAhFxC;;AAiFA;EAAwC,sBAAA;AA7ExC;;AA8EA;EAAwC,sBAAA;AA1ExC;;AA2EA;EAAwC,sBAAA;AAvExC;;AAwEA;EAAwC,sBAAA;AApExC;;AAsEA;EACE,UAAA;EACA,YAAA;AAnEF;;AAsEA;EACE,UAAA;AAnEF;;AAsEA;EACE,sCAAA;AAnEF;;AAsEA;EACE,6BAAA;EACA,4EAAA;AAnEF;;AAsEA;EACE,8BAAA;AAnEF;;AAsEA;EACE,sCAAA;AAnEF;;AAsEA;EACE;IACE,2BAAA;EAnEF;AACF;AAsEA;EACE;IACE,UAAA;IACA,0BAAA;EApEF;EAsEA;IACE,UAAA;IACA,wBAAA;EApEF;AACF;AAuEA;EACE;IACE,UAAA;IACA,uCAAA;EArEF;EAuEA;IACE,UAAA;IACA,iCAAA;EArEF;AACF;AAwEA;EACE;IACE,UAAA;IACA,2BAAA;EAtEF;EAwEA;IACE,UAAA;IACA,wBAAA;EAtEF;AACF;AAyEA;EACE;IACE,UAAA;IACA,uCAAA;EAvEF;EAyEA;IACE,UAAA;IACA,iCAAA;EAvEF;AACF;AA0EA;EACE;IACE,UAAA;IACA,uCAAA;EAxEF;EA0EA;IACE,UAAA;IACA,iCAAA;EAxEF;AACF;AA2EA;EACE;;;;;;;;;IASE,eAAA;EAzEF;AACF;AA4EA,+BAAA;AACA;EACE;IACE,eAAA;IACA,QAAA;IACA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,0BAAA;EA1EF;EA6EA;IACE,cAAA;IACA,aAAA;IACA,gBAAA;EA3EF;EA8EA;IACE,cAAA;IACA,aAAA;IACA,aAAA;IACA,gFAAA;EA5EF;EA+EA;IACE,YAAA;IACA,gBAAA;IACA,aAAA;IACA,+CAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;EA7EF;EAgFA;IACE,mBAAA;IACA,eAAA;IACA,iBAAA;EA9EF;EAiFA;IACE,QAAA;EA/EF;EAkFA;;IAEE,WAAA;IACA,YAAA;IACA,eAAA;IACA,UAAA;EAhFF;EAmFA;IACE,aAAA;IACA,gBAAA;EAjFF;EAoFA;IACE,qBAAA;EAlFF;EAqFA;IACE,UAAA;IACA,WAAA;IACA,YAAA;EAnFF;EAsFA;IACE,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;EApFF;EAuFA;IACE,QAAA;IACA,qBAAA;EArFF;EAwFA;IACE,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAtFF;EAyFA;IACE,aAAA;IACA,gBAAA;IACA,4BAAA;EAvFF;EA0FA;IACE,gBAAA;IACA,0CAAA;IACA,SAAA;IACA,iBAAA;EAxFF;EA2FA;IACE,UAAA;EAzFF;EA4FA;;IAEE,WAAA;IACA,YAAA;EA1FF;EA6FA;IACE,eAAA;EA3FF;EA8FA;IACE,eAAA;EA5FF;EA+FA;IACE,eAAA;EA7FF;EAgGA;IACE,gDAAA;IACA,2CAAA;EA9FF;EAiGA;IACE,wBAAA;EA/FF;EAkGA;IACE,wBAAA;EAhGF;EAmGA;IACE,cAAA;IACA,aAAA;IACA,iDAAA;EAjGF;EAoGA;IACE,YAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,8BAAA;IACA,QAAA;IACA,cAAA;EAlGF;EAqGA;IACE,cAAA;IACA,YAAA;IACA,YAAA;IACA,QAAA;EAnGF;EAsGA;IACE,+BAAA;IACA,cAAA;IACA,cAAA;EApGF;EAuGA;;IAEE,WAAA;IACA,YAAA;IACA,eAAA;EArGF;EAwGA;IACE,eAAA;EAtGF;EAyGA;IACE,eAAA;EAvGF;EA0GA;IACE,gBAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;EAxGF;EA2GA;IACE,aAAA;EAzGF;EA4GA;;IAEE,oBAAA;EA1GF;EA6GA;IACE,aAAA;IACA,qBAAA;IACA,4BAAA;EA3GF;EA8GA;IACE,cAAA;IACA,oBAAA;EA5GF;EA+GA;IACE,0BAAA;EA7GF;EAgHA;IACE,uBAAA;IACA,YAAA;IACA,mBAAA;EA9GF;EAiHA;IACE,eAAA;IACA,iBAAA;EA/GF;EAkHA;IACE,gBAAA;IACA,oDAAA;IACA,mBAAA;IACA,QAAA;IACA,wDAAA;EAhHF;EAmHA;IACE,cAAA;IACA,WAAA;EAjHF;EAoHA;IACE,cAAA;IACA,WAAA;EAlHF;EAqHA;IACE,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,eAAA;EAnHF;EAsHA;IACE,cAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;EApHF;EAuHA;;;IAGE,6BAAA;EArHF;EAwHA;;;;;;;;;IASE,WAAA;EAtHF;EAyHA;;;IAGE,WAAA;EAvHF;AACF;AA0HA,mFAAA;AACA;EACE,kBAAA;EACA,wCAAA;EACA,oGAAA;EACA,mBAAA;EACA,wCAAA;AAxHF;;AA2HA;EACE,UAAA;EACA,gBAAA;EACA,wBAAA;AAxHF;;AA2HA;EACE,+CAAA;AAxHF;;AA2HA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,+CAAA;EACA,oBAAA;EACA,uCAAA;EACA,oDAAA;AAxHF;;AA2HA;EACE,WAAA;EACA,YAAA;AAxHF;;AA2HA;EACE,WAAA;AAxHF;;AA2HA;EACE,YAAA;AAxHF;;AA2HA;EACE,aAAA;EACA,oCAAA;AAxHF;;AA2HA;EACE,UAAA;AAxHF;;AA2HA;EACE,eAAA;AAxHF;;AA2HA;EACE,eAAA;AAxHF;;AA2HA;EACE,2BAAA;AAxHF;;AA2HA;EACE,4BAAA;AAxHF;;AA2HA;EACE,8BAAA;AAxHF;;AA2HA;EACE,+BAAA;AAxHF;;AA2HA;;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAxHF;;AA2HA;EACE,UAAA;EACA,gCAAA;EACA,kCAAA;AAxHF;;AA2HA;EACE,WAAA;EACA,+BAAA;EACA,iCAAA;AAxHF;;AA2HA;EACE,UAAA;EACA,sBAAA;EACA,2EAAA;AAxHF;;AA2HA;;EAEE,UAAA;EACA,mBAAA;AAxHF;;AA2HA;EACE,+BAAA;AAxHF;;AA2HA;EACE,sEAAA;AAxHF;;AA2HA;EACE,mEAAA;AAxHF;;AA2HA;EACE,oBAAA;EACA,uDAAA;AAxHF;;AA2HA;EACE,sBAAA;EACA,oCAAA;AAxHF;;AA2HA;EACE,oDAAA;AAxHF;;AA2HA;EACE,sBAAA;AAxHF;;AA2HA;EACE,aAAA;AAxHF;;AA2HA;EACE,sBAAA;AAxHF;;AA2HA;EACE;IACE,UAAA;IACA,sCAAA;EAxHF;EA0HA;IACE,UAAA;IACA,iCAAA;EAxHF;AACF;AA2HA;EACE;IACE,UAAA;IACA,uCAAA;EAzHF;EA2HA;IACE,UAAA;IACA,iCAAA;EAzHF;AACF;AA4HA;EACE;IACE,aAAA;EA1HF;EA6HA;IACE,yBAAA;YAAA,iBAAA;EA3HF;AACF;AA8HA;EACE;;;;;IAKE,eAAA;IACA,gBAAA;EA5HF;AACF;AA+HA,uDAAA;AACA;EACE,uKAAA;EACA,8FAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gCAAA;EACA,qBAAA;EACA,mCAAA;EACA,kCAAA;AA7HF;;AAgIA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;AA7HF;;AAgIA;;;;;EAKE,gCAAA;AA7HF;;AAgIA;;;;;;EAME,4BAAA;EACA,gBAAA;EACA,iBAAA;AA7HF;;AAgIA;EACE,eAAA;EACA,gBAAA;AA7HF;;AAgIA;EACE,eAAA;EACA,gBAAA;AA7HF;;AAgIA;EACE,eAAA;EACA,gBAAA;AA7HF;;AAgIA;;;;;;;;;;;;EAYE,sBAAA;EACA,gBAAA;EACA,iBAAA;AA7HF;;AAgIA;EACE,eAAA;EACA,iBAAA;AA7HF;;AAgIA;EACE,eAAA;AA7HF;;AAgIA;EACE,eAAA;AA7HF;;AAgIA;;;;;;;;;;;EAWE,uBAAA;AA7HF;;AAgIA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AA7HF;;AAgIA;EACE,sBAAA;AA7HF;;AAgIA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AA7HF;;AAgIA;EACE,cAAA;AA7HF;;AAgIA;EACE,cAAA;AA7HF;;AAgIA;;;EAGE,6BAAA;EACA,eAAA;EACA,gBAAA;AA7HF;;AAgIA;;EAEE,sBAAA;AA7HF;;AAgIA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA7HF;;AAgIA;;;;EAIE,uBAAA;EACA,gBAAA;AA7HF;;AAgIA;;;;;EAKE,sBAAA;EACA,gBAAA;AA7HF;;AAgIA;;;;;;;EAOE,gBAAA;EACA,iBAAA;AA7HF;;AAgIA;EACE,cAAA;EACA,eAAA;AA7HF;;AAgIA;EACE,uBAAA;AA7HF;;AAgIA;;EAEE,gCAAA;AA7HF;;AAgIA,iCAAA;AACA;EACE,4BAAA;EACA,gCAAA;EACA;;4EAAA;EAGA,+DAAA;AA7HF;;AAgIA;EACE,4BAAA;EACA,gCAAA;EACA;;iFAAA;EAGA,+DAAA;AA7HF;;AAgIA;EACE,kBAAA;EACA,kBAAA;EACA,+CAAA;EACA,gBAAA;AA7HF;;AAgIA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,0CAAA;EACA,8CAAA;EACA,4BAAA;EACA,qBAAA;EACA,+BAAA;AA7HF;;AAgIA;;;;;EAKE,kBAAA;EACA,UAAA;AA7HF;;AAgIA;EACE,wCAAA;EACA,wDAAA;EACA,oCAAA;EACA,oDAAA;EACA,yCAAA;AA7HF;;AAgIA;EACE,iGAAA;AA7HF;;AAgIA;EACE,qGAAA;AA7HF","sourcesContent":[".chats-page {\n  min-height: 100vh;\n  background:\n    radial-gradient(circle at 16% 18%, rgba(231, 47, 68, 0.12), transparent 38%),\n    radial-gradient(circle at 88% 8%, rgba(35, 33, 55, 0.12), transparent 34%),\n    linear-gradient(160deg, #f3f5f8 0%, #f7fafc 42%, #eef2f8 100%);\n  color: #1d2330;\n  font-family: \"Manrope\", \"Segoe UI\", sans-serif;\n}\n\n.chats-shell {\n  display: grid;\n  grid-template-columns: 340px minmax(0, 1fr);\n  gap: 14px;\n  padding: 0 14px 20px;\n  max-width: 1220px;\n  margin: 0 auto;\n}\n\n.chats-sidebar,\n.chats-main {\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(8px);\n  box-shadow: 0 18px 40px rgba(23, 30, 44, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n}\n\n.chats-sidebar {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: calc(100vh - 95px);\n}\n\n.chats-brand {\n  font-size: 13px;\n  letter-spacing: 0.22em;\n  font-weight: 800;\n  color: #e72f44;\n}\n\n.chats-create {\n  display: grid;\n  gap: 8px;\n  padding: 10px;\n  border-radius: 16px;\n  background: linear-gradient(145deg, rgba(231, 47, 68, 0.09), rgba(35, 33, 55, 0.06));\n}\n\n.chats-input,\n.composer-input {\n  width: 100%;\n  border: 1px solid rgba(35, 33, 55, 0.15);\n  background: #fff;\n  color: #1f2530;\n  border-radius: 14px;\n  padding: 10px 12px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.chats-input:focus,\n.composer-input:focus {\n  border-color: rgba(231, 47, 68, 0.65);\n  box-shadow: 0 0 0 3px rgba(231, 47, 68, 0.12);\n}\n\n.chats-search {\n  background: rgba(255, 255, 255, 0.92);\n}\n\n.chats-primary,\n.chats-secondary,\n.messages-loadmore {\n  border: 0;\n  border-radius: 14px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.chats-primary:hover,\n.chats-secondary:hover,\n.messages-loadmore:hover {\n  transform: translateY(-1px);\n}\n\n.chats-primary:disabled,\n.chats-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.chats-primary {\n  background: linear-gradient(135deg, #e72f44, #ff5f45);\n  color: #fff;\n  padding: 10px 12px;\n}\n\n.chats-secondary,\n.messages-loadmore {\n  background: #232137;\n  color: #fff;\n  padding: 10px 12px;\n}\n\n.chats-list {\n  overflow: auto;\n  padding-right: 2px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.chat-row {\n  text-align: left;\n  border: 1px solid rgba(24, 29, 42, 0.08);\n  background: #fff;\n  border-radius: 16px;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, transform 0.15s ease;\n  display: grid;\n  gap: 3px;\n}\n\n.chat-row-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.chat-row.active {\n  border-color: rgba(231, 47, 68, 0.58);\n  background: linear-gradient(155deg, rgba(255, 247, 248, 1), rgba(255, 255, 255, 1));\n}\n\n.chat-row-title {\n  font-weight: 700;\n  color: #1f2534;\n  font-size: 14px;\n}\n\n.chat-row-preview {\n  color: #6f7786;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-row-time {\n  color: #939cb0;\n  font-size: 11px;\n}\n\n.chat-unread-badge {\n  min-width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  padding: 0 6px;\n  background: #e72f44;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chats-main {\n  min-height: calc(100vh - 95px);\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto;\n}\n\n.chats-header {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border-bottom: 1px solid rgba(25, 32, 45, 0.08);\n}\n\n.chats-header-name {\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.chats-header-meta {\n  font-size: 12px;\n  color: #7a8396;\n}\n\n.chats-invite {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chats-invite .chats-input {\n  min-width: 220px;\n}\n\n.messages-panel {\n  overflow: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.messages-loadmore-wrap {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n:where(.chats-page) .message-bubble {\n  max-width: 72%;\n  border-radius: 18px;\n  padding: 10px 12px 8px;\n  animation: bubble-in 0.22s ease;\n}\n\n:where(.chats-page) .message-bubble.mine {\n  align-self: flex-end;\n  background: linear-gradient(145deg, #e72f44, #ff5e47);\n  color: #fff;\n  border-bottom-right-radius: 6px;\n}\n\n:where(.chats-page) .message-bubble.other {\n  align-self: flex-start;\n  background: #fff;\n  border: 1px solid rgba(30, 36, 51, 0.1);\n  color: #1d2432;\n  border-bottom-left-radius: 6px;\n}\n\n:where(.chats-page) .message-text {\n  font-size: 14px;\n  line-height: 1.42;\n  white-space: pre-wrap;\n}\n\n:where(.chats-page) .message-meta {\n  margin-top: 5px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  font-size: 11px;\n  opacity: 0.8;\n}\n\n.read-indicator {\n  font-weight: 700;\n}\n\n.composer {\n  border-top: 1px solid rgba(25, 32, 45, 0.08);\n  padding: 12px 16px 14px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px;\n}\n\n.composer-send {\n  min-width: 122px;\n}\n\n.chats-empty {\n  padding: 20px;\n  border-radius: 14px;\n  text-align: center;\n  color: #667082;\n}\n\n.chats-error {\n  color: #d12f3d;\n}\n\n@keyframes bubble-in {\n  from {\n    transform: translateY(6px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 990px) {\n  .chats-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .chats-sidebar {\n    max-height: none;\n  }\n\n  .chats-main {\n    min-height: 74vh;\n  }\n\n  .chats-invite {\n    width: 100%;\n  }\n\n  .chats-invite .chats-input {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 680px) {\n  .chats-shell {\n    padding: 0 6px 16px;\n  }\n\n  .chats-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .chats-invite {\n    display: grid;\n    grid-template-columns: 1fr auto;\n  }\n\n  :where(.chats-page) .message-bubble {\n    max-width: 88%;\n  }\n\n  .composer {\n    grid-template-columns: 1fr;\n  }\n\n  .composer-send {\n    width: 100%;\n  }\n}\n\n/* Telegram-like regular chat overrides */\n.chats-page {\n  --tg-bg: #e7eef5;\n  --tg-sidebar: #fff;\n  --tg-panel: #fff;\n  --tg-header: rgba(255, 255, 255, 0.96);\n  --tg-border: #dfe7ef;\n  --tg-text: #17212b;\n  --tg-muted: #6f8396;\n  --tg-accent: #2aabee;\n  --tg-bubble-other: #fff;\n  --tg-bubble-mine: #effdde;\n  min-height: 100dvh;\n  background: var(--tg-bg);\n  color: var(--tg-text);\n}\n\nbody[data-theme=\"dark\"] .chats-page {\n  --tg-bg: #0e1621;\n  --tg-sidebar: #17212b;\n  --tg-panel: #17212b;\n  --tg-header: rgba(23, 33, 43, 0.96);\n  --tg-border: #263542;\n  --tg-text: #eef6fc;\n  --tg-muted: #8aa0b3;\n  --tg-bubble-other: #182533;\n  --tg-bubble-mine: #2b5278;\n}\n\n.chats-shell {\n  grid-template-columns: minmax(300px, 368px) minmax(0, 1fr);\n  gap: 0;\n  max-width: none;\n  min-height: calc(100dvh - 68px);\n  padding: 0;\n}\n\n.chats-sidebar,\n.chats-main {\n  border-radius: 0;\n  border: 0;\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.chats-sidebar {\n  background: var(--tg-sidebar);\n  border-right: 1px solid var(--tg-border);\n  max-height: none;\n}\n\n.chats-main {\n  background:\n    linear-gradient(rgba(231, 238, 245, 0.84), rgba(231, 238, 245, 0.84)),\n    repeating-linear-gradient(45deg, rgba(42, 171, 238, 0.04) 0 1px, transparent 1px 18px);\n}\n\nbody[data-theme=\"dark\"] .chats-main {\n  background:\n    linear-gradient(rgba(14, 22, 33, 0.9), rgba(14, 22, 33, 0.9)),\n    repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.025) 0 1px, transparent 1px 18px);\n}\n\n.chats-brand {\n  display: none;\n}\n\n.chats-create {\n  margin: 10px;\n  background: var(--tg-panel);\n  border: 1px solid var(--tg-border);\n}\n\n.chats-filter-row {\n  display: flex;\n  gap: 8px;\n  overflow: auto;\n  padding: 0 14px 10px;\n}\n\n.chat-filter-chip,\n.chats-icon {\n  border: 1px solid var(--tg-border);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--tg-muted);\n  padding: 8px 10px;\n}\n\n.chat-filter-chip.active {\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, 0.12);\n}\n\n.chat-row {\n  position: relative;\n  border-radius: 0;\n  border: 0;\n  display: grid;\n  grid-template-columns: 52px minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n  min-height: 72px;\n}\n\n.chat-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-accent);\n  color: #fff;\n  font-weight: 800;\n}\n\n.chat-avatar.large {\n  width: 48px;\n  height: 48px;\n}\n\n.chat-avatar.small {\n  width: 34px;\n  height: 34px;\n  font-size: 13px;\n}\n\n.chat-row-copy {\n  min-width: 0;\n}\n\n.chat-row-pin {\n  color: var(--tg-accent);\n  margin-right: 4px;\n}\n\n.chat-row-pin.important {\n  color: #e8a800;\n}\n\n.chats-header {\n  background: var(--tg-header);\n  border-bottom: 1px solid var(--tg-border);\n}\n\n.chats-header-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pinned-message-bar {\n  border: 0;\n  border-bottom: 1px solid var(--tg-border);\n  background: var(--tg-header);\n  color: var(--tg-text);\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr);\n  gap: 8px;\n  align-items: center;\n  padding: 8px 18px;\n  text-align: left;\n}\n\n.pinned-message-bar em {\n  color: var(--tg-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n:where(.chats-page) .message-bubble.other {\n  background: var(--tg-bubble-other);\n}\n\n:where(.chats-page) .message-bubble.mine {\n  background: var(--tg-bubble-mine);\n  color: var(--tg-text);\n}\n\n.attachment-stack {\n  display: grid;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.attachment-card {\n  border-radius: 9px;\n  overflow: hidden;\n}\n\n.attachment-card.media img,\n.attachment-card.media {\n  max-width: 260px;\n  max-height: 260px;\n}\n\n.message-reply-preview,\n.message-forwarded,\n.link-preview-card {\n  border-left: 3px solid var(--tg-accent);\n  background: rgba(42, 171, 238, 0.08);\n  border-radius: 7px;\n  padding: 6px 8px;\n  margin-bottom: 6px;\n}\n\n.message-reply-preview {\n  width: 100%;\n  text-align: left;\n}\n\n:where(.chats-page) .message-text {\n  overflow-wrap: anywhere;\n}\n\n:where(.chats-page) .message-text.deleted {\n  color: var(--tg-muted);\n  font-style: italic;\n}\n\n.link-preview-card {\n  display: block;\n  color: var(--tg-accent);\n}\n\n.message-reactions,\n.reaction-row {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n.message-reaction,\n.reaction-row button {\n  border: 0;\n  border-radius: 999px;\n  background: rgba(42, 171, 238, 0.14);\n  padding: 4px 8px;\n}\n\n.message-more {\n  border: 0;\n  background: transparent;\n  color: var(--tg-muted);\n}\n\n.composer {\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr) auto;\n  align-items: end;\n  gap: 8px;\n  background: transparent;\n}\n\n.composer-file-input {\n  display: none;\n}\n\n.composer-input {\n  min-height: 42px;\n  resize: none;\n}\n\n.composer-preview {\n  grid-column: 1 / -1;\n  border-left: 3px solid var(--tg-accent);\n  background: var(--tg-panel);\n  border-radius: 12px;\n  padding: 8px 10px;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  gap: 8px;\n}\n\n.messages-panel.drag-over {\n  outline: 2px dashed var(--tg-accent);\n  outline-offset: -12px;\n}\n\n.attachment-card.media-button {\n  border: 0;\n  padding: 0;\n  cursor: zoom-in;\n}\n\n.emoji-panel {\n  grid-column: 1 / -1;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 8px 10px;\n  border: 1px solid var(--tg-border);\n  border-radius: 14px;\n  background: var(--tg-panel);\n}\n\n.emoji-choice {\n  border: 0;\n  border-radius: 999px;\n  background: rgba(42, 171, 238, 0.12);\n  padding: 6px 9px;\n  cursor: pointer;\n}\n\n.chat-sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: grid;\n  place-items: end center;\n  background: rgba(14, 22, 33, 0.36);\n}\n\n.chat-sheet-card {\n  width: min(420px, 100%);\n  max-height: 78dvh;\n  overflow: auto;\n  background: var(--tg-panel);\n  color: var(--tg-text);\n  border-radius: 18px 18px 0 0;\n  padding: 14px;\n  display: grid;\n  gap: 8px;\n}\n\n.chat-sheet-card > button,\n.forward-chat-row,\n.search-result-row {\n  border: 0;\n  border-radius: 12px;\n  background: rgba(42, 171, 238, 0.08);\n  color: var(--tg-text);\n  padding: 10px;\n  text-align: left;\n}\n\n.forward-chat-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.settings-switch {\n  width: 52px;\n  height: 32px;\n  border: 0;\n  border-radius: 16px;\n  padding: 3px;\n  background: rgba(127, 145, 164, 0.35);\n  transition: background 0.18s ease;\n}\n\n.settings-switch i {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  display: block;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.22);\n  transition: transform 0.18s ease;\n}\n\n.settings-switch.on {\n  background: var(--tg-accent);\n}\n\n.settings-switch.on i {\n  transform: translateX(20px);\n}\n\n.settings-switch:disabled {\n  opacity: 0.58;\n}\n\n.chat-settings-sheet {\n  z-index: 1300;\n  padding: 0 10px calc(10px + env(safe-area-inset-bottom));\n  background: rgba(10, 18, 28, 0.48);\n  backdrop-filter: blur(12px);\n}\n\n.chat-settings-card {\n  width: min(430px, 100%);\n  max-height: min(82dvh, 720px);\n  overflow: auto;\n  border-radius: 20px;\n  display: grid;\n  gap: 12px;\n  padding: 14px;\n  color: var(--tg-text);\n  background: color-mix(in srgb, var(--tg-panel) 94%, transparent);\n  box-shadow: 0 20px 50px rgba(5, 12, 20, 0.28);\n}\n\n.chat-settings-head {\n  display: grid;\n  grid-template-columns: 52px minmax(0, 1fr) 36px;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-settings-head span:nth-child(2) {\n  min-width: 0;\n  display: grid;\n  gap: 3px;\n}\n\n.chat-settings-head strong,\n.chat-settings-toggle-row strong,\n.chat-settings-row strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-settings-head em,\n.chat-settings-toggle-row em,\n.chat-settings-stats em {\n  color: var(--tg-muted);\n  font-style: normal;\n  font-size: 13px;\n}\n\n.chat-settings-head button {\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-muted);\n  background: rgba(127, 145, 164, 0.12);\n}\n\n.chat-settings-section {\n  border-radius: 14px;\n  display: grid;\n  gap: 10px;\n  padding: 10px;\n  background: rgba(127, 145, 164, 0.08);\n}\n\n.chat-settings-toggle-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 54px;\n  align-items: center;\n  gap: 12px;\n}\n\n.chat-settings-toggle-row span {\n  min-width: 0;\n  display: grid;\n  gap: 4px;\n}\n\n.chat-settings-section-title {\n  color: var(--tg-muted);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.chat-settings-choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.chat-settings-choice,\n.chat-settings-refresh {\n  min-height: 40px;\n  border: 1px solid var(--tg-soft-border);\n  border-radius: 12px;\n  color: var(--tg-text);\n  background: rgba(255, 255, 255, 0.04);\n  font-weight: 600;\n}\n\n.chat-settings-choice.active {\n  border-color: rgba(42, 171, 238, 0.48);\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, 0.14);\n}\n\n.chat-settings-choice:disabled {\n  opacity: 0.58;\n}\n\n.chat-settings-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.chat-settings-stats span {\n  min-height: 68px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  align-content: center;\n  gap: 3px;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.chat-settings-stats strong {\n  font-size: 21px;\n}\n\n.chat-settings-row {\n  min-height: 46px;\n  border: 0;\n  display: grid;\n  grid-template-columns: 31px minmax(0, 1fr) 52px;\n  align-items: center;\n  gap: 10px;\n  color: var(--tg-text);\n  background: transparent;\n  text-align: left;\n}\n\n.chat-settings-row + .chat-settings-row {\n  border-top: 1px solid rgba(127, 145, 164, 0.12);\n}\n\n.chat-settings-note {\n  border-radius: 12px;\n  padding: 10px 12px;\n  color: var(--tg-muted);\n  background: rgba(127, 145, 164, 0.1);\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.chat-settings-note.error {\n  color: #ff6b5f;\n  background: rgba(255, 69, 58, 0.1);\n}\n\n.chat-settings-refresh {\n  color: var(--tg-accent);\n}\n\n.chat-toast {\n  position: fixed;\n  left: 50%;\n  bottom: 28px;\n  transform: translateX(-50%);\n  z-index: 2000;\n  border-radius: 999px;\n  padding: 10px 16px;\n  color: #fff;\n  background: rgba(23, 33, 43, 0.88);\n}\n\n.image-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 3000;\n  display: grid;\n  place-items: center;\n  padding: 18px;\n  background: rgba(14, 22, 33, 0.78);\n}\n\n.image-modal-card {\n  position: relative;\n  max-width: min(960px, 96vw);\n  max-height: 92dvh;\n  display: grid;\n  gap: 10px;\n  color: #fff;\n  text-align: center;\n}\n\n.image-modal-card img {\n  max-width: 100%;\n  max-height: 86dvh;\n  border-radius: 12px;\n  object-fit: contain;\n}\n\n.image-modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 50%;\n  color: #fff;\n  background: rgba(14, 22, 33, 0.72);\n  cursor: pointer;\n}\n\n@media (max-width: 760px) {\n  .chats-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .chats-sidebar {\n    border-right: 0;\n  }\n\n  .chats-main {\n    min-height: 100dvh;\n  }\n}\n\n/* Telegram Web visual pass */\n.chats-page {\n  --tg-bg: #dbe7f3;\n  --tg-sidebar: #ffffff;\n  --tg-panel: #ffffff;\n  --tg-header: #ffffff;\n  --tg-border: #d7e0ea;\n  --tg-text: #17212b;\n  --tg-muted: #6d7f90;\n  --tg-accent: #2aabee;\n  --tg-accent-press: #1f97d4;\n  --tg-bubble-other: #ffffff;\n  --tg-bubble-mine: #dff7c7;\n  --tg-bubble-mine-border: #c9edaa;\n  --tg-pattern: rgba(49, 102, 139, 0.06);\n  min-height: 100dvh;\n  background: var(--tg-bg);\n  color: var(--tg-text);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n}\n\nbody[data-theme=\"dark\"] .chats-page {\n  --tg-bg: #0e1621;\n  --tg-sidebar: #17212b;\n  --tg-panel: #17212b;\n  --tg-header: #17212b;\n  --tg-border: #263542;\n  --tg-text: #eef6fc;\n  --tg-muted: #8aa0b3;\n  --tg-accent: #2aabee;\n  --tg-accent-press: #49b7ec;\n  --tg-bubble-other: #182533;\n  --tg-bubble-mine: #2b5278;\n  --tg-bubble-mine-border: #37658e;\n  --tg-pattern: rgba(255, 255, 255, 0.035);\n}\n\n.chats-shell {\n  display: grid;\n  grid-template-columns: 372px minmax(0, 1fr);\n  gap: 0;\n  max-width: none;\n  height: calc(100dvh - 68px);\n  min-height: 620px;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background: var(--tg-bg);\n}\n\n.chats-sidebar,\n.chats-main {\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.chats-sidebar {\n  min-height: 0;\n  max-height: none;\n  padding: 0;\n  gap: 0;\n  background: var(--tg-sidebar);\n  border-right: 1px solid var(--tg-border);\n}\n\n.chats-main {\n  min-height: 0;\n  display: grid;\n  grid-template-rows: 60px auto minmax(0, 1fr) auto;\n  background:\n    linear-gradient(rgba(219, 231, 243, 0.88), rgba(219, 231, 243, 0.88)),\n    radial-gradient(circle at 18px 18px, var(--tg-pattern) 0 1.4px, transparent 1.5px),\n    radial-gradient(circle at 42px 42px, var(--tg-pattern) 0 1.2px, transparent 1.3px);\n  background-size: auto, 52px 52px, 52px 52px;\n}\n\nbody[data-theme=\"dark\"] .chats-main {\n  background:\n    linear-gradient(rgba(14, 22, 33, 0.92), rgba(14, 22, 33, 0.92)),\n    radial-gradient(circle at 18px 18px, var(--tg-pattern) 0 1.4px, transparent 1.5px),\n    radial-gradient(circle at 42px 42px, var(--tg-pattern) 0 1.2px, transparent 1.3px);\n  background-size: auto, 52px 52px, 52px 52px;\n}\n\n.chats-brand,\n.chats-create {\n  display: none;\n}\n\n.chats-sidebar-head {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--tg-border);\n  background: var(--tg-header);\n}\n\n.chats-sidebar-title {\n  font-size: 20px;\n  line-height: 1;\n  font-weight: 700;\n}\n\n.chats-round-action,\n.chats-icon {\n  width: 38px;\n  height: 38px;\n  min-width: 38px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-muted);\n  background: transparent;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.chats-round-action:hover,\n.chats-icon:hover,\n.chats-icon.active {\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, 0.12);\n}\n\n.chats-search-box {\n  position: relative;\n  padding: 9px 12px 8px;\n  background: var(--tg-header);\n}\n\n.chats-search-box span {\n  position: absolute;\n  left: 25px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--tg-muted);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.chats-input,\n.composer-input {\n  box-shadow: none;\n  outline: none;\n}\n\n.chats-search {\n  height: 38px;\n  border: 0;\n  border-radius: 19px;\n  padding: 0 14px 0 38px;\n  background: #eef3f7;\n  color: var(--tg-text);\n}\n\nbody[data-theme=\"dark\"] .chats-search {\n  background: #242f3d;\n}\n\n.chats-search:focus,\n.composer-input:focus,\n.chat-sheet-card .chats-input:focus {\n  border-color: transparent;\n  box-shadow: 0 0 0 2px rgba(42, 171, 238, 0.24);\n}\n\n.chats-filter-row {\n  display: flex;\n  gap: 6px;\n  padding: 4px 12px 9px;\n  overflow: auto;\n  background: var(--tg-header);\n  scrollbar-width: none;\n}\n\n.chats-filter-row::-webkit-scrollbar {\n  display: none;\n}\n\n.chat-filter-chip {\n  min-height: 30px;\n  border: 0;\n  border-radius: 15px;\n  background: transparent;\n  color: var(--tg-muted);\n  padding: 0 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.chat-filter-chip.active {\n  background: rgba(42, 171, 238, 0.14);\n  color: var(--tg-accent-press);\n}\n\n.chat-filter-chip span {\n  min-width: 18px;\n  height: 18px;\n  border-radius: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(109, 127, 144, 0.16);\n  font-size: 11px;\n}\n\n.chats-list {\n  flex: 1;\n  min-height: 0;\n  padding: 0;\n  gap: 0;\n  overflow: auto;\n  background: var(--tg-sidebar);\n}\n\n.chat-row {\n  position: relative;\n  min-height: 72px;\n  width: 100%;\n  border: 0;\n  border-radius: 0;\n  display: grid;\n  grid-template-columns: 52px minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: transparent;\n  color: var(--tg-text);\n  transform: none;\n}\n\n.chat-row:hover {\n  background: rgba(42, 171, 238, 0.07);\n}\n\n.chat-row.active {\n  background: rgba(42, 171, 238, 0.14);\n  border-color: transparent;\n}\n\n.chat-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #37aee2, #7bc862);\n  color: #fff;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.chat-avatar.large {\n  width: 42px;\n  height: 42px;\n  font-size: 15px;\n}\n\n.chat-avatar.small {\n  width: 34px;\n  height: 34px;\n  font-size: 13px;\n}\n\n.chat-row-copy {\n  min-width: 0;\n  display: grid;\n  gap: 5px;\n}\n\n.chat-row-top {\n  min-width: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px;\n}\n\n.chat-row-title {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--tg-text);\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.chat-row-time {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  color: var(--tg-muted);\n  font-size: 12px;\n}\n\n.chat-row-preview {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--tg-muted);\n  font-size: 13px;\n}\n\n.chat-row.unread .chat-row-title,\n.chat-row.unread .chat-row-preview {\n  font-weight: 700;\n}\n\n.chat-row-pin {\n  color: var(--tg-muted);\n  font-size: 12px;\n}\n\n.chat-row-pin.important {\n  color: #e5a800;\n}\n\n.chat-unread-badge {\n  position: absolute;\n  right: 14px;\n  bottom: 12px;\n  min-width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  padding: 0 6px;\n  background: var(--tg-accent);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.chats-header {\n  height: 60px;\n  min-height: 60px;\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: var(--tg-header);\n  border-bottom: 1px solid var(--tg-border);\n}\n\n.chats-header-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.chats-header-main > div:last-child {\n  min-width: 0;\n}\n\n.chats-header-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--tg-text);\n  font-size: 16px;\n  line-height: 1.2;\n  font-weight: 600;\n}\n\n.chats-header-meta {\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--tg-accent);\n  font-size: 13px;\n}\n\n.chats-header-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.chats-invite {\n  display: none;\n}\n\n.pinned-message-bar {\n  min-height: 44px;\n  border: 0;\n  border-bottom: 1px solid var(--tg-border);\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  padding: 7px 18px;\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--tg-text);\n  text-align: left;\n}\n\nbody[data-theme=\"dark\"] .pinned-message-bar {\n  background: rgba(23, 33, 43, 0.92);\n}\n\n.pinned-message-bar span:first-child {\n  color: var(--tg-accent);\n}\n\n.pinned-message-bar strong {\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.pinned-message-bar em {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--tg-muted);\n  font-size: 13px;\n  font-style: normal;\n}\n\n.messages-panel {\n  min-height: 0;\n  padding: 18px 22px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow: auto;\n}\n\n.messages-date-divider {\n  align-self: center;\n  margin: 10px 0;\n}\n\n.messages-date-divider span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 12px;\n  border-radius: 14px;\n  color: #fff;\n  background: rgba(109, 127, 144, 0.58);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.messages-loadmore {\n  min-height: 32px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.84);\n  color: var(--tg-accent-press);\n  padding: 0 14px;\n}\n\n:where(.chats-page) .message-bubble {\n  position: relative;\n  width: fit-content;\n  max-width: min(680px, 72%);\n  border: 0;\n  border-radius: 12px;\n  padding: 7px 9px 5px;\n  box-shadow: 0 1px 1px rgba(23, 33, 43, 0.12);\n  animation: bubble-in 0.16s ease;\n}\n\n:where(.chats-page) .message-bubble.other {\n  align-self: flex-start;\n  border-bottom-left-radius: 4px;\n  background: var(--tg-bubble-other);\n  color: var(--tg-text);\n}\n\n:where(.chats-page) .message-bubble.mine {\n  align-self: flex-end;\n  border: 1px solid var(--tg-bubble-mine-border);\n  border-bottom-right-radius: 4px;\n  background: var(--tg-bubble-mine);\n  color: var(--tg-text);\n}\n\n:where(.chats-page) .message-bubble.other::after,\n:where(.chats-page) .message-bubble.mine::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  width: 10px;\n  height: 10px;\n  background: inherit;\n}\n\n:where(.chats-page) .message-bubble.other::after {\n  left: -5px;\n  clip-path: polygon(100% 0, 100% 100%, 0 100%);\n}\n\n:where(.chats-page) .message-bubble.mine::after {\n  right: -5px;\n  clip-path: polygon(0 0, 100% 100%, 0 100%);\n}\n\n:where(.chats-page) .message-text {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  font-size: 15px;\n  line-height: 1.35;\n}\n\n:where(.chats-page) .message-meta {\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 5px;\n  color: rgba(109, 127, 144, 0.92);\n  font-size: 11px;\n  line-height: 1;\n}\n\n:where(.chats-page) .message-bubble.mine .message-meta {\n  color: rgba(77, 123, 57, 0.9);\n}\n\nbody[data-theme=\"dark\"] :where(.chats-page) .message-bubble.mine .message-meta {\n  color: rgba(170, 211, 238, 0.86);\n}\n\n.read-indicator {\n  color: var(--tg-accent);\n  font-weight: 700;\n}\n\n.message-more {\n  width: 24px;\n  height: 20px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: inherit;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.message-more:hover {\n  background: rgba(42, 171, 238, 0.12);\n}\n\n.message-reply-preview,\n.message-forwarded,\n.link-preview-card {\n  border: 0;\n  border-left: 3px solid var(--tg-accent);\n  border-radius: 7px;\n  background: rgba(42, 171, 238, 0.1);\n  color: var(--tg-text);\n  padding: 6px 8px;\n  margin-bottom: 6px;\n}\n\n.message-reply-preview {\n  width: 100%;\n  display: grid;\n  gap: 2px;\n  text-align: left;\n}\n\n.message-reply-preview strong,\n.message-forwarded {\n  color: var(--tg-accent-press);\n  font-size: 12px;\n}\n\n.attachment-stack {\n  display: grid;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.attachment-card {\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.attachment-card.media-button {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  cursor: zoom-in;\n}\n\n.attachment-card.media img,\n.attachment-card.media {\n  max-width: 300px;\n  max-height: 300px;\n}\n\n.message-reactions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 6px;\n}\n\n.message-reaction {\n  border: 0;\n  border-radius: 999px;\n  background: rgba(42, 171, 238, 0.13);\n  color: var(--tg-text);\n  padding: 3px 7px;\n  font-size: 12px;\n}\n\n.composer {\n  position: sticky;\n  bottom: 0;\n  z-index: 4;\n  border: 0;\n  padding: 9px 18px 14px;\n  display: grid;\n  grid-template-columns: 40px 40px minmax(0, 1fr) 44px;\n  align-items: end;\n  gap: 8px;\n  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, 0.95) 28%);\n}\n\nbody[data-theme=\"dark\"] .composer {\n  background: linear-gradient(180deg, rgba(14, 22, 33, 0), rgba(14, 22, 33, 0.96) 28%);\n}\n\n.composer-file-input {\n  display: none;\n}\n\n.composer .chats-icon {\n  background: var(--tg-panel);\n  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);\n}\n\n.composer-input {\n  min-height: 42px;\n  max-height: 140px;\n  border: 0;\n  border-radius: 21px;\n  resize: none;\n  padding: 11px 14px;\n  background: var(--tg-panel);\n  color: var(--tg-text);\n  font-size: 15px;\n  line-height: 1.35;\n  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);\n}\n\n.composer-send {\n  min-width: 44px;\n  width: 44px;\n  height: 44px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  background: var(--tg-accent);\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n  box-shadow: 0 2px 5px rgba(42, 171, 238, 0.28);\n}\n\n.composer-send:hover {\n  transform: none;\n  background: var(--tg-accent-press);\n}\n\n.composer-preview,\n.emoji-panel {\n  grid-column: 1 / -1;\n  border: 0;\n  border-left: 3px solid var(--tg-accent);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.92);\n  padding: 8px 10px;\n  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);\n}\n\nbody[data-theme=\"dark\"] .composer-preview,\nbody[data-theme=\"dark\"] .emoji-panel {\n  background: rgba(23, 33, 43, 0.92);\n}\n\n.composer-preview {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  gap: 8px;\n}\n\n.composer-preview span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--tg-muted);\n}\n\n.composer-preview button {\n  border: 0;\n  background: transparent;\n  color: var(--tg-muted);\n  cursor: pointer;\n}\n\n.emoji-panel {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.emoji-choice {\n  border: 0;\n  border-radius: 999px;\n  background: rgba(42, 171, 238, 0.12);\n  padding: 6px 9px;\n  cursor: pointer;\n}\n\n.chats-primary,\n.chats-secondary {\n  border: 0;\n  border-radius: 10px;\n  background: var(--tg-accent);\n  color: #fff;\n  padding: 10px 12px;\n  font-weight: 600;\n}\n\n.chats-primary:hover,\n.chats-secondary:hover {\n  transform: none;\n  background: var(--tg-accent-press);\n}\n\n.chat-sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: grid;\n  place-items: end center;\n  background: rgba(14, 22, 33, 0.36);\n}\n\n.chat-sheet-card {\n  width: min(420px, 100%);\n  max-height: 78dvh;\n  overflow: auto;\n  border-radius: 16px 16px 0 0;\n  display: grid;\n  gap: 9px;\n  padding: 14px;\n  background: var(--tg-panel);\n  color: var(--tg-text);\n}\n\n.chat-sheet-card h3 {\n  margin: 0 0 4px;\n  font-size: 17px;\n}\n\n.chat-sheet-card > button,\n.forward-chat-row,\n.search-result-row {\n  min-height: 40px;\n  border: 0;\n  border-radius: 10px;\n  background: rgba(42, 171, 238, 0.08);\n  color: var(--tg-text);\n  padding: 10px;\n  text-align: left;\n}\n\n.chat-sheet-card .chats-input {\n  border: 1px solid var(--tg-border);\n  border-radius: 10px;\n  background: var(--tg-panel);\n  color: var(--tg-text);\n}\n\n.forward-chat-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-toast {\n  position: fixed;\n  left: 50%;\n  bottom: 28px;\n  transform: translateX(-50%);\n  z-index: 2000;\n  border-radius: 999px;\n  padding: 10px 16px;\n  color: #fff;\n  background: rgba(23, 33, 43, 0.88);\n}\n\n.chats-empty {\n  align-self: center;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.72);\n  color: var(--tg-muted);\n  padding: 16px 18px;\n}\n\nbody[data-theme=\"dark\"] .chats-empty {\n  background: rgba(23, 33, 43, 0.72);\n}\n\n@media (max-width: 900px) {\n  .chats-shell {\n    grid-template-columns: 320px minmax(0, 1fr);\n  }\n\n  :where(.chats-page) .message-bubble {\n    max-width: 82%;\n  }\n}\n\n@media (max-width: 760px) {\n  .chats-shell {\n    display: grid;\n    grid-template-columns: 1fr;\n    height: auto;\n    min-height: calc(100dvh - 68px);\n    overflow: visible;\n  }\n\n  .chats-sidebar {\n    border-right: 0;\n    min-height: 44dvh;\n  }\n\n  .chats-main {\n    min-height: 70dvh;\n  }\n\n  .messages-panel {\n    padding: 12px 10px;\n  }\n\n  :where(.chats-page) .message-bubble {\n    max-width: 90%;\n  }\n\n  .composer {\n    grid-template-columns: 40px 40px minmax(0, 1fr) 44px;\n    padding: 8px 8px calc(10px + env(safe-area-inset-bottom));\n  }\n\n  .chats-header-actions {\n    gap: 0;\n  }\n}\n\n.chat-icon {\n  width: 20px;\n  height: 20px;\n  display: block;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.chats-sidebar-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.chat-avatar-wrap {\n  position: relative;\n  width: 52px;\n  height: 52px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chat-avatar-wrap.large {\n  width: 42px;\n  height: 42px;\n}\n\n.chat-avatar-wrap.online::after {\n  content: \"\";\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  width: 11px;\n  height: 11px;\n  border: 2px solid var(--tg-sidebar);\n  border-radius: 50%;\n  background: #33c46e;\n}\n\n.chats-header .chat-avatar-wrap.online::after {\n  right: 0;\n  bottom: 0;\n  border-color: var(--tg-header);\n}\n\n.chats-search-box .chat-icon {\n  position: absolute;\n  left: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  color: var(--tg-muted);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.chats-search-box span {\n  display: none;\n}\n\n.chat-row-time .chat-icon {\n  width: 13px;\n  height: 13px;\n}\n\n.chat-row-time .chat-icon:nth-child(2) {\n  color: #e5a800;\n}\n\n.chats-icon .chat-icon,\n.chats-round-action .chat-icon,\n.composer-send .chat-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.chat-mobile-back {\n  display: none;\n}\n\n.chats-main {\n  position: relative;\n}\n\n.chats-header {\n  grid-row: 1;\n}\n\n.pinned-message-bar {\n  grid-row: 2;\n}\n\n.messages-panel {\n  grid-row: 3;\n}\n\n.composer {\n  grid-row: 4;\n}\n\n:where(.chats-page) .message-bubble.grouped-prev {\n  margin-top: 1px;\n}\n\n:where(.chats-page) .message-bubble.grouped-prev.other {\n  border-top-left-radius: 12px;\n}\n\n:where(.chats-page) .message-bubble.grouped-prev.mine {\n  border-top-right-radius: 12px;\n}\n\n:where(.chats-page) .message-bubble.grouped-next.other,\n:where(.chats-page) .message-bubble.grouped-prev.other {\n  border-bottom-left-radius: 12px;\n}\n\n:where(.chats-page) .message-bubble.grouped-next.mine,\n:where(.chats-page) .message-bubble.grouped-prev.mine {\n  border-bottom-right-radius: 12px;\n}\n\n:where(.chats-page) .message-bubble.grouped-next::after,\n:where(.chats-page) .message-bubble.grouped-prev::after {\n  display: none;\n}\n\n:where(.chats-page) .message-bubble.important {\n  box-shadow: 0 0 0 1px rgba(229, 168, 0, 0.28), 0 1px 1px rgba(23, 33, 43, 0.12);\n}\n\n:where(.chats-page) .message-text a {\n  color: var(--tg-accent-press);\n  text-decoration: none;\n}\n\n:where(.chats-page) .message-text a:hover {\n  text-decoration: underline;\n}\n\n:where(.chats-page) .message-text code {\n  border-radius: 5px;\n  padding: 1px 5px;\n  background: rgba(109, 127, 144, 0.16);\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 0.92em;\n}\n\n:where(.chats-page) .message-text pre {\n  max-width: 100%;\n  overflow: auto;\n  border-radius: 8px;\n  margin: 5px 0;\n  padding: 8px;\n  background: rgba(14, 22, 33, 0.08);\n}\n\nbody[data-theme=\"dark\"] :where(.chats-page) .message-text pre {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.message-more {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.message-more .chat-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.jump-to-bottom {\n  position: absolute;\n  right: 22px;\n  bottom: 76px;\n  z-index: 8;\n  width: 42px;\n  height: 42px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-accent);\n  background: var(--tg-panel);\n  box-shadow: 0 4px 14px rgba(23, 33, 43, 0.18);\n  cursor: pointer;\n}\n\n.composer-send:disabled,\n.composer .chats-icon:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.composer-send .chat-icon {\n  color: #fff;\n}\n\n.composer-preview button,\n.composer-attachment-chip button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.composer-preview button .chat-icon,\n.composer-attachment-chip button .chat-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.composer-attachments {\n  grid-column: 1 / -1;\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding: 2px 0 1px;\n  scrollbar-width: thin;\n}\n\n.composer-attachment-chip {\n  min-width: 190px;\n  max-width: 260px;\n  border-radius: 12px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 28px;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 8px 8px 10px;\n  background: var(--tg-panel);\n  color: var(--tg-text);\n  box-shadow: 0 1px 2px rgba(23, 33, 43, 0.08);\n}\n\n.composer-attachment-chip span {\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.composer-attachment-chip strong,\n.composer-attachment-chip em {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.composer-attachment-chip strong {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.composer-attachment-chip em {\n  color: var(--tg-muted);\n  font-size: 12px;\n  font-style: normal;\n}\n\n.composer-attachment-chip button {\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 50%;\n  color: var(--tg-muted);\n  background: rgba(109, 127, 144, 0.12);\n}\n\n@media (max-width: 760px) {\n  .chats-shell {\n    height: calc(100dvh - 56px);\n    min-height: 0;\n  }\n\n  .chats-shell:not(.mobile-dialog-open) .chats-main {\n    display: none;\n  }\n\n  .chats-shell.mobile-dialog-open .chats-sidebar {\n    display: none;\n  }\n\n  .chat-mobile-back {\n    display: inline-flex;\n    margin-left: -8px;\n  }\n\n  .chats-sidebar {\n    min-height: 100%;\n  }\n\n  .chats-main {\n    min-height: 0;\n  }\n\n  .chats-header {\n    padding: 0 8px;\n  }\n\n  .chats-header-actions .chats-icon {\n    width: 34px;\n    min-width: 34px;\n  }\n\n  .jump-to-bottom {\n    right: 14px;\n    bottom: 72px;\n  }\n}\n\n/* Native Telegram-like pass */\n.chats-page {\n  --tg-bg: #0e1621;\n  --tg-sidebar: #17212b;\n  --tg-panel: #17212b;\n  --tg-header: #17212b;\n  --tg-border: #0b1118;\n  --tg-soft-border: #26323f;\n  --tg-text: #eef6fc;\n  --tg-muted: #7f91a4;\n  --tg-accent: #2aabee;\n  --tg-accent-press: #41b6ea;\n  --tg-bubble-other: #182533;\n  --tg-bubble-mine: #2b5278;\n  --tg-bubble-mine-border: #2b5278;\n  --tg-date-pill: rgba(42, 54, 68, 0.82);\n  --tg-composer: #17212b;\n  --tg-input: #242f3d;\n  min-height: 100dvh;\n  height: 100dvh;\n  overflow: hidden;\n  background: var(--tg-bg);\n  color: var(--tg-text);\n}\n\n.chats-page[data-chat-theme=\"light\"] {\n  --tg-bg: #dbe7f3;\n  --tg-sidebar: #ffffff;\n  --tg-panel: #ffffff;\n  --tg-header: #ffffff;\n  --tg-border: #cfd9e4;\n  --tg-soft-border: #e2e8ef;\n  --tg-text: #17212b;\n  --tg-muted: #6d7f90;\n  --tg-bubble-other: #ffffff;\n  --tg-bubble-mine: #dff7c7;\n  --tg-bubble-mine-border: #c9edaa;\n  --tg-date-pill: rgba(109, 127, 144, 0.58);\n  --tg-composer: #dbe7f3;\n  --tg-input: #ffffff;\n}\n\n.chats-page .chats-shell {\n  height: 100dvh;\n  min-height: 0;\n  grid-template-columns: 360px minmax(0, 1fr);\n  background: var(--tg-bg);\n}\n\n.chats-page .chats-sidebar {\n  background: var(--tg-sidebar);\n  border-right: 1px solid var(--tg-border);\n}\n\n.chats-page .chats-main {\n  position: relative;\n  isolation: isolate;\n  min-height: 0;\n  grid-template-rows: 56px auto minmax(0, 1fr) auto;\n  background:\n    linear-gradient(rgba(14, 22, 33, 0.9), rgba(14, 22, 33, 0.9)),\n    radial-gradient(circle at 24px 24px, rgba(255, 255, 255, 0.045) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(255, 255, 255, 0.035) 0 1.6px, transparent 1.8px),\n    linear-gradient(35deg, transparent 0 46%, rgba(255, 255, 255, 0.025) 46% 48%, transparent 48% 100%);\n  background-color: var(--tg-bg);\n  background-size: auto, 68px 68px, 112px 112px, 96px 96px;\n}\n\n.chats-page[data-chat-theme=\"light\"] .chats-main {\n  background:\n    linear-gradient(rgba(219, 231, 243, 0.84), rgba(219, 231, 243, 0.84)),\n    radial-gradient(circle at 24px 24px, rgba(49, 102, 139, 0.075) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(49, 102, 139, 0.055) 0 1.6px, transparent 1.8px),\n    linear-gradient(35deg, transparent 0 46%, rgba(49, 102, 139, 0.035) 46% 48%, transparent 48% 100%);\n  background-color: var(--tg-bg);\n  background-size: auto, 68px 68px, 112px 112px, 96px 96px;\n}\n\n.chats-page .chats-sidebar-head,\n.chats-page .chats-header {\n  height: 56px;\n  min-height: 56px;\n  background: var(--tg-header);\n  border-bottom: 1px solid var(--tg-border);\n}\n\n.chats-page .chats-sidebar-head {\n  display: grid;\n  grid-template-columns: 40px minmax(0, 1fr) auto;\n  gap: 8px;\n  padding: 0 8px 0 10px;\n}\n\n.chats-page .chats-sidebar-title {\n  font-size: 19px;\n  font-weight: 600;\n}\n\n.chats-page .chats-round-action,\n.chats-page .chats-icon {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  color: #8596a8;\n}\n\n.chats-page .chats-round-action:hover,\n.chats-page .chats-icon:hover,\n.chats-page .chats-icon.active {\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, 0.12);\n}\n\n.chats-page .chats-search-box {\n  padding: 8px 12px;\n  background: var(--tg-sidebar);\n}\n\n.chats-page .chats-search {\n  height: 36px;\n  border-radius: 18px;\n  background: var(--tg-input);\n  color: var(--tg-text);\n  font-size: 14px;\n}\n\n.chats-page .chats-search::placeholder,\n.chats-page .composer-input::placeholder {\n  color: var(--tg-muted);\n}\n\n.chats-page .chats-filter-row {\n  padding: 2px 10px 8px;\n  background: var(--tg-sidebar);\n}\n\n.chats-page .chat-filter-chip {\n  min-height: 30px;\n  border-radius: 15px;\n  color: var(--tg-muted);\n  font-size: 13px;\n}\n\n.chats-page .chat-filter-chip.active {\n  color: #ffffff;\n  background: rgba(42, 171, 238, 0.24);\n}\n\n.chats-page[data-chat-theme=\"light\"] .chat-filter-chip.active {\n  color: var(--tg-accent-press);\n  background: rgba(42, 171, 238, 0.14);\n}\n\n.chats-page .chat-row {\n  min-height: 72px;\n  grid-template-columns: 54px minmax(0, 1fr);\n  gap: 10px;\n  padding: 8px 12px;\n}\n\n.chats-page .chat-row::after {\n  content: \"\";\n  position: absolute;\n  left: 76px;\n  right: 0;\n  bottom: 0;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.045);\n}\n\n.chats-page[data-chat-theme=\"light\"] .chat-row::after {\n  background: rgba(23, 33, 43, 0.08);\n}\n\n.chats-page .chat-row:hover {\n  background: rgba(255, 255, 255, 0.045);\n}\n\n.chats-page .chat-row.active {\n  background: rgba(42, 171, 238, 0.22);\n}\n\n.chats-page[data-chat-theme=\"light\"] .chat-row.active {\n  background: rgba(42, 171, 238, 0.14);\n}\n\n.chats-page .chat-avatar {\n  background: linear-gradient(135deg, #8b5cf6, #c053dd);\n  box-shadow: none;\n}\n\n.chats-page .chat-row:nth-child(4n + 1) .chat-avatar {\n  background: linear-gradient(135deg, #36a3f7, #2cc7b7);\n}\n\n.chats-page .chat-row:nth-child(4n + 2) .chat-avatar {\n  background: linear-gradient(135deg, #f59f37, #ef4444);\n}\n\n.chats-page .chat-row:nth-child(4n + 3) .chat-avatar {\n  background: linear-gradient(135deg, #7bc862, #38bdf8);\n}\n\n.chats-page .chat-row-title {\n  color: var(--tg-text);\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.chats-page .chat-row-preview,\n.chats-page .chat-row-time {\n  color: var(--tg-muted);\n}\n\n.chats-page .chat-unread-badge {\n  right: 12px;\n  bottom: 12px;\n  background: #4dcd5e;\n}\n\n.chats-page .chats-header {\n  padding: 0 10px 0 14px;\n  box-shadow: none;\n}\n\n.chats-page .chats-header-name {\n  color: var(--tg-text);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.chats-page .chats-header-meta {\n  color: var(--tg-accent);\n  font-size: 14px;\n}\n\n.chats-page .pinned-message-bar {\n  min-height: 42px;\n  background: rgba(23, 33, 43, 0.94);\n  border-bottom: 1px solid var(--tg-border);\n}\n\n.chats-page[data-chat-theme=\"light\"] .pinned-message-bar {\n  background: rgba(255, 255, 255, 0.94);\n}\n\n.chats-page .messages-panel {\n  padding: 14px max(18px, calc((100% - 920px) / 2)) 10px;\n  gap: 2px;\n  scroll-behavior: smooth;\n}\n\n.chats-page .messages-date-divider span {\n  min-height: 26px;\n  padding: 0 12px;\n  background: var(--tg-date-pill);\n  backdrop-filter: blur(8px);\n  font-size: 12px;\n}\n\n.chats-page .message-bubble {\n  max-width: min(620px, 78%);\n  border-radius: 11px;\n  padding: 6px 8px 4px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.22);\n}\n\n.chats-page .message-bubble.other {\n  background: var(--tg-bubble-other);\n  border-bottom-left-radius: 3px;\n}\n\n.chats-page .message-bubble.mine {\n  border: 0;\n  background: var(--tg-bubble-mine);\n  border-bottom-right-radius: 3px;\n}\n\n.chats-page .message-bubble.grouped-next.other,\n.chats-page .message-bubble.grouped-prev.other {\n  border-bottom-left-radius: 11px;\n}\n\n.chats-page .message-bubble.grouped-next.mine,\n.chats-page .message-bubble.grouped-prev.mine {\n  border-bottom-right-radius: 11px;\n}\n\n.chats-page .message-text {\n  color: var(--tg-text);\n  font-size: 16px;\n  line-height: 1.36;\n}\n\n.chats-page .message-meta {\n  min-height: 13px;\n  margin-top: 1px;\n  color: #7d8e9f;\n  font-size: 11px;\n}\n\n.chats-page .message-bubble.mine .message-meta {\n  color: #a9c7dd;\n}\n\n.chats-page[data-chat-theme=\"light\"] .message-bubble.mine .message-meta {\n  color: #4d7b39;\n}\n\n.chats-page .read-indicator {\n  color: #59c7ff;\n}\n\n.chats-page .message-reply-preview,\n.chats-page .message-forwarded,\n.chats-page .link-preview-card {\n  background: rgba(42, 171, 238, 0.11);\n}\n\n.chats-page .composer {\n  min-height: 58px;\n  padding: 7px max(12px, calc((100% - 940px) / 2)) 10px;\n  grid-template-columns: 40px minmax(0, 1fr) 40px 46px;\n  background: linear-gradient(180deg, rgba(14, 22, 33, 0), var(--tg-bg) 22%);\n}\n\n.chats-page[data-chat-theme=\"light\"] .composer {\n  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, 0.96) 22%);\n}\n\n.chats-page .composer .chats-icon {\n  background: transparent;\n  box-shadow: none;\n}\n\n.chats-page .composer > .chats-icon:first-of-type {\n  grid-column: 1;\n}\n\n.chats-page .composer > .chats-icon:nth-of-type(2) {\n  grid-column: 3;\n}\n\n.chats-page .composer-input {\n  grid-column: 2;\n  min-height: 42px;\n  border: 0;\n  border-radius: 21px;\n  background: var(--tg-input);\n  color: var(--tg-text);\n  box-shadow: none;\n}\n\n.chats-page .composer-send {\n  grid-column: 4;\n  background: var(--tg-accent);\n  box-shadow: none;\n}\n\n.chats-page .composer-preview,\n.chats-page .composer-attachments,\n.chats-page .emoji-panel {\n  grid-column: 1 / -1;\n}\n\n.chats-page .composer-preview,\n.chats-page .emoji-panel,\n.chats-page .composer-attachment-chip {\n  background: rgba(23, 33, 43, 0.96);\n  border-color: var(--tg-accent);\n}\n\n.chats-page[data-chat-theme=\"light\"] .composer-preview,\n.chats-page[data-chat-theme=\"light\"] .emoji-panel,\n.chats-page[data-chat-theme=\"light\"] .composer-attachment-chip {\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.chats-page .jump-to-bottom {\n  right: max(16px, calc((100% - 920px) / 2));\n  bottom: 74px;\n  background: var(--tg-panel);\n}\n\n.chats-page .chats-empty {\n  justify-self: center;\n  align-self: center;\n  background: rgba(42, 54, 68, 0.84);\n  color: #d7e5ef;\n}\n\n.chats-page[data-chat-theme=\"light\"] .chats-empty {\n  background: rgba(255, 255, 255, 0.78);\n  color: var(--tg-muted);\n}\n\n@media (max-width: 900px) {\n  .chats-page .chats-shell {\n    grid-template-columns: 330px minmax(0, 1fr);\n  }\n\n  .chats-page .message-bubble {\n    max-width: 84%;\n  }\n}\n\n@media (max-width: 760px) {\n  .chats-page .chats-shell {\n    height: 100dvh;\n    grid-template-columns: 1fr;\n  }\n\n  .chats-page .chats-sidebar-head,\n  .chats-page .chats-header {\n    height: 58px;\n    min-height: 58px;\n  }\n\n  .chats-page .chats-main {\n    grid-template-rows: 58px auto minmax(0, 1fr) auto;\n  }\n\n  .chats-page .chats-header-actions .chats-icon:nth-child(3),\n  .chats-page .chats-header-actions .chats-icon:nth-child(4),\n  .chats-page .chats-header-actions .chats-icon:nth-child(5) {\n    display: none;\n  }\n\n  .chats-page .messages-panel {\n    padding: 12px 10px 8px;\n  }\n\n  .chats-page .message-bubble {\n    max-width: 86%;\n  }\n\n  .chats-page .composer {\n    padding: 6px 8px calc(8px + env(safe-area-inset-bottom));\n    grid-template-columns: 38px minmax(0, 1fr) 38px 44px;\n  }\n\n  .chats-page .jump-to-bottom {\n    right: 12px;\n    bottom: calc(70px + env(safe-area-inset-bottom));\n  }\n}\n\n/* Telegram iOS multi-screen states */\n.chats-sidebar-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-list-screen {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.mobile-settings-screen,\n.mobile-tabbar {\n  display: none;\n}\n\n.chats-search-cancel {\n  position: absolute;\n  right: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-muted);\n  background: rgba(127, 145, 164, 0.18);\n}\n\n.chats-search-cancel .chat-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.mobile-search-screen {\n  display: grid;\n  gap: 10px;\n  padding: 0 12px 8px;\n  color: var(--tg-muted);\n}\n\n.mobile-search-tabs {\n  display: flex;\n  gap: 18px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.mobile-search-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-search-tabs button {\n  position: relative;\n  border: 0;\n  background: transparent;\n  color: var(--tg-muted);\n  padding: 8px 0;\n  white-space: nowrap;\n}\n\n.mobile-search-tabs button.active {\n  color: var(--tg-accent);\n}\n\n.mobile-search-tabs button.active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--tg-accent);\n}\n\n.mobile-search-count {\n  font-size: 13px;\n}\n\n.message-action-sheet {\n  place-items: center center;\n  max-height: 100vh;\n  max-height: 100dvh;\n  padding: 18px 12px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n  backdrop-filter: blur(14px);\n  background: rgba(0, 0, 0, 0.58);\n}\n\n.message-action-sheet .message-action-preview {\n  width: fit-content;\n  max-width: min(520px, 84vw);\n  margin-bottom: 10px;\n  pointer-events: auto;\n}\n\n.message-action-sheet .chat-sheet-card {\n  width: min(360px, calc(100vw - 24px));\n  max-height: calc(100vh - 36px);\n  max-height: calc(100dvh - 36px);\n  border-radius: 14px;\n  padding: 0;\n  gap: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n  -webkit-overflow-scrolling: touch;\n  background: rgba(34, 36, 40, 0.94);\n  backdrop-filter: blur(20px);\n}\n\n.message-action-sheet .reaction-row {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0;\n  margin: 0;\n  padding: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.message-action-sheet .reaction-row button {\n  min-height: 34px;\n  border: 0;\n  background: transparent;\n  color: #fff;\n  font-size: 23px;\n}\n\n.message-action-sheet .reaction-row .chat-icon {\n  width: 17px;\n  height: 17px;\n}\n\n.message-action-sheet .chat-sheet-card > button {\n  min-height: 46px;\n  border: 0;\n  border-radius: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 24px;\n  align-items: center;\n  gap: 16px;\n  padding: 0 14px;\n  color: #fff;\n  background: transparent;\n  text-align: left;\n  font-size: 16px;\n}\n\n.message-action-sheet .chat-sheet-card > button + button {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.message-action-sheet .chat-sheet-card > button.danger {\n  color: #ff453a;\n}\n\n.message-action-sheet .chat-sheet-card .chat-icon {\n  width: 19px;\n  height: 19px;\n}\n\n.attachment-action-sheet {\n  place-items: end center;\n  gap: 10px;\n  padding: 0 10px calc(10px + env(safe-area-inset-bottom));\n  backdrop-filter: blur(18px);\n  background: rgba(0, 0, 0, 0.58);\n}\n\n.attachment-sheet-grid {\n  width: min(420px, 100%);\n  border-radius: 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px 12px;\n  padding: 28px 18px 24px;\n  background: rgba(33, 35, 39, 0.94);\n  backdrop-filter: blur(20px);\n}\n\n.attachment-sheet-grid button {\n  border: 0;\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n  color: #fff;\n  background: transparent;\n}\n\n.attachment-sheet-grid strong {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.attachment-sheet-icon,\n.settings-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.attachment-sheet-icon .chat-icon {\n  width: 25px;\n  height: 25px;\n}\n\n.attachment-sheet-icon.blue,\n.settings-icon.blue { background: linear-gradient(135deg, #2f80ed, #3b9bff); }\n.attachment-sheet-icon.purple,\n.settings-icon.purple { background: linear-gradient(135deg, #7c3aed, #a855f7); }\n.attachment-sheet-icon.orange,\n.settings-icon.orange { background: linear-gradient(135deg, #f59e0b, #fb923c); }\n.attachment-sheet-icon.green,\n.settings-icon.green { background: linear-gradient(135deg, #22c55e, #4ade80); }\n.attachment-sheet-icon.red,\n.settings-icon.red { background: linear-gradient(135deg, #ef4444, #f97316); }\n.settings-icon.gray { background: linear-gradient(135deg, #64748b, #94a3b8); }\n\n.attachment-sheet-cancel {\n  width: min(420px, 100%);\n  min-height: 54px;\n  border: 0;\n  border-radius: 14px;\n  color: var(--tg-accent);\n  background: rgba(33, 35, 39, 0.94);\n  font-size: 16px;\n}\n\n.telegram-media-viewer {\n  place-items: stretch;\n  padding: 0;\n  background: #000;\n}\n\n.telegram-media-viewer header,\n.telegram-media-viewer footer {\n  position: fixed;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  display: grid;\n  align-items: center;\n  color: #fff;\n}\n\n.telegram-media-viewer header {\n  top: 0;\n  height: 58px;\n  grid-template-columns: 58px 1fr 96px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0));\n}\n\n.telegram-media-viewer header > button,\n.telegram-media-viewer header span button,\n.media-caption button {\n  border: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: transparent;\n}\n\n.telegram-media-viewer header strong {\n  text-align: center;\n  font-size: 16px;\n}\n\n.telegram-media-viewer header span {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding-right: 12px;\n}\n\n.telegram-media-viewer .image-modal-card {\n  width: 100%;\n  height: 100dvh;\n  max-width: none;\n  max-height: none;\n  display: grid;\n  place-items: center;\n  padding: 70px 16px 150px;\n}\n\n.telegram-media-viewer .image-modal-card img {\n  max-width: min(820px, 88vw);\n  max-height: calc(100dvh - 240px);\n  border-radius: 0;\n}\n\n.telegram-media-viewer footer {\n  bottom: 0;\n  gap: 12px;\n  padding: 10px 18px calc(16px + env(safe-area-inset-bottom));\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));\n}\n\n.media-thumbnails {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n}\n\n.media-thumbnails button {\n  width: 42px;\n  height: 42px;\n  border: 2px solid transparent;\n  border-radius: 5px;\n  padding: 0;\n  overflow: hidden;\n  background: transparent;\n}\n\n.media-thumbnails button.active {\n  border-color: #fff;\n}\n\n.media-thumbnails img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.media-caption {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 14px;\n  max-width: 620px;\n  width: 100%;\n  justify-self: center;\n}\n\n.media-caption strong,\n.media-caption span {\n  grid-column: 1;\n}\n\n.media-caption strong {\n  font-size: 14px;\n}\n\n.media-caption span {\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 12px;\n}\n\n.mobile-edit-screen {\n  display: none;\n}\n\n@media (max-width: 760px) {\n  .mobile-tabbar {\n    height: 66px;\n    border-top: 1px solid rgba(211, 221, 232, 0.92);\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    background: rgba(255, 255, 255, 0.96);\n    box-shadow: 0 -10px 28px rgba(15, 23, 42, 0.07);\n    backdrop-filter: blur(18px) saturate(1.2);\n  }\n\n  .mobile-tabbar button {\n    position: relative;\n    border: 0;\n    display: grid;\n    place-items: center;\n    align-content: center;\n    gap: 3px;\n    color: #7b8da3;\n    background: transparent;\n    font-size: 10px;\n  }\n\n  .mobile-tabbar button.active {\n    color: var(--tg-accent);\n  }\n\n  .mobile-tabbar .chat-icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .mobile-tabbar b {\n    position: absolute;\n    top: 7px;\n    right: calc(50% - 22px);\n    min-width: 17px;\n    height: 17px;\n    border-radius: 9px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    background: #ff3b30;\n    font-size: 10px;\n  }\n\n  .chats-sidebar-body.show-settings .chat-list-screen,\n  .chats-sidebar-body.show-chats .mobile-settings-screen {\n    display: none;\n  }\n\n  .chats-sidebar-body.show-settings .mobile-settings-screen {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    padding: 0 12px 14px;\n    background: var(--tg-bg);\n  }\n\n  .mobile-settings-title {\n    height: 54px;\n    display: grid;\n    grid-template-columns: 64px 1fr 64px;\n    align-items: center;\n    color: var(--tg-text);\n  }\n\n  .mobile-settings-title span {\n    grid-column: 2;\n    justify-self: center;\n    font-weight: 700;\n  }\n\n  .mobile-settings-title button {\n    grid-column: 3;\n    border: 0;\n    color: var(--tg-accent);\n    background: transparent;\n    text-align: right;\n    font-size: 15px;\n  }\n\n  .mobile-settings-title.sub {\n    grid-template-columns: 48px 1fr 64px;\n  }\n\n  .mobile-settings-title.sub .mobile-settings-back {\n    grid-column: 1;\n    justify-self: start;\n    width: 40px;\n    height: 40px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .mobile-settings-title.sub .mobile-settings-back .chat-icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .mobile-settings-profile {\n    min-height: 76px;\n    border: 0;\n    border-radius: 12px;\n    display: grid;\n    grid-template-columns: 56px minmax(0, 1fr) 20px;\n    align-items: center;\n    gap: 12px;\n    padding: 10px;\n    color: var(--tg-text);\n    background: rgba(255, 255, 255, 0.04);\n    text-align: left;\n  }\n\n  .mobile-settings-profile span:nth-child(2) {\n    min-width: 0;\n    display: grid;\n    gap: 4px;\n  }\n\n  .mobile-settings-profile strong {\n    font-size: 17px;\n  }\n\n  .mobile-settings-profile em {\n    color: var(--tg-muted);\n    font-style: normal;\n  }\n\n  .mobile-settings-profile em.error {\n    color: #ff6b5f;\n  }\n\n  .mobile-settings-group {\n    margin-top: 14px;\n    border-radius: 12px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.04);\n  }\n\n  .mobile-settings-row {\n    min-height: 48px;\n    width: 100%;\n    border: 0;\n    display: grid;\n    grid-template-columns: 31px minmax(0, 1fr) auto auto 16px;\n    align-items: center;\n    gap: 10px;\n    padding: 7px 10px;\n    color: var(--tg-text);\n    background: transparent;\n    text-align: left;\n  }\n\n  .mobile-settings-row + .mobile-settings-row {\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n  }\n\n  .settings-icon {\n    width: 28px;\n    height: 28px;\n    border-radius: 7px;\n  }\n\n  .settings-icon .chat-icon {\n    width: 17px;\n    height: 17px;\n  }\n\n  .mobile-settings-row strong {\n    font-weight: 500;\n  }\n\n  .mobile-settings-row em,\n  .mobile-settings-row b {\n    color: var(--tg-muted);\n    font-style: normal;\n    font-weight: 400;\n  }\n\n  .mobile-settings-row > .chat-icon {\n    width: 15px;\n    height: 15px;\n    transform: rotate(-90deg);\n    color: var(--tg-muted);\n  }\n\n  .mobile-settings-note {\n    margin-top: 12px;\n    border-radius: 12px;\n    padding: 10px 12px;\n    color: var(--tg-muted);\n    background: rgba(255, 255, 255, 0.04);\n    font-size: 13px;\n    line-height: 1.35;\n  }\n\n  .mobile-settings-note.error {\n    color: #ff6b5f;\n    background: rgba(255, 69, 58, 0.1);\n  }\n\n  .mobile-settings-panel {\n    display: grid;\n    gap: 12px;\n  }\n\n  .mobile-settings-toggle-row {\n    min-height: 68px;\n    border-radius: 14px;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 54px;\n    align-items: center;\n    gap: 14px;\n    padding: 12px;\n    color: var(--tg-text);\n    background: rgba(255, 255, 255, 0.04);\n  }\n\n  .mobile-settings-toggle-row span {\n    min-width: 0;\n    display: grid;\n    gap: 4px;\n  }\n\n  .mobile-settings-toggle-row strong,\n  .mobile-settings-section-title {\n    font-weight: 600;\n  }\n\n  .mobile-settings-toggle-row em {\n    color: var(--tg-muted);\n    font-style: normal;\n    font-size: 13px;\n  }\n\n  .settings-switch {\n    width: 52px;\n    height: 32px;\n    border: 0;\n    border-radius: 16px;\n    padding: 3px;\n    background: rgba(127, 145, 164, 0.35);\n    transition: background 0.18s ease;\n  }\n\n  .settings-switch i {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: block;\n    background: #fff;\n    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.22);\n    transition: transform 0.18s ease;\n  }\n\n  .settings-switch.on {\n    background: var(--tg-accent);\n  }\n\n  .settings-switch.on i {\n    transform: translateX(20px);\n  }\n\n  .settings-switch:disabled,\n  .mobile-settings-choice:disabled {\n    opacity: 0.58;\n  }\n\n  .mobile-settings-section-title {\n    padding: 4px 2px 0;\n    color: var(--tg-muted);\n    font-size: 13px;\n  }\n\n  .mobile-settings-choice-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  .mobile-settings-choice-grid.two {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .mobile-settings-choice {\n    min-height: 42px;\n    border: 1px solid var(--tg-soft-border);\n    border-radius: 12px;\n    color: var(--tg-text);\n    background: rgba(255, 255, 255, 0.04);\n    font-weight: 600;\n  }\n\n  .mobile-settings-choice.active {\n    border-color: rgba(42, 171, 238, 0.48);\n    color: var(--tg-accent);\n    background: rgba(42, 171, 238, 0.14);\n  }\n\n  .mobile-settings-stats {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  .mobile-settings-stats span {\n    min-height: 76px;\n    border-radius: 14px;\n    display: grid;\n    place-items: center;\n    align-content: center;\n    gap: 4px;\n    background: rgba(255, 255, 255, 0.04);\n  }\n\n  .mobile-settings-stats strong {\n    color: var(--tg-text);\n    font-size: 22px;\n  }\n\n  .mobile-settings-stats em {\n    color: var(--tg-muted);\n    font-style: normal;\n    font-size: 13px;\n  }\n\n  .chats-page[data-chat-theme=\"light\"] .mobile-settings-profile,\n  .chats-page[data-chat-theme=\"light\"] .mobile-settings-group,\n  .chats-page[data-chat-theme=\"light\"] .mobile-settings-note,\n  .chats-page[data-chat-theme=\"light\"] .mobile-settings-toggle-row,\n  .chats-page[data-chat-theme=\"light\"] .mobile-settings-choice,\n  .chats-page[data-chat-theme=\"light\"] .mobile-settings-stats span {\n    background: rgba(255, 255, 255, 0.72);\n  }\n\n  .chats-page[data-chat-theme=\"light\"] .mobile-settings-row + .mobile-settings-row {\n    border-top-color: rgba(23, 33, 43, 0.08);\n  }\n\n  .message-action-sheet {\n    place-items: end center;\n    padding-bottom: calc(24px + env(safe-area-inset-bottom));\n  }\n\n  .message-action-sheet .message-action-preview {\n    justify-self: start;\n    margin-left: 8px;\n  }\n\n  .mobile-edit-screen {\n    position: fixed;\n    inset: 0;\n    z-index: 3600;\n    display: grid;\n    grid-template-rows: 56px minmax(0, 1fr);\n    background: var(--tg-bg);\n    color: var(--tg-text);\n  }\n\n  .is-editing-message .composer {\n    display: none;\n  }\n\n  .mobile-edit-screen header {\n    display: grid;\n    grid-template-columns: 48px 1fr 48px;\n    align-items: center;\n    border-bottom: 1px solid var(--tg-border);\n    background: var(--tg-header);\n  }\n\n  .mobile-edit-screen header button {\n    border: 0;\n    color: var(--tg-accent);\n    background: transparent;\n  }\n\n  .mobile-edit-screen header strong {\n    text-align: center;\n  }\n\n  .mobile-edit-body {\n    display: grid;\n    align-content: start;\n    gap: 22px;\n    padding: 22px 14px;\n  }\n\n  .mobile-edit-body p {\n    margin: 0;\n    font-size: 16px;\n    line-height: 1.35;\n  }\n\n  .mobile-edit-input {\n    border: 1px solid var(--tg-soft-border);\n    border-radius: 14px;\n    display: grid;\n    grid-template-columns: 28px minmax(0, 1fr) 38px;\n    align-items: center;\n    gap: 8px;\n    padding: 8px;\n    background: var(--tg-input);\n  }\n\n  .mobile-edit-input textarea {\n    border: 0;\n    resize: none;\n    outline: none;\n    color: var(--tg-text);\n    background: transparent;\n    font: inherit;\n  }\n\n  .mobile-edit-input button {\n    width: 34px;\n    height: 34px;\n    border: 0;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    background: var(--tg-accent);\n  }\n}\n\n/* Loading polish */\n.chats-page {\n  --tg-skeleton-base: rgba(255, 255, 255, 0.07);\n  --tg-skeleton-peak: rgba(255, 255, 255, 0.16);\n}\n\n.chats-page[data-chat-theme=\"light\"] {\n  --tg-skeleton-base: rgba(23, 33, 43, 0.08);\n  --tg-skeleton-peak: rgba(255, 255, 255, 0.72);\n}\n\n.chat-list-skeleton {\n  display: grid;\n  gap: 0;\n  padding: 2px 0;\n}\n\n.chat-list-status {\n  margin: 8px 12px;\n  border: 1px solid rgba(42, 171, 238, 0.16);\n  border-radius: 14px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 10px 10px 12px;\n  color: var(--tg-muted);\n  background: rgba(42, 171, 238, 0.08);\n  font-size: 13px;\n  animation: skeleton-row-in 0.24s ease both;\n}\n\n.chat-list-status span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-list-status button {\n  border: 0;\n  border-radius: 999px;\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, 0.14);\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.messages-status {\n  align-self: center;\n  width: min(440px, 92%);\n  margin: 8px 0;\n  background: rgba(23, 33, 43, 0.78);\n  backdrop-filter: blur(12px);\n}\n\n.chats-page[data-chat-theme=\"light\"] .messages-status {\n  background: rgba(255, 255, 255, 0.82);\n}\n\n.chat-skeleton-row {\n  position: relative;\n  min-height: 72px;\n  display: grid;\n  grid-template-columns: 54px minmax(0, 1fr) 42px;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  overflow: hidden;\n  animation: skeleton-row-in 0.28s ease both;\n}\n\n.chat-skeleton-row::after {\n  content: \"\";\n  position: absolute;\n  left: 76px;\n  right: 0;\n  bottom: 0;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.045);\n}\n\n.chats-page[data-chat-theme=\"light\"] .chat-skeleton-row::after {\n  background: rgba(23, 33, 43, 0.08);\n}\n\n.chat-skeleton-row:nth-child(2) { animation-delay: 0.03s; }\n.chat-skeleton-row:nth-child(3) { animation-delay: 0.06s; }\n.chat-skeleton-row:nth-child(4) { animation-delay: 0.09s; }\n.chat-skeleton-row:nth-child(5) { animation-delay: 0.12s; }\n.chat-skeleton-row:nth-child(6) { animation-delay: 0.15s; }\n.chat-skeleton-row:nth-child(7) { animation-delay: 0.18s; }\n.chat-skeleton-row:nth-child(8) { animation-delay: 0.21s; }\n\n.skeleton-circle,\n.skeleton-line,\n.skeleton-date-pill,\n.message-skeleton-bubble {\n  position: relative;\n  overflow: hidden;\n  background: var(--tg-skeleton-base);\n}\n\n.skeleton-circle::after,\n.skeleton-line::after,\n.skeleton-date-pill::after,\n.message-skeleton-bubble::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent);\n  animation: skeleton-shimmer 1.25s ease-in-out infinite;\n}\n\n.skeleton-circle {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n}\n\n.skeleton-lines {\n  min-width: 0;\n  display: grid;\n  gap: 9px;\n}\n\n.skeleton-line {\n  display: block;\n  height: 11px;\n  border-radius: 999px;\n}\n\n.skeleton-line.title {\n  width: min(170px, 78%);\n  height: 13px;\n}\n\n.skeleton-line.preview {\n  width: min(230px, 92%);\n}\n\n.skeleton-line.time {\n  width: 38px;\n  height: 9px;\n  align-self: start;\n  margin-top: 10px;\n}\n\n.message-list-skeleton {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 4px 0 16px;\n}\n\n.skeleton-date-pill {\n  align-self: center;\n  width: 86px;\n  height: 26px;\n  border-radius: 999px;\n  margin: 6px 0 8px;\n  background: rgba(109, 127, 144, 0.32);\n}\n\n.message-skeleton-bubble {\n  width: min(360px, 68%);\n  min-height: 56px;\n  border-radius: 13px;\n  display: grid;\n  align-content: center;\n  gap: 8px;\n  padding: 12px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);\n  animation: skeleton-bubble-in 0.28s cubic-bezier(.2, .8, .2, 1) both;\n}\n\n.message-skeleton-bubble.other {\n  align-self: flex-start;\n  border-bottom-left-radius: 4px;\n}\n\n.message-skeleton-bubble.mine {\n  align-self: flex-end;\n  border-bottom-right-radius: 4px;\n  background: rgba(42, 171, 238, 0.16);\n}\n\n.chats-page[data-chat-theme=\"light\"] .message-skeleton-bubble.mine {\n  background: rgba(91, 185, 74, 0.16);\n}\n\n.message-skeleton-bubble.wide {\n  width: min(470px, 78%);\n}\n\n.message-skeleton-bubble:nth-child(2) { animation-delay: 0.02s; }\n.message-skeleton-bubble:nth-child(3) { animation-delay: 0.06s; }\n.message-skeleton-bubble:nth-child(4) { animation-delay: 0.1s; }\n.message-skeleton-bubble:nth-child(5) { animation-delay: 0.14s; }\n.message-skeleton-bubble:nth-child(6) { animation-delay: 0.18s; }\n.message-skeleton-bubble:nth-child(7) { animation-delay: 0.22s; }\n.message-skeleton-bubble:nth-child(8) { animation-delay: 0.26s; }\n\n.message-line {\n  width: 92%;\n  height: 10px;\n}\n\n.message-line.short {\n  width: 54%;\n}\n\n.chats-page .chat-row {\n  animation: chat-row-in 0.22s ease both;\n}\n\n.chats-page .message-bubble {\n  transform-origin: left bottom;\n  animation: telegram-message-in 0.2s cubic-bezier(.18, .9, .22, 1.12) both;\n}\n\n.chats-page .message-bubble.mine {\n  transform-origin: right bottom;\n}\n\n.chats-page .messages-date-divider {\n  animation: date-pill-in 0.2s ease both;\n}\n\n@keyframes skeleton-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes skeleton-row-in {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes skeleton-bubble-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes chat-row-in {\n  from {\n    opacity: 0;\n    transform: translateX(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes telegram-message-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes date-pill-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .skeleton-circle::after,\n  .skeleton-line::after,\n  .skeleton-date-pill::after,\n  .message-skeleton-bubble::after,\n  .chat-skeleton-row,\n  .message-skeleton-bubble,\n  .chats-page .chat-row,\n  .chats-page .message-bubble,\n  .chats-page .messages-date-divider {\n    animation: none;\n  }\n}\n\n/* Final mobile native polish */\n@media (max-width: 760px) {\n  .chats-page {\n    position: fixed;\n    inset: 0;\n    width: 100%;\n    height: 100dvh;\n    min-height: 100dvh;\n    overflow: hidden;\n    touch-action: manipulation;\n  }\n\n  .chats-page .chats-shell {\n    height: 100dvh;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .chats-page .chats-sidebar {\n    height: 100dvh;\n    min-height: 0;\n    display: grid;\n    grid-template-rows: 54px minmax(0, 1fr) calc(58px + env(safe-area-inset-bottom));\n  }\n\n  .chats-page .chats-sidebar-head {\n    height: 54px;\n    min-height: 54px;\n    display: grid;\n    grid-template-columns: 36px minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 8px;\n    padding: 0 10px;\n  }\n\n  .chats-page .chats-sidebar-title {\n    justify-self: start;\n    font-size: 18px;\n    letter-spacing: 0;\n  }\n\n  .chats-page .chats-sidebar-actions {\n    gap: 2px;\n  }\n\n  .chats-page .chats-round-action,\n  .chats-page .chats-icon {\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n    padding: 0;\n  }\n\n  .chats-page .chat-list-screen {\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .chats-page .chats-search-box {\n    padding: 8px 10px 6px;\n  }\n\n  .chats-page .chats-search-box .chat-icon {\n    left: 22px;\n    width: 17px;\n    height: 17px;\n  }\n\n  .chats-page .chats-search {\n    height: 34px;\n    border-radius: 17px;\n    padding-left: 36px;\n    font-size: 15px;\n  }\n\n  .chats-page .chats-filter-row {\n    gap: 8px;\n    padding: 4px 10px 8px;\n  }\n\n  .chats-page .chat-filter-chip {\n    flex: 0 0 auto;\n    min-height: 28px;\n    padding: 0 10px;\n    font-size: 13px;\n  }\n\n  .chats-page .chats-list {\n    min-height: 0;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n  }\n\n  .chats-page .chat-row {\n    min-height: 72px;\n    grid-template-columns: 50px minmax(0, 1fr);\n    gap: 10px;\n    padding: 8px 10px;\n  }\n\n  .chats-page .chat-row::after {\n    left: 70px;\n  }\n\n  .chats-page .chat-avatar-wrap,\n  .chats-page .chat-avatar {\n    width: 50px;\n    height: 50px;\n  }\n\n  .chats-page .chat-row-title {\n    font-size: 16px;\n  }\n\n  .chats-page .chat-row-preview {\n    font-size: 14px;\n  }\n\n  .chats-page .chat-row-time {\n    font-size: 12px;\n  }\n\n  .chats-page .mobile-tabbar {\n    height: calc(58px + env(safe-area-inset-bottom));\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  .chats-page .chats-shell:not(.mobile-dialog-open) .chats-main {\n    display: none !important;\n  }\n\n  .chats-page .chats-shell.mobile-dialog-open .chats-sidebar {\n    display: none !important;\n  }\n\n  .chats-page .chats-main {\n    height: 100dvh;\n    min-height: 0;\n    grid-template-rows: 56px auto minmax(0, 1fr) auto;\n  }\n\n  .chats-page .chats-header {\n    height: 56px;\n    min-height: 56px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 0 8px;\n  }\n\n  .chats-page .chats-header-main {\n    flex: 1 1 auto;\n    min-width: 0;\n    height: 56px;\n    gap: 8px;\n  }\n\n  .chats-page .chat-mobile-back {\n    display: inline-flex !important;\n    flex: 0 0 36px;\n    margin-left: 0;\n  }\n\n  .chats-page .chats-header .chat-avatar-wrap.large,\n  .chats-page .chats-header .chat-avatar.large {\n    width: 38px;\n    height: 38px;\n    font-size: 14px;\n  }\n\n  .chats-page .chats-header-name {\n    font-size: 16px;\n  }\n\n  .chats-page .chats-header-meta {\n    font-size: 12px;\n  }\n\n  .chats-page .chats-header-actions {\n    position: static;\n    flex: 0 0 auto;\n    width: auto;\n    height: 36px;\n    display: flex;\n    align-self: center;\n  }\n\n  .chats-page .chats-header-actions .chats-icon {\n    display: none;\n  }\n\n  .chats-page .chats-header-actions .chats-icon:first-child,\n  .chats-page .chats-header-actions .chats-icon:nth-child(2) {\n    display: inline-flex;\n  }\n\n  .chats-page .messages-panel {\n    min-height: 0;\n    padding: 10px 8px 8px;\n    overscroll-behavior: contain;\n  }\n\n  .chats-page .message-bubble {\n    max-width: 84%;\n    padding: 6px 8px 4px;\n  }\n\n  .chats-page .message-bubble:has(.attachment-card.voice) {\n    max-width: min(320px, 86%);\n  }\n\n  .chats-page .attachment-card.voice {\n    width: min(260px, 66vw);\n    height: 34px;\n    border-radius: 17px;\n  }\n\n  .chats-page .message-text {\n    font-size: 15px;\n    line-height: 1.35;\n  }\n\n  .chats-page .composer {\n    min-height: auto;\n    grid-template-columns: 38px minmax(0, 1fr) 38px 44px;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 8px calc(7px + env(safe-area-inset-bottom));\n  }\n\n  .chats-page .composer > .chats-icon:first-of-type {\n    grid-column: 1;\n    grid-row: 1;\n  }\n\n  .chats-page .composer > .chats-icon:nth-of-type(2) {\n    grid-column: 3;\n    grid-row: 1;\n  }\n\n  .chats-page .composer-input {\n    grid-column: 2;\n    grid-row: 1;\n    min-height: 40px;\n    max-height: 112px;\n    padding: 10px 14px;\n    font-size: 16px;\n  }\n\n  .chats-page .composer-send {\n    grid-column: 4;\n    grid-row: 1;\n    width: 44px;\n    height: 44px;\n    border-radius: 16px;\n  }\n\n  .chats-page .composer:has(.composer-preview),\n  .chats-page .composer:has(.composer-attachments),\n  .chats-page .composer:has(.emoji-panel) {\n    grid-template-rows: auto auto;\n  }\n\n  .chats-page .composer:has(.composer-preview) > .chats-icon,\n  .chats-page .composer:has(.composer-attachments) > .chats-icon,\n  .chats-page .composer:has(.emoji-panel) > .chats-icon,\n  .chats-page .composer:has(.composer-preview) .composer-input,\n  .chats-page .composer:has(.composer-attachments) .composer-input,\n  .chats-page .composer:has(.emoji-panel) .composer-input,\n  .chats-page .composer:has(.composer-preview) .composer-send,\n  .chats-page .composer:has(.composer-attachments) .composer-send,\n  .chats-page .composer:has(.emoji-panel) .composer-send {\n    grid-row: 2;\n  }\n\n  .chats-page .composer-preview,\n  .chats-page .composer-attachments,\n  .chats-page .emoji-panel {\n    grid-row: 1;\n  }\n}\n\n/* Native mobile polish: swipe reply, Telegram-like tails and cleaner touch menus */\n.chats-page .message-bubble {\n  position: relative;\n  transform: translateX(var(--swipe-x, 0));\n  transition: transform 0.18s cubic-bezier(.2, .8, .2, 1), box-shadow 0.18s ease, filter 0.18s ease;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.chats-page .message-bubble.is-swiping {\n  z-index: 5;\n  transition: none;\n  filter: brightness(1.04);\n}\n\n.chats-page .message-bubble.swipe-ready {\n  box-shadow: 0 4px 16px rgba(42, 171, 238, 0.22);\n}\n\n.message-swipe-reply {\n  position: absolute;\n  top: 50%;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  color: #fff;\n  background: var(--tg-accent);\n  box-shadow: 0 4px 14px rgba(42, 171, 238, 0.32);\n  pointer-events: none;\n  transform: translateY(-50%) scale(.72);\n  transition: opacity 0.12s ease, transform 0.12s ease;\n}\n\n.message-swipe-reply .chat-icon {\n  width: 18px;\n  height: 18px;\n}\n\n:where(.chats-page) .message-bubble.other .message-swipe-reply {\n  left: -44px;\n}\n\n:where(.chats-page) .message-bubble.mine .message-swipe-reply {\n  right: -44px;\n}\n\n:where(.chats-page) .message-bubble.is-swiping .message-swipe-reply {\n  opacity: .82;\n  transform: translateY(-50%) scale(1);\n}\n\n:where(.chats-page) .message-bubble.swipe-ready .message-swipe-reply {\n  opacity: 1;\n}\n\n.chats-page .message-bubble.starts-group {\n  margin-top: 7px;\n}\n\n.chats-page .message-bubble.grouped-prev {\n  margin-top: 2px;\n}\n\n.chats-page .message-bubble.grouped-prev.other {\n  border-top-left-radius: 8px;\n}\n\n.chats-page .message-bubble.grouped-prev.mine {\n  border-top-right-radius: 8px;\n}\n\n.chats-page .message-bubble.grouped-next.other {\n  border-bottom-left-radius: 8px;\n}\n\n.chats-page .message-bubble.grouped-next.mine {\n  border-bottom-right-radius: 8px;\n}\n\n.chats-page .message-bubble.ends-group.other::after,\n.chats-page .message-bubble.ends-group.mine::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  width: 10px;\n  height: 12px;\n  pointer-events: none;\n}\n\n.chats-page .message-bubble.ends-group.other::after {\n  left: -5px;\n  border-bottom-right-radius: 10px;\n  background: var(--tg-bubble-other);\n}\n\n.chats-page .message-bubble.ends-group.mine::after {\n  right: -5px;\n  border-bottom-left-radius: 10px;\n  background: var(--tg-bubble-mine);\n}\n\n.chats-page .message-more {\n  opacity: 0;\n  transform: scale(.86);\n  transition: opacity 0.14s ease, transform 0.14s ease, background 0.14s ease;\n}\n\n.chats-page .message-bubble:hover .message-more,\n.chats-page .message-more:focus-visible {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.message-action-sheet {\n  background: rgba(0, 0, 0, 0.62);\n}\n\n.message-action-sheet .message-action-preview {\n  animation: action-preview-in 0.16s cubic-bezier(.2, .8, .2, 1) both;\n}\n\n.message-action-sheet .chat-sheet-card {\n  animation: action-card-in 0.18s cubic-bezier(.2, .8, .2, 1) both;\n}\n\n.message-action-sheet .reaction-row button {\n  border-radius: 999px;\n  transition: transform 0.12s ease, background 0.12s ease;\n}\n\n.message-action-sheet .reaction-row button:active {\n  transform: scale(.88);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.attachment-sheet-grid button {\n  transition: transform 0.14s ease, opacity 0.14s ease;\n}\n\n.attachment-sheet-grid button:active {\n  transform: scale(.94);\n}\n\n.attachment-sheet-grid button.is-disabled {\n  opacity: .54;\n}\n\n.attachment-sheet-grid button.is-disabled .attachment-sheet-icon {\n  filter: grayscale(.2);\n}\n\n@keyframes action-preview-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes action-card-in {\n  from {\n    opacity: 0;\n    transform: translateY(14px) scale(.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 760px) {\n  .chats-page .message-more {\n    display: none;\n  }\n\n  .chats-page .message-bubble {\n    user-select: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .chats-page .message-bubble,\n  .message-swipe-reply,\n  .message-action-sheet .message-action-preview,\n  .message-action-sheet .chat-sheet-card,\n  .attachment-sheet-grid button {\n    animation: none;\n    transition: none;\n  }\n}\n\n/* Telegram Web typography and text color calibration */\n.chats-page {\n  --tg-font-main: \"Roboto\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", Arial, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Noto Color Emoji\", sans-serif;\n  --tg-font-mono: \"Roboto Mono\", \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  --tg-text: #f5f5f5;\n  --tg-text-strong: #ffffff;\n  --tg-muted: #a8b3bd;\n  --tg-muted-soft: #7f91a4;\n  --tg-meta: #8ea2b3;\n  --tg-accent: #6ab2f2;\n  --tg-accent-press: #5aa9ee;\n  --tg-danger: #ff595a;\n  --tg-link: #6ab2f2;\n  --tg-service-text: #d5dee7;\n  font-family: var(--tg-font-main);\n  color: var(--tg-text);\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n\n.chats-page[data-chat-theme=\"light\"] {\n  --tg-text: #222222;\n  --tg-text-strong: #000000;\n  --tg-muted: #707579;\n  --tg-muted-soft: #8a969f;\n  --tg-meta: #8c9aa5;\n  --tg-accent: #3390ec;\n  --tg-accent-press: #2481cc;\n  --tg-danger: #df3f40;\n  --tg-link: #168acd;\n  --tg-service-text: #ffffff;\n  color: var(--tg-text);\n}\n\n.chats-page,\n.chats-page button,\n.chats-page input,\n.chats-page textarea,\n.chats-page select {\n  font-family: var(--tg-font-main);\n}\n\n.chats-page .chats-sidebar-title,\n.chats-page .chats-header-name,\n.chats-page .chat-row-title,\n.chats-page .mobile-settings-title span,\n.chats-page .mobile-settings-profile strong,\n.chats-page .chat-settings-head strong {\n  color: var(--tg-text-strong);\n  font-weight: 500;\n  letter-spacing: 0;\n}\n\n.chats-page .chats-sidebar-title {\n  font-size: 20px;\n  line-height: 1.2;\n}\n\n.chats-page .chats-header-name {\n  font-size: 16px;\n  line-height: 1.2;\n}\n\n.chats-page .chat-row-title {\n  font-size: 16px;\n  line-height: 1.2;\n}\n\n.chats-page .chat-row-preview,\n.chats-page .chat-row-meta,\n.chats-page .chat-row-time,\n.chats-page .chats-header-meta,\n.chats-page .mobile-tabbar button,\n.chats-page .mobile-settings-row em,\n.chats-page .mobile-settings-row b,\n.chats-page .mobile-settings-profile em,\n.chats-page .chat-settings-head em,\n.chats-page .chat-settings-toggle-row em,\n.chats-page .chat-settings-note,\n.chats-page .composer-input::placeholder {\n  color: var(--tg-muted);\n  font-weight: 400;\n  letter-spacing: 0;\n}\n\n.chats-page .chat-row-preview {\n  font-size: 14px;\n  line-height: 1.25;\n}\n\n.chats-page .chat-row-time {\n  font-size: 12px;\n}\n\n.chats-page .chats-header-meta {\n  font-size: 14px;\n}\n\n.chats-page .chats-header-meta.typing,\n.chats-page .chat-filter-chip.active,\n.chats-page .mobile-search-tabs button.active,\n.chats-page .mobile-tabbar button.active,\n.chats-page .chats-icon,\n.chats-page .chats-round-action,\n.chats-page .chat-mobile-back,\n.chats-page .mobile-settings-back,\n.chats-page .message-text a,\n.chats-page .link-preview-card,\n.chats-page .read-indicator {\n  color: var(--tg-accent);\n}\n\n.chats-page .message-text {\n  color: var(--tg-text);\n  font-size: 16px;\n  line-height: 1.3125;\n  font-weight: 400;\n  letter-spacing: 0;\n}\n\n.chats-page .message-text.deleted {\n  color: var(--tg-muted);\n}\n\n.chats-page .message-meta {\n  color: var(--tg-meta);\n  font-size: 12px;\n  line-height: 1.1;\n  font-weight: 400;\n  letter-spacing: 0;\n}\n\n.chats-page .message-bubble.mine .message-meta {\n  color: #93bdd8;\n}\n\n.chats-page[data-chat-theme=\"light\"] .message-bubble.mine .message-meta {\n  color: #5c8f45;\n}\n\n.chats-page .messages-date-divider span,\n.chats-page .chats-empty,\n.chats-page .chat-list-status {\n  color: var(--tg-service-text);\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.chats-page[data-chat-theme=\"light\"] .chats-empty,\n.chats-page[data-chat-theme=\"light\"] .chat-list-status {\n  color: var(--tg-muted);\n}\n\n.chats-page .composer-input {\n  color: var(--tg-text);\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 400;\n}\n\n.chats-page .composer-preview strong,\n.chats-page .composer-attachment-chip strong,\n.chats-page .message-reply-preview strong,\n.chats-page .pinned-message-copy strong {\n  color: var(--tg-accent);\n  font-weight: 500;\n}\n\n.chats-page .composer-preview span,\n.chats-page .composer-attachment-chip em,\n.chats-page .message-reply-preview span,\n.chats-page .message-forwarded,\n.chats-page .pinned-message-copy span {\n  color: var(--tg-muted);\n  font-weight: 400;\n}\n\n.chats-page .message-action-sheet .chat-sheet-card > button,\n.chats-page .attachment-sheet-grid strong,\n.chats-page .attachment-sheet-cancel,\n.chats-page .chat-settings-choice,\n.chats-page .mobile-settings-choice,\n.chats-page .chat-settings-row strong,\n.chats-page .mobile-settings-row strong {\n  font-weight: 400;\n  letter-spacing: 0;\n}\n\n.chats-page .message-action-sheet .chat-sheet-card > button {\n  color: #ffffff;\n  font-size: 16px;\n}\n\n.chats-page .message-action-sheet .chat-sheet-card > button.danger {\n  color: var(--tg-danger);\n}\n\n.chats-page .message-text code,\n.chats-page .message-text pre {\n  font-family: var(--tg-font-mono);\n}\n\n/* Telegram-like chat wallpaper */\n.chats-page {\n  --tg-wallpaper-base: #0f1d2a;\n  --tg-wallpaper-size: 112px 112px;\n  --tg-wallpaper-vignette:\n    radial-gradient(circle at 18% 0%, rgba(42, 171, 238, 0.08), transparent 34%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.015), rgba(0, 0, 0, 0.08));\n  --tg-wallpaper-pattern: url(\"data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2796%27%20height%3D%2796%27%20viewBox%3D%270%200%2096%2096%27%3E%3Cg%20fill%3D%27none%27%20stroke%3D%27%23ffffff%27%20stroke-opacity%3D%27.052%27%20stroke-width%3D%271.05%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%3E%3Cpath%20d%3D%27M10%2015h12l5%205v16H10z%27%2F%3E%3Cpath%20d%3D%27M22%2015v6h6%27%2F%3E%3Cpath%20d%3D%27M14%2027h10M14%2032h7%27%2F%3E%3Cpath%20d%3D%27M56%209l4%209%2010%201-7%207%202%2010-9-5-9%205%202-10-7-7%2010-1z%27%2F%3E%3Ccircle%20cx%3D%2780%27%20cy%3D%2726%27%20r%3D%278%27%2F%3E%3Cpath%20d%3D%27M76%2026h8M80%2022v8%27%2F%3E%3Cpath%20d%3D%27M25%2061c4-8%2014-5%2012%204-1%207-11%2012-12%2019-1-7-11-12-12-19-2-9%208-12%2012-4z%27%2F%3E%3Cpath%20d%3D%27M67%2062l10%205%2010-5-10-5zM67%2062v12l10%205%2010-5V62%27%2F%3E%3Cpath%20d%3D%27M41%2084c7-8%2016-8%2023%200M47%2077c3-4%209-4%2012%200%27%2F%3E%3Cpath%20d%3D%27M7%2082h12M13%2076v12%27%2F%3E%3Ccircle%20cx%3D%2785%27%20cy%3D%2782%27%20r%3D%275%27%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n\n.chats-page[data-chat-theme=\"light\"] {\n  --tg-wallpaper-base: #d9e6f2;\n  --tg-wallpaper-size: 112px 112px;\n  --tg-wallpaper-vignette:\n    radial-gradient(circle at 22% 0%, rgba(51, 144, 236, 0.12), transparent 34%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.42), rgba(210, 224, 237, 0.14));\n  --tg-wallpaper-pattern: url(\"data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2796%27%20height%3D%2796%27%20viewBox%3D%270%200%2096%2096%27%3E%3Cg%20fill%3D%27none%27%20stroke%3D%27%236f8493%27%20stroke-opacity%3D%27.12%27%20stroke-width%3D%271.05%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%3E%3Cpath%20d%3D%27M10%2015h12l5%205v16H10z%27%2F%3E%3Cpath%20d%3D%27M22%2015v6h6%27%2F%3E%3Cpath%20d%3D%27M14%2027h10M14%2032h7%27%2F%3E%3Cpath%20d%3D%27M56%209l4%209%2010%201-7%207%202%2010-9-5-9%205%202-10-7-7%2010-1z%27%2F%3E%3Ccircle%20cx%3D%2780%27%20cy%3D%2726%27%20r%3D%278%27%2F%3E%3Cpath%20d%3D%27M76%2026h8M80%2022v8%27%2F%3E%3Cpath%20d%3D%27M25%2061c4-8%2014-5%2012%204-1%207-11%2012-12%2019-1-7-11-12-12-19-2-9%208-12%2012-4z%27%2F%3E%3Cpath%20d%3D%27M67%2062l10%205%2010-5-10-5zM67%2062v12l10%205%2010-5V62%27%2F%3E%3Cpath%20d%3D%27M41%2084c7-8%2016-8%2023%200M47%2077c3-4%209-4%2012%200%27%2F%3E%3Cpath%20d%3D%27M7%2082h12M13%2076v12%27%2F%3E%3Ccircle%20cx%3D%2785%27%20cy%3D%2782%27%20r%3D%275%27%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n\n.chats-page .chats-main {\n  position: relative;\n  isolation: isolate;\n  background: var(--tg-wallpaper-base) !important;\n  overflow: hidden;\n}\n\n.chats-page .chats-main::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  background-color: var(--tg-wallpaper-base);\n  background-image: var(--tg-wallpaper-vignette);\n  background-repeat: no-repeat;\n  background-size: auto;\n  background-position: center top;\n}\n\n.chats-page .chats-header,\n.chats-page .pinned-message-bar,\n.chats-page .messages-panel,\n.chats-page .composer,\n.chats-page .jump-to-bottom {\n  position: relative;\n  z-index: 1;\n}\n\n.chats-page .messages-panel {\n  background-color: transparent !important;\n  background-image: var(--tg-wallpaper-pattern) !important;\n  background-repeat: repeat !important;\n  background-size: var(--tg-wallpaper-size) !important;\n  background-position: 12px 12px !important;\n}\n\n.chats-page .composer {\n  background: linear-gradient(180deg, rgba(15, 29, 42, 0), var(--tg-wallpaper-base) 22%) !important;\n}\n\n.chats-page[data-chat-theme=\"light\"] .composer {\n  background: linear-gradient(180deg, rgba(217, 230, 242, 0), rgba(217, 230, 242, 0.96) 22%) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
